import { computed as $, openBlock as a, createElementBlock as c, normalizeClass as T, renderSlot as x, createCommentVNode as A, ref as w, watch as h1, onBeforeUnmount as St, Fragment as t1, createTextVNode as D, toDisplayString as O, resolveComponent as _, createBlock as k, mergeProps as U, normalizeStyle as ke, createElementVNode as o, h as xe, withCtx as g, createVNode as b, resolveDirective as ne, withDirectives as S1, normalizeProps as D1, withModifiers as re, renderList as c1, createSlots as j1, guardReactiveProps as Ne, getCurrentInstance as en, onMounted as Lt, nextTick as O1, withKeys as Y1, vModelDynamic as tn, vShow as nn, Transition as rn, createStaticVNode as k1, resolveDynamicComponent as on } from "vue";
import { useDisplay as dn, useLocale as ln } from "vuetify";
const je = (e) => {
  window.document.title = e;
}, an = {
  beforeMount(e, { value: t }) {
    je(t);
  },
  updated(e, { value: t }) {
    je(t);
  }
}, M7 = an;
function sn(e, t) {
  const n = {
    fa: "app--farsi",
    tr: "app--tr",
    vi: "app--vi",
    th: "app--th"
  };
  Object.values(n).forEach((l) => e.classList.remove(l));
  const r = n[t];
  r && e.classList.add(r);
}
const Pe = (e) => {
  const t = window.document.documentElement;
  t.setAttribute("lang", e);
  const r = ["fa"].includes(e) ? "rtl" : "ltr";
  t.setAttribute("dir", r), sn(t, e);
}, k7 = {
  mounted(e, { value: t }) {
    Pe(t);
  },
  updated(e, { value: t }) {
    Pe(t);
  }
};
const u = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, l] of t)
    n[r] = l;
  return n;
}, cn = {
  name: "app-card",
  emits: ["click"],
  slots: ["header", "body", "footer"],
  props: {
    hover: {
      type: Boolean,
      default: !1
    },
    headerClasses: {
      type: String,
      default: ""
    },
    bodyClasses: {
      type: String,
      default: ""
    },
    footerClasses: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return { rootClasses: $(() => [
      "app-card d-flex flex-column w-100 h-100 rounded-xxl",
      { "app-card--hover": e.hover }
    ]) };
  }
};
function un(e, t, n, r, l, d) {
  return a(), c("div", {
    class: T(r.rootClasses),
    "aria-hidden": "true",
    onClick: t[0] || (t[0] = (i) => e.$emit("click"))
  }, [
    e.$slots.header ? (a(), c("div", {
      key: 0,
      class: T(n.headerClasses)
    }, [
      x(e.$slots, "header", {}, void 0, !0)
    ], 2)) : A("", !0),
    e.$slots.body ? (a(), c("div", {
      key: 1,
      class: T(n.bodyClasses)
    }, [
      x(e.$slots, "body", {}, void 0, !0)
    ], 2)) : A("", !0),
    e.$slots.footer ? (a(), c("div", {
      key: 2,
      class: T(n.footerClasses)
    }, [
      x(e.$slots, "footer", {}, void 0, !0)
    ], 2)) : A("", !0)
  ], 2);
}
const x7 = /* @__PURE__ */ u(cn, [["render", un], ["__scopeId", "data-v-90b39d77"]]), $e = (e) => e.toString().padStart(2, "0"), He = 3600, fn = (e, t = !1) => {
  const n = t ? Math.trunc(e / He) : 0, r = Math.trunc(t ? (e - n * He) / 60 : e / 60), l = Math.trunc(e % 60);
  return {
    hours: t ? $e(n) : void 0,
    minutes: $e(r),
    seconds: $e(l)
  };
}, pn = 1, $n = {
  name: "app-countdown-timer",
  props: {
    milliseconds: {
      type: Number,
      default: 0
    },
    className: {
      type: String,
      default: ""
    },
    withHours: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["finish"],
  setup(e, { emit: t }) {
    const n = w(0), r = w(null), l = $(() => {
      const { hours: i, minutes: s, seconds: f } = fn(n.value, e.withHours);
      return {
        hours: i,
        minutes: s,
        seconds: f
      };
    }), d = () => new Promise((i) => {
      n.value = Math.trunc(e.milliseconds / 1e3), r.value = setInterval(() => {
        n.value === pn && (clearInterval(r.value), i()), n.value -= 1;
      }, 1e3);
    });
    return h1(() => e.milliseconds, (i) => {
      clearInterval(r.value), i >= 1e3 && d().then(() => t("finish"));
    }, {
      immediate: !0
    }), St(() => clearInterval(r.value)), { counter: n, timer: l };
  }
}, Cn = { class: "d-inline" };
function _n(e, t, n, r, l, d) {
  return a(), c("div", Cn, [
    x(e.$slots, "default", {
      hours: r.timer.hours,
      minutes: r.timer.minutes,
      seconds: r.timer.seconds
    }, () => [
      n.withHours ? (a(), c(t1, { key: 0 }, [
        D(O(r.timer.hours) + ":" + O(r.timer.minutes) + ":" + O(r.timer.seconds), 1)
      ], 64)) : (a(), c(t1, { key: 1 }, [
        D(O(r.timer.minutes) + ":" + O(r.timer.seconds), 1)
      ], 64))
    ])
  ]);
}
const N7 = /* @__PURE__ */ u($n, [["render", _n]]), gn = {
  // https://vuetifyjs.com/en/components/dividers/
  name: "app-divider",
  props: ["inset", "vertical"]
};
function yn(e, t, n, r, l, d) {
  const i = _("v-divider");
  return a(), k(i, U(e.$props, {
    class: "app-divider",
    color: "gray text-gray-30"
  }), null, 16);
}
const mn = /* @__PURE__ */ u(gn, [["render", yn]]);
function hn(e) {
  return Array.isArray(e);
}
var F1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function L1(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var vn = typeof F1 == "object" && F1 && F1.Object === Object && F1, bn = vn, In = bn, Mn = typeof self == "object" && self && self.Object === Object && self, kn = In || Mn || Function("return this")(), At = kn, xn = At, Nn = xn.Symbol, wt = Nn, Re = wt, Ot = Object.prototype, Sn = Ot.hasOwnProperty, Ln = Ot.toString, w1 = Re ? Re.toStringTag : void 0;
function An(e) {
  var t = Sn.call(e, w1), n = e[w1];
  try {
    e[w1] = void 0;
    var r = !0;
  } catch {
  }
  var l = Ln.call(e);
  return r && (t ? e[w1] = n : delete e[w1]), l;
}
var wn = An, On = Object.prototype, Tn = On.toString;
function Dn(e) {
  return Tn.call(e);
}
var En = Dn, Be = wt, Vn = wn, jn = En, Pn = "[object Null]", Hn = "[object Undefined]", ze = Be ? Be.toStringTag : void 0;
function Rn(e) {
  return e == null ? e === void 0 ? Hn : Pn : ze && ze in Object(e) ? Vn(e) : jn(e);
}
var P1 = Rn, Bn = Array.isArray, zn = Bn;
function Fn(e) {
  return e != null && typeof e == "object";
}
var oe = Fn, Un = P1, Zn = zn, Gn = oe, Yn = "[object String]";
function Wn(e) {
  return typeof e == "string" || !Zn(e) && Gn(e) && Un(e) == Yn;
}
var Qn = Wn;
const Kn = /* @__PURE__ */ L1(Qn), K1 = Kn;
var Xn = P1, qn = oe, Jn = "[object Number]";
function e2(e) {
  return typeof e == "number" || qn(e) && Xn(e) == Jn;
}
var t2 = e2;
const n2 = /* @__PURE__ */ L1(t2), r2 = n2;
function o2(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var de = o2;
const d2 = /* @__PURE__ */ L1(de), X1 = d2;
var l2 = P1, a2 = de, i2 = "[object AsyncFunction]", s2 = "[object Function]", c2 = "[object GeneratorFunction]", u2 = "[object Proxy]";
function f2(e) {
  if (!a2(e))
    return !1;
  var t = l2(e);
  return t == s2 || t == c2 || t == i2 || t == u2;
}
var p2 = f2;
const $2 = /* @__PURE__ */ L1(p2), C2 = $2;
var _2 = P1, g2 = oe, y2 = "[object Boolean]";
function m2(e) {
  return e === !0 || e === !1 || g2(e) && _2(e) == y2;
}
var h2 = m2;
const v2 = /* @__PURE__ */ L1(h2), b2 = v2;
class h {
  static isIncludeValues(t = [], n) {
    const r = `prop value must be one of: ${t.join(", ")}`;
    return (l) => t.includes(l) || h._logError(n, r);
  }
  static isArrayOf(t) {
    const n = "prop value must be an array", r = (d, i, s) => hn(i) && i.every(d) || h._logError(t, s), l = (d) => ({
      check: h._getCheckByType(d),
      errorMsg: h._getErrorMsgByType(d, n)
    });
    return {
      num(d) {
        const { check: i, errorMsg: s } = l("num");
        return r(i, d, s);
      },
      str(d) {
        const { check: i, errorMsg: s } = l("str");
        return r(i, d, s);
      },
      obj(d) {
        const { check: i, errorMsg: s } = l("obj");
        return r(i, d, s);
      },
      fn(d) {
        const { check: i, errorMsg: s } = l("fn");
        return r(i, d, s);
      },
      bool(d) {
        const { check: i, errorMsg: s } = l("bool");
        return r(i, d, s);
      }
    };
  }
  static isArrayOfOneOf(t = [], n) {
    const r = "prop value must be an array of one of types:";
    return (l) => l.reduce((d, i) => [
      ...d,
      t.map((s) => h._getCheckByType(s)(i)).some((s) => s)
    ], []).every((d) => d) || h._logError(n, `${r} ${t.join(", ")}`);
  }
  static isInstanceOf(t, n) {
    const r = `prop value must be the instance of ${t.constructor.name}`;
    return (l) => l instanceof t || h._logError(n, r);
  }
  static _getCheckByType(t) {
    const n = {
      str: K1,
      num: r2,
      obj: X1,
      fn: C2,
      bool: b2
    };
    return (n == null ? void 0 : n[t]) || n.str;
  }
  static _getErrorMsgByType(t, n) {
    const r = {
      str: "of strings",
      num: "of numbers",
      obj: "of objects",
      fn: "of functions",
      bool: "of boolean"
    }, l = (r == null ? void 0 : r[t]) || r.str;
    return `${n} ${l}`;
  }
  static _logError(t, n) {
    console.error(`${t}: ${n}`);
  }
}
const M = {
  XS: "xs",
  S: "s",
  M: "m",
  L: "l",
  XL: "xl",
  XXL: "xxl"
}, n1 = [
  "account-multiple-outline",
  "arrow-big-down",
  "arrow-big-left",
  "arrow-big-right",
  "arrow-big-up",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-small-down",
  "arrow-small-up",
  "arrow-top-right",
  "arrow-up",
  "bank",
  "block",
  "business-chart",
  "call",
  "card-in",
  "chart-box-outline",
  "check-circle-fill",
  "check-circle",
  "check",
  "checkbox-checked",
  "checkbox-indeterminate",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "close-circle-outline",
  "close",
  "content-copy",
  "copy",
  "coupon",
  "credit-card-perigon",
  "credit-card-withdraw",
  "delimiter-slider",
  "deposit-gold",
  "deposit",
  "discount",
  "document",
  "dollar-gold",
  "dollar-payments-conversion",
  "dollar",
  "download",
  "edit-gold",
  "edit",
  "education",
  "email",
  "error-outline",
  "essential-copy",
  "exit",
  "eye-off",
  "eye",
  "facebook",
  "file-outline",
  "file",
  "gift-box",
  "gift-solid",
  "grid",
  "group",
  "handshake-outline",
  "help-circle",
  "home",
  "house-gold",
  "house",
  "info-outline",
  "info-solid",
  "instagram",
  "invoice-dollar",
  "language",
  "letter",
  "lightning",
  "link-out",
  "link-share",
  "linkedin",
  "list-bulleted",
  "logout",
  "magnify",
  "messages-chat",
  "minus-circle",
  "minus",
  "money-wallet-solid",
  "money-wallet",
  "move",
  "open-in-new",
  "password-key",
  "password",
  "pause-circle",
  "payment-method",
  "percent",
  "phone-call",
  "phone",
  "plus-circle",
  "plus",
  "portfolio",
  "products-chart",
  "pulse",
  "question",
  "refresh",
  "retry",
  "reward-cup",
  "rocket",
  "search",
  "security-lock",
  "settings-alt-gold",
  "settings-alt",
  "settings",
  "shield-keyhole",
  "shield-lock",
  "shield",
  "single-user",
  "square-chart",
  "square-check",
  "square",
  "star",
  "suitcase-portfolio",
  "target-goal",
  "telegram",
  "tick-big",
  "tick-circle",
  "time-circle",
  "time-clock",
  "tools-settings",
  "trade-gold",
  "trade",
  "trading-gold",
  "trading",
  "transaction-gold",
  "transaction",
  "transfer-gold",
  "transfer",
  "trashcan",
  "tune",
  "user",
  "variant",
  "viber",
  "visibility-off",
  "visibility-on",
  "warning-circle",
  "warning-outline",
  "warning-triangle",
  "whatsapp",
  "withdrawal-gold",
  "withdrawal",
  "work-outline",
  "youtube",
  "chat-2-desk",
  "union",
  "gold-medal"
], C = {
  PRIMARY: "primary",
  ERROR: "error",
  SUCCESS: "success",
  WARNING: "warning",
  WHITE: "white",
  BLACK: "black",
  GRAY: "gray",
  LINK: "link",
  TRANSPARENT: "transparent"
}, v1 = (e) => {
  const [t] = e.split("-", 2);
  return h.isIncludeValues(Object.values(C), "color")(t);
}, I2 = {
  // https://vuetifyjs.com/en/components/icons/
  name: "app-icon",
  props: {
    icon: {
      type: String,
      validator: h.isIncludeValues(n1, "icon"),
      required: !0
    },
    color: {
      type: String,
      validator: v1,
      default: "gray-80"
    },
    size: {
      type: String,
      validator: h.isIncludeValues(Object.values(M), "size"),
      default: M.M
    }
  },
  computed: {
    interpretedSize() {
      return {
        [M.XS]: 12,
        [M.S]: 16,
        [M.M]: 20,
        [M.L]: 24,
        [M.XL]: 30,
        [M.XXL]: 40
      }[this.size];
    }
  }
};
function M2(e, t, n, r, l, d) {
  const i = _("v-icon");
  return a(), k(i, U({
    class: "app-icon",
    color: n.color,
    size: d.interpretedSize,
    icon: n.icon,
    tag: "svg"
  }, e.$attrs), null, 16, ["color", "size", "icon"]);
}
const G = /* @__PURE__ */ u(I2, [["render", M2]]), H = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary",
  CAUTION: "caution",
  SUCCESS: "success"
}, U1 = {
  LEFT: "left",
  RIGHT: "right"
}, I = (e, t) => t ? `${e}-${t}` : e;
function H1(e) {
  return {
    linkProps: $(() => e.href || e.to ? {
      href: e.href,
      to: e.to,
      exact: e.exact,
      target: e.target
    } : {})
  };
}
const k2 = {
  name: "app-spinner-dot",
  props: {
    size: {
      type: String,
      default: M.S,
      validator: h.isIncludeValues([M.S, M.M], "size")
    }
  },
  computed: {
    interpretedSize() {
      const e = {
        [M.XS]: 10,
        [M.S]: 16,
        [M.M]: 26
      };
      return e[this.size] || e.xs;
    },
    spinnerSize() {
      return `--spinner-size: ${this.interpretedSize}px`;
    }
  }
};
function x2(e, t, n, r, l, d) {
  return a(), c("div", {
    class: "loader",
    style: ke(d.spinnerSize)
  }, t[0] || (t[0] = [
    o("span", { class: "loader__dot loader__dot--1" }, null, -1),
    o("span", { class: "loader__dot loader__dot--2" }, null, -1),
    o("span", { class: "loader__dot loader__dot--3" }, null, -1),
    o("span", { class: "loader__dot loader__dot--4" }, null, -1)
  ]), 4);
}
const le = /* @__PURE__ */ u(k2, [["render", x2], ["__scopeId", "data-v-42cbe6cb"]]), Z = {
  BODY_1: "body-1",
  BODY_2: "body-2",
  CAPTION: "caption",
  CAPTION_2: "caption-2",
  SUBTITLE_1: "subtitle-1",
  TITLE: "title",
  BUTTON: "button",
  SMALL: "small"
}, T1 = {
  REGULAR: "regular",
  MEDIUM: "medium",
  SEMI_BOLD: "semi-bold"
}, W1 = {
  BLOCK: "block",
  INLINE: "inline"
}, Fe = {
  LEVEL_1: 1,
  LEVEL_2: 2,
  LEVEL_3: 3
};
const N2 = {
  name: "app-text",
  props: {
    variant: {
      type: String,
      default: Z.BODY_1,
      validator: h.isIncludeValues(Object.values(Z), "variant")
    },
    display: {
      type: String,
      default: W1.INLINE,
      validator: h.isIncludeValues(Object.values(W1), "display")
    },
    color: {
      type: String,
      default: C.BLACK,
      validator: v1
    },
    weight: {
      type: String,
      default: T1.REGULAR,
      validator: h.isIncludeValues(Object.values(T1), "weight")
    }
  },
  setup(e, { slots: t }) {
    const n = $(() => {
      const l = e.variant === Z.CAPTION_2, d = e.weight === T1.SEMI_BOLD;
      return l && d ? "text-uppercase" : "";
    }), r = $(() => [
      `text-${e.variant}`,
      `text-${e.color}`,
      `font-weight-${e.weight}`,
      n.value
    ]);
    return () => {
      var l;
      return xe(
        e.display === W1.BLOCK ? "p" : "span",
        { class: r.value },
        (l = t.default) == null ? void 0 : l.call(t)
      );
    };
  }
}, R = /* @__PURE__ */ u(N2, [["__scopeId", "data-v-ba16713b"]]);
const S2 = [H.PRIMARY, H.SECONDARY], L2 = {
  // https://vuetifyjs.com/en/components/buttons/
  name: "app-button",
  components: {
    AppSpinnerDot: le,
    AppIcon: G,
    AppText: R
  },
  props: {
    buttonType: {
      type: String,
      validator: (e) => h.isIncludeValues(S2, "buttonType")(e),
      default: H.PRIMARY
    },
    block: {
      type: Boolean,
      default: !1
    },
    contentWithHtml: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    icon: {
      type: String,
      default: ""
    },
    iconPosition: {
      type: String,
      default: U1.RIGHT,
      validator: (e) => h.isIncludeValues(Object.values(U1), "iconPosition")(e)
    },
    exact: {
      type: Boolean,
      default: !1
    },
    href: {
      type: String,
      default: ""
    },
    to: {
      type: Object,
      default: () => null
    },
    tag: {
      type: String,
      default: "button"
    }
  },
  emits: ["click"],
  setup(e) {
    const { linkProps: t } = H1(e), n = $(() => e.buttonType === H.SECONDARY), r = $(() => {
      const f = "app-button";
      return [
        f,
        `${f}--${e.buttonType}`,
        e.disabled ? `${f}--disabled` : "",
        e.loading ? `${f}--loading` : ""
      ];
    }), l = $(() => e.loading ? I(C.GRAY, 40) : e.disabled ? I(C.GRAY, 10) : n.value ? I(C.GRAY, 20) : I(C.PRIMARY, 70)), d = $(() => e.loading ? I(C.GRAY, 80) : e.disabled ? I(C.GRAY, 60) : n.value ? I(C.GRAY, 90) : C.WHITE), i = $(() => e.iconPosition === U1.LEFT), s = $(() => e.iconPosition === U1.RIGHT);
    return {
      linkProps: t,
      isSecondary: n,
      rootClasses: r,
      buttonColor: l,
      contentColor: d,
      showLeftIcon: i,
      showRightIcon: s
    };
  }
}, A2 = ["innerHTML"], w2 = ["innerHTML"];
function O2(e, t, n, r, l, d) {
  const i = _("app-icon"), s = _("app-text"), f = _("app-spinner-dot"), p = _("v-btn");
  return a(), k(p, U({
    class: r.rootClasses,
    color: r.buttonColor,
    disabled: n.disabled,
    loading: n.loading,
    ripple: !1,
    tag: n.tag,
    block: n.block,
    height: "fit-content"
  }, r.linkProps, {
    onClick: t[0] || (t[0] = (v) => e.$emit("click"))
  }), {
    loader: g(() => [
      b(s, {
        variant: "button",
        color: r.contentColor,
        weight: "semi-bold"
      }, {
        default: g(() => [
          n.contentWithHtml ? (a(), c("span", {
            key: 0,
            "data-testId": "app-button-custom-html",
            innerHTML: n.contentWithHtml
          }, null, 8, w2)) : A("", !0),
          x(e.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["color"]),
      b(f)
    ]),
    default: g(() => [
      n.icon && r.showLeftIcon ? (a(), k(i, {
        key: 0,
        icon: n.icon,
        color: r.contentColor,
        size: "s"
      }, null, 8, ["icon", "color"])) : A("", !0),
      b(s, {
        variant: "button",
        color: r.contentColor,
        weight: "semi-bold"
      }, {
        default: g(() => [
          n.contentWithHtml ? (a(), c("span", {
            key: 0,
            "data-testId": "app-button-custom-html",
            innerHTML: n.contentWithHtml
          }, null, 8, A2)) : A("", !0),
          x(e.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["color"]),
      n.icon && r.showRightIcon ? (a(), k(i, {
        key: 1,
        icon: n.icon,
        color: r.contentColor,
        size: "s"
      }, null, 8, ["icon", "color"])) : A("", !0)
    ]),
    _: 3
  }, 16, ["class", "color", "disabled", "loading", "tag", "block"]);
}
const S7 = /* @__PURE__ */ u(L2, [["render", O2], ["__scopeId", "data-v-b778ca0e"]]);
function T2(e, t) {
  const n = e.createElement("textarea");
  n.addEventListener("focusin", (r) => r.stopPropagation()), n.value = t, e.body.appendChild(n), n.select(), e.execCommand("copy"), e.body.removeChild(n);
}
const z = (e) => n1.find((t) => t === e);
function o1() {
  const {
    name: e,
    sm: t,
    xs: n,
    lgAndUp: r,
    mdAndUp: l,
    platform: d
  } = dn(), { isRtl: i } = ln();
  return {
    breakpointName: e,
    isBreakpointSm: t,
    isBreakpointXs: n,
    isRtl: i,
    lgAndUp: r,
    mdAndUp: l,
    hasTouch: d.value.touch
  };
}
const M1 = {
  TOP: "top",
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right"
};
const D2 = {
  name: "app-tooltip",
  props: {
    maxWidth: {
      type: Number,
      default: 180
    },
    showByClick: {
      type: Boolean,
      default: !1
    },
    closeDelay: {
      type: Number,
      default: 300
    },
    position: {
      type: String,
      default: M1.BOTTOM,
      validator: h.isIncludeValues(Object.values(M1), "position")
    },
    offset: {
      type: Number,
      default: 4
    }
  },
  emits: ["visibility-change"],
  setup(e, { emit: t }) {
    const n = w(!1), r = w(!1), l = w(!1), d = w(!1), { hasTouch: i } = o1(), s = (V) => {
      const N = setTimeout(() => {
        if (l.value || d.value) {
          const B = setTimeout(() => {
            l.value = !1, d.value = !1, clearTimeout(B);
          }, 0);
          return;
        }
        r.value = !1, n.value = !1, d.value = !1, clearTimeout(N);
      }, V);
    }, f = () => {
      n.value && (l.value = !0);
    }, p = (V = !1) => {
      if (!(!r.value || !e.showByClick)) {
        if (r.value && !n.value) {
          n.value = !0;
          return;
        }
        if (V) {
          s(e.closeDelay);
          return;
        }
        r.value = !1, n.value = !1, d.value = !1;
      }
    }, v = () => {
      i && s(3e3);
    }, y = () => {
      d.value = !0;
    };
    return h1(() => r.value, (V) => {
      t("visibility-change", V), V && v();
    }), {
      hasTouch: i,
      isVisible: r,
      closeTooltip: p,
      stopClose: f,
      clickOnActivator: y
    };
  }
};
function E2(e, t, n, r, l, d) {
  const i = _("v-tooltip"), s = ne("click-outside");
  return a(), k(i, {
    modelValue: r.isVisible,
    "onUpdate:modelValue": t[5] || (t[5] = (f) => r.isVisible = f),
    class: "app-tooltip",
    transition: "fade-transition",
    "open-on-click": r.hasTouch || n.showByClick,
    location: n.position,
    "open-on-hover": !n.showByClick,
    "max-width": n.maxWidth,
    offset: n.offset,
    "close-delay": n.closeDelay,
    "z-index": 202
  }, {
    activator: g(({ props: f }) => [
      o("span", U(f, {
        class: "app-tooltip__activator",
        role: "button",
        tabindex: "0",
        onClick: t[0] || (t[0] = (...p) => r.clickOnActivator && r.clickOnActivator(...p)),
        onMouseleave: t[1] || (t[1] = (p) => r.closeTooltip(!0)),
        onMouseenter: t[2] || (t[2] = (...p) => r.stopClose && r.stopClose(...p))
      }), [
        x(e.$slots, "tooltip-activator", {}, void 0, !0)
      ], 16)
    ]),
    default: g(() => [
      S1((a(), c("div", {
        class: "app-tooltip__content",
        role: "button",
        tabindex: "0",
        onMouseenter: t[3] || (t[3] = (...f) => r.stopClose && r.stopClose(...f)),
        onMouseleave: t[4] || (t[4] = (f) => r.closeTooltip(!0))
      }, [
        x(e.$slots, "default", {}, void 0, !0)
      ], 32)), [
        [s, () => r.closeTooltip(!1)]
      ])
    ]),
    _: 3
  }, 8, ["modelValue", "open-on-click", "location", "open-on-hover", "max-width", "offset", "close-delay"]);
}
const Tt = /* @__PURE__ */ u(D2, [["render", E2], ["__scopeId", "data-v-8b888e9b"]]);
const V2 = 2e3, j2 = {
  name: "app-button-clipboard",
  components: {
    AppIcon: G,
    AppTooltip: Tt,
    AppText: R
  },
  props: {
    value: {
      type: [String, Number],
      required: !0
    },
    copyTooltipText: {
      type: String,
      default: "Copy"
    },
    copiedTooltipText: {
      type: String,
      default: "Copied"
    },
    closeDelay: {
      type: Number,
      default: 1200
    }
  },
  setup(e) {
    const { hasTouch: t } = o1(), n = w(!1), r = $(() => n.value ? e.copiedTooltipText : e.copyTooltipText), l = () => {
      n.value || (T2(window.document, e.value), n.value = !0, setTimeout(() => {
        n.value = !1;
      }, V2));
    };
    return {
      tooltipText: r,
      icon: z("content-copy"),
      iconColor: I(C.GRAY, 50),
      iconSize: M.M,
      tooltipTextColor: C.WHITE,
      tooltipTextVariant: Z.CAPTION_2,
      copyToClipboardHandler: l,
      hasTouch: t
    };
  }
};
function P2(e, t, n, r, l, d) {
  const i = _("app-icon"), s = _("v-btn"), f = _("app-text"), p = _("app-tooltip");
  return a(), k(p, {
    class: "app-button-clipboard",
    "close-delay": n.closeDelay,
    "show-by-click": r.hasTouch
  }, {
    "tooltip-activator": g(() => [
      b(s, {
        class: "app-button-clipboard__btn py-2 px-4 font-weight-regular",
        variant: "plain",
        ripple: !1,
        onClick: r.copyToClipboardHandler
      }, {
        default: g(() => [
          x(e.$slots, "prepend", {}, void 0, !0),
          b(i, {
            icon: r.icon,
            color: r.iconColor,
            size: r.iconSize
          }, null, 8, ["icon", "color", "size"]),
          x(e.$slots, "append", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["onClick"])
    ]),
    default: g(() => [
      b(f, {
        variant: r.tooltipTextVariant,
        color: r.tooltipTextColor
      }, {
        default: g(() => [
          D(O(r.tooltipText), 1)
        ]),
        _: 1
      }, 8, ["variant", "color"])
    ]),
    _: 3
  }, 8, ["close-delay", "show-by-click"]);
}
const L7 = /* @__PURE__ */ u(j2, [["render", P2], ["__scopeId", "data-v-6a91088d"]]), H2 = {
  [H.PRIMARY]: I(C.LINK, 80),
  [H.SECONDARY]: I(C.GRAY, 70),
  [H.TERTIARY]: I(C.GRAY, 50),
  [H.CAUTION]: I(C.ERROR, 80),
  [H.SUCCESS]: I(C.SUCCESS, 80)
};
const R2 = {
  // https://vuetifyjs.com/en/components/buttons/
  name: "app-button-icon",
  components: {
    AppIcon: G
  },
  props: {
    buttonType: {
      type: String,
      default: H.SECONDARY,
      validator: h.isIncludeValues(Object.values(H), "buttonType")
    },
    icon: {
      type: String,
      required: !0
    },
    href: {
      type: String,
      default: ""
    },
    to: {
      type: Object,
      default: () => null
    },
    exact: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["click"],
  setup(e) {
    const { linkProps: t } = H1(e), { isBreakpointXs: n } = o1(), r = $(
      () => n.value ? M.S : M.M
    ), l = $(() => H2[e.buttonType]), d = $(() => {
      const i = "app-button-icon";
      return [
        i,
        `${i}--${e.buttonType}`
      ];
    });
    return {
      linkProps: t,
      interpretedSize: r,
      contentColor: l,
      rootClasses: d
    };
  }
};
function B2(e, t, n, r, l, d) {
  const i = _("app-icon"), s = _("v-btn");
  return a(), k(s, U({
    class: r.rootClasses,
    icon: !0,
    rounded: "md",
    variant: "text"
  }, r.linkProps, {
    onClick: t[0] || (t[0] = (f) => e.$emit("click"))
  }), {
    default: g(() => [
      b(i, {
        icon: n.icon,
        color: r.contentColor,
        size: r.interpretedSize
      }, null, 8, ["icon", "color", "size"])
    ]),
    _: 1
  }, 16, ["class"]);
}
const Se = /* @__PURE__ */ u(R2, [["render", B2], ["__scopeId", "data-v-3a775e86"]]), z2 = {
  [H.PRIMARY]: I(C.LINK, 80),
  [H.SECONDARY]: I(C.GRAY, 90),
  [H.TERTIARY]: I(C.GRAY, 70),
  [H.CAUTION]: I(C.ERROR, 80),
  [H.SUCCESS]: I(C.SUCCESS, 90)
};
const F2 = [M1.LEFT, M1.RIGHT], U2 = n1.concat([""]), Z2 = {
  name: "app-button-text",
  components: {
    AppSpinnerDot: le,
    AppIcon: G,
    AppText: R
  },
  props: {
    buttonType: {
      type: String,
      default: H.PRIMARY,
      validator: h.isIncludeValues(Object.values(H), "buttonType")
    },
    block: {
      type: Boolean,
      default: !1
    },
    contentWithHtml: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    icon: {
      type: String,
      default: "",
      validator: h.isIncludeValues(U2, "icon")
    },
    iconPosition: {
      type: String,
      default: M1.LEFT,
      validator: h.isIncludeValues(F2, "position")
    },
    exact: {
      type: Boolean,
      default: !1
    },
    href: {
      type: String,
      default: ""
    },
    to: {
      type: Object,
      default: () => null
    },
    tag: {
      type: String,
      default: "button"
    },
    target: {
      type: String,
      default: "_self"
    }
  },
  emits: ["click"],
  setup(e) {
    const { linkProps: t } = H1(e), { isBreakpointXs: n } = o1(), r = $(
      () => n.value ? M.S : M.M
    ), l = $(
      () => n.value ? M.XS : M.S
    ), d = $(() => e.icon && !e.loading), i = $(() => {
      const f = "app-button-text";
      return [
        "d-flex align-center px-0",
        f,
        `${f}--${e.buttonType}`,
        `${f}--${e.iconPosition}`,
        e.loading ? `${f}--loading` : "",
        e.disabled ? `${f}--disabled` : ""
      ];
    }), s = $(() => {
      const f = {
        [H.CAUTION]: C.ERROR,
        [H.SUCCESS]: C.SUCCESS
      }, p = {
        loading: I(f[e.buttonType] || C.LINK, 100),
        disabled: I(C.GRAY, 70),
        ...z2
      };
      return e.loading ? p.loading : e.disabled ? p.disabled : p[e.buttonType];
    });
    return {
      linkProps: t,
      isIconVisible: d,
      iconSize: r,
      spinnerSize: l,
      rootClasses: i,
      contentColor: s
    };
  }
}, G2 = ["innerHTML"];
function Y2(e, t, n, r, l, d) {
  const i = _("app-icon"), s = _("app-spinner-dot"), f = _("app-text"), p = _("v-btn");
  return a(), k(p, U({
    class: r.rootClasses,
    variant: "text",
    color: r.contentColor,
    disabled: n.disabled || n.loading,
    ripple: !1,
    block: n.block,
    tag: n.tag,
    height: "fit-content"
  }, r.linkProps, {
    onClick: t[0] || (t[0] = (v) => e.$emit("click"))
  }), {
    default: g(() => [
      r.isIconVisible ? (a(), k(i, {
        key: 0,
        class: "app-button-text__icon",
        icon: n.icon,
        color: r.contentColor,
        size: r.iconSize
      }, null, 8, ["icon", "color", "size"])) : A("", !0),
      n.loading ? (a(), k(s, {
        key: 1,
        size: r.spinnerSize
      }, null, 8, ["size"])) : A("", !0),
      b(f, {
        class: "app-button-text__text",
        variant: "button",
        weight: "medium",
        color: r.contentColor
      }, {
        default: g(() => [
          n.contentWithHtml ? (a(), c("span", {
            key: 0,
            "data-testId": "btn-custom-html",
            innerHTML: n.contentWithHtml
          }, null, 8, G2)) : A("", !0),
          x(e.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["color"])
    ]),
    _: 3
  }, 16, ["class", "color", "disabled", "block", "tag"]);
}
const Dt = /* @__PURE__ */ u(Z2, [["render", Y2], ["__scopeId", "data-v-3282273b"]]);
const W2 = {
  name: "app-title",
  props: {
    level: {
      type: Number,
      default: Fe.LEVEL_1,
      validator: h.isIncludeValues(Object.values(Fe), "level")
    },
    color: {
      type: String,
      default: C.BLACK,
      validator: v1
    }
  },
  setup(e, { slots: t }) {
    const n = $(() => [
      `text-h${e.level}`,
      `text-${e.color}`
    ]);
    return () => {
      var r;
      return xe(
        `h${e.level}`,
        { class: n.value },
        (r = t.default) == null ? void 0 : r.call(t)
      );
    };
  }
}, Le = /* @__PURE__ */ u(W2, [["__scopeId", "data-v-6cbc168f"]]), Q2 = (e) => {
  const { params: t, query: n } = e;
  return X1(t) && Object.keys(t).length > 0 || X1(n) && Object.keys(n).length > 0;
};
function K2(e) {
  const t = X1(e) && K1(e.name) && Q2(e);
  return K1(e) || t ? !0 : (console.error("to: must be string or valid route plain obj"), !1);
}
const X2 = {
  // https://vuetifyjs.com/en/components/buttons/
  name: "app-link",
  components: {
    AppText: R,
    AppTitle: Le
  },
  props: {
    href: {
      type: String,
      default: ""
    },
    to: {
      type: [String, Object],
      default: "",
      // # || name-of-route || { name: 'name-of-route', params: { id: '22a' } }
      validator: K2
    },
    target: {
      type: String,
      default: "_self",
      validator: h.isIncludeValues(["_self", "_blank"], "target")
    },
    isTitle: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: C.BLACK,
      validator: v1
    },
    textVariant: {
      type: String,
      default: Z.BODY_1,
      validator: h.isIncludeValues([
        Z.BODY_1,
        Z.BODY_2,
        Z.CAPTION
      ], "textVariant")
    },
    contentClasses: {
      type: String,
      default: ""
    },
    textDecoration: {
      type: Boolean,
      default: !0
    },
    exact: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const { linkProps: t } = H1(e), n = $(() => {
      const r = `${e.textDecoration ? "text-decoration-underline" : ""}`, l = `${e.contentClasses ? ` ${e.contentClasses}` : ""}`, d = {
        color: e.color,
        class: `${r}${l}`,
        weight: "medium"
      };
      return e.isTitle ? {
        ...d,
        level: 2
      } : {
        ...d,
        variant: e.textVariant
      };
    });
    return {
      linkProps: t,
      textCmpProps: n
    };
  }
};
function q2(e, t, n, r, l, d) {
  const i = _("app-title"), s = _("app-text"), f = _("v-btn");
  return a(), k(f, U({
    class: "app-link pa-0",
    tag: "a",
    height: "fit-content",
    variant: "text",
    ripple: !1,
    "min-width": "auto",
    disabled: n.disabled,
    target: n.target
  }, r.linkProps), {
    default: g(() => [
      n.isTitle ? (a(), k(i, D1(U({ key: 0 }, r.textCmpProps)), {
        default: g(() => [
          x(e.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 16)) : (a(), k(s, D1(U({ key: 1 }, r.textCmpProps)), {
        default: g(() => [
          x(e.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 16))
    ]),
    _: 3
  }, 16, ["disabled", "target"]);
}
const J2 = /* @__PURE__ */ u(X2, [["render", q2], ["__scopeId", "data-v-d926f848"]]), e1 = {
  SUCCESS: "success",
  HOLD: "hold",
  ERROR: "error",
  PROGRESS: "progress",
  WARNING: "warning"
}, e0 = {
  [e1.SUCCESS]: C.SUCCESS,
  [e1.HOLD]: C.GRAY,
  [e1.ERROR]: C.ERROR,
  [e1.PROGRESS]: C.LINK,
  [e1.WARNING]: C.WARNING
}, t0 = {
  [e1.SUCCESS]: z("tick-circle"),
  [e1.HOLD]: z("block"),
  [e1.ERROR]: z("warning-circle"),
  [e1.PROGRESS]: z("time-circle"),
  [e1.WARNING]: z("warning-triangle")
};
const n0 = {
  name: "app-chip",
  components: {
    AppIcon: G,
    AppText: R
  },
  props: {
    closable: {
      type: Boolean,
      default: !1
    },
    isStatusChip: {
      type: Boolean,
      default: !1
    },
    iconNameOrAvailability: {
      type: [Boolean, String],
      default: !1
    },
    type: {
      type: String,
      validator: h.isIncludeValues(Object.values(e1), "type"),
      default: e1.HOLD
    },
    text: {
      type: String,
      default: ""
    }
  },
  emits: ["click", "click:close"],
  setup(e) {
    const { lgAndUp: t } = o1(), n = $(
      () => t.value ? M.M : M.S
    ), r = $(() => K1(e.iconNameOrAvailability) ? e.iconNameOrAvailability : t0[e.type]), l = $(() => e0[e.type]), d = $(() => {
      const s = e.type === e1.HOLD ? 10 : 40;
      return I(l.value, s);
    }), i = $(() => {
      const s = "app-chip";
      return {
        [s]: !0,
        [`${s}--disabled`]: e.disabled,
        [`${s}--status`]: e.isStatusChip,
        [`${s}--status-${e.type}`]: e.isStatusChip && e.type,
        [`${s}--closable`]: e.closable,
        [`bg-${d.value}`]: !0
      };
    });
    return {
      sizeIcon: n,
      closeIcon: z("close-circle-outline"),
      iconByType: r,
      color: I(l.value, 100),
      rootClasses: i
    };
  }
};
function r0(e, t, n, r, l, d) {
  const i = _("app-icon"), s = _("app-text");
  return a(), c("div", {
    class: T([r.rootClasses, "py-2 px-3 rounded-xl"])
  }, [
    o("div", {
      class: "app-chip__content",
      "aria-hidden": "true",
      onClick: t[0] || (t[0] = re((f) => e.$emit("click"), ["stop"]))
    }, [
      n.isStatusChip || n.iconNameOrAvailability ? (a(), k(i, {
        key: 0,
        icon: r.iconByType,
        color: r.color,
        size: r.sizeIcon,
        "aria-hidden": "true"
      }, null, 8, ["icon", "color", "size"])) : A("", !0),
      x(e.$slots, "default", {}, () => [
        b(s, {
          variant: "caption-2",
          weight: "semi-bold",
          color: r.color
        }, {
          default: g(() => [
            D(O(n.text), 1)
          ]),
          _: 1
        }, 8, ["color"])
      ], !0)
    ]),
    n.closable ? (a(), k(i, {
      key: 0,
      icon: r.closeIcon,
      color: r.color,
      size: r.sizeIcon,
      "aria-hidden": "true",
      onClick: t[1] || (t[1] = (f) => e.$emit("click:close"))
    }, null, 8, ["icon", "color", "size"])) : A("", !0)
  ], 2);
}
const A7 = /* @__PURE__ */ u(n0, [["render", r0], ["__scopeId", "data-v-17e65a6f"]]), m1 = {
  SUCCESS: "success",
  GRAY: "gray",
  ERROR: "error",
  PRIMARY: "primary",
  WARNING: "warning"
}, o0 = {
  [m1.SUCCESS]: C.SUCCESS,
  [m1.GRAY]: C.GRAY,
  [m1.ERROR]: C.ERROR,
  [m1.PRIMARY]: C.PRIMARY,
  [m1.WARNING]: C.WARNING
};
const d0 = {
  name: "app-chip-assist",
  components: {
    AppIcon: G,
    AppText: R
  },
  props: {
    icon: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      validator: h.isIncludeValues(Object.values(m1), "type"),
      default: m1.PRIMARY
    }
  },
  emits: ["click"],
  setup(e) {
    const { mdAndUp: t } = o1(), n = $(
      () => t.value ? M.M : M.S
    ), r = $(() => o0[e.type]), l = $(() => I(r.value, 100)), d = $(() => I(r.value, 80)), i = $(() => {
      const f = m1.GRAY === e.type ? 10 : 30;
      return I(r.value, f);
    }), s = $(() => {
      const f = "app-chip-assist";
      return {
        [f]: !0,
        [`${f}--${e.type}`]: e.type,
        [`bg-${i.value}`]: !0
      };
    });
    return {
      sizeIcon: n,
      textColor: l,
      iconColor: d,
      rootClasses: s
    };
  }
};
function l0(e, t, n, r, l, d) {
  const i = _("app-icon"), s = _("app-text");
  return a(), c("div", {
    class: T([r.rootClasses, "py-1 px-2 rounded-xl"])
  }, [
    o("div", {
      class: "app-chip-assist__content",
      "aria-hidden": "true",
      onClick: t[0] || (t[0] = re((f) => e.$emit("click"), ["stop"]))
    }, [
      n.icon ? (a(), k(i, {
        key: 0,
        icon: n.icon,
        color: r.iconColor,
        size: r.sizeIcon,
        "aria-hidden": "true"
      }, null, 8, ["icon", "color", "size"])) : A("", !0),
      x(e.$slots, "default", {}, () => [
        b(s, {
          variant: "caption-2",
          color: r.textColor
        }, {
          default: g(() => [
            D(O(n.text), 1)
          ]),
          _: 1
        }, 8, ["color"])
      ], !0)
    ])
  ], 2);
}
const w7 = /* @__PURE__ */ u(d0, [["render", l0], ["__scopeId", "data-v-84c3e206"]]);
const a0 = {
  name: "app-chip-tab",
  components: {
    AppText: R,
    AppIcon: G
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    isActiveTab: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(e) {
    const { isBreakpointXs: t } = o1(), n = $(
      () => t.value ? M.S : M.M
    ), r = $(() => I(C.GRAY, e.isActiveTab ? 80 : 50)), l = $(() => e.isActiveTab ? I(C.BLACK) : I(C.GRAY, 90)), d = $(() => e.isActiveTab ? "app-chip-tab--active" : "");
    return {
      sizeIcon: n,
      iconColor: r,
      textColor: l,
      activeClass: d,
      variant: Z.BUTTON,
      weight: T1.SEMI_BOLD
    };
  }
}, i0 = ["disabled"];
function s0(e, t, n, r, l, d) {
  const i = _("app-icon"), s = _("app-text");
  return a(), c("button", {
    class: T(["app-chip-tab px-4 py-2 d-flex align-center", r.activeClass]),
    disabled: n.disabled,
    onClick: t[0] || (t[0] = re((f) => e.$emit("click", n.item), ["stop"]))
  }, [
    n.item.icon ? (a(), k(i, {
      key: 0,
      class: "me-1",
      icon: n.item.icon,
      color: r.iconColor,
      size: r.sizeIcon,
      "aria-hidden": "true"
    }, null, 8, ["icon", "color", "size"])) : A("", !0),
    b(s, {
      color: r.textColor,
      variant: r.variant,
      weight: r.weight
    }, {
      default: g(() => [
        D(O(n.item.text), 1)
      ]),
      _: 1
    }, 8, ["color", "variant", "weight"])
  ], 10, i0);
}
const c0 = /* @__PURE__ */ u(a0, [["render", s0], ["__scopeId", "data-v-951971f9"]]);
const u0 = {
  name: "app-chip-tabs",
  components: {
    AppChipTab: c0
  },
  props: {
    modelValue: {
      type: String,
      required: !0
    },
    items: {
      type: Object,
      required: !0,
      validator: h.isArrayOf("items").obj
    }
  },
  emits: ["update:modelValue"]
}, f0 = { class: "app-chip-tabs" };
function p0(e, t, n, r, l, d) {
  const i = _("app-chip-tab");
  return a(), c("div", f0, [
    (a(!0), c(t1, null, c1(n.items, (s) => x(e.$slots, "label", {
      key: s.value,
      item: s
    }, () => [
      b(i, {
        item: s,
        disabled: s.disabled,
        "is-active-tab": s.value === n.modelValue,
        onClick: (f) => e.$emit("update:modelValue", s.value)
      }, null, 8, ["item", "disabled", "is-active-tab", "onClick"])
    ], !0)), 128))
  ]);
}
const O7 = /* @__PURE__ */ u(u0, [["render", p0], ["__scopeId", "data-v-8015fef3"]]), Z1 = {
  BOTTOM: "bottom",
  CENTER: "center"
};
const $0 = {
  // https://vuetifyjs.com/en/components/dialogs/
  name: "app-dialog",
  components: {
    AppButtonIcon: Se
  },
  props: {
    size: {
      type: String,
      validator: h.isIncludeValues([M.S, M.M, M.L], "size"),
      default: M.M
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    persistent: {
      type: Boolean,
      default: !1
    },
    fullscreen: {
      type: Boolean,
      default: !1
    },
    isHeaderVisible: {
      type: Boolean,
      default: !0
    },
    attach: {
      type: [String, Boolean],
      default: !1
    },
    showShadow: {
      type: Boolean,
      default: !1
    },
    closeAfter: {
      type: Number,
      validator: (e) => e >= 0,
      default: 0
    },
    modalPosition: {
      type: String,
      validator: h.isIncludeValues(Object.values(Z1), "modalPosition"),
      default: Z1.BOTTOM
    },
    showCloseBtn: {
      type: Boolean,
      default: !0
    },
    withBorder: {
      type: Boolean,
      default: !1
    },
    isConfirmDialog: {
      type: Boolean,
      default: !1
    },
    noPadding: {
      type: Boolean,
      default: !1
    },
    withScroll: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      timeoutId: null
    };
  },
  watch: {
    modelValue(e) {
      e && this.initCountdownWhenNecessary();
    }
  },
  computed: {
    isBottomPositionModal() {
      return this.modalPosition === Z1.BOTTOM;
    },
    isCenterPositionModal() {
      return this.modalPosition === Z1.CENTER;
    },
    propsForMobileDevice() {
      return this.isBreakpointSm && this.isBottomPositionModal ? { transition: "dialog-bottom-transition" } : null;
    },
    interpretedSize() {
      const e = {
        [M.S]: 368,
        [M.M]: 456,
        [M.L]: 600
      };
      return this.isBreakpointXs && !this.isConfirmDialog || this.fullscreen ? "100%" : e[this.size];
    },
    headerCssClasses() {
      const e = "app-dialog__header";
      return [
        e,
        { [`${e}--with-border`]: this.withBorder },
        { [`${e}--no-scroll`]: !this.withScroll }
      ];
    },
    iconClasses() {
      const e = "app-dialog__close-icon";
      return [
        e,
        { [`${e}--rtl`]: this.isRtl }
      ];
    },
    contentClasses() {
      const e = "app-dialog__container";
      return [
        e,
        "bg-white",
        this.fullscreen ? "" : "rounded-xxl",
        this.showShadow ? `${e}--with-shadow` : "",
        this.isBreakpointSm && this.isCenterPositionModal ? `${e}--show-center` : "",
        this.isConfirmDialog ? `${e}--type-confirm` : "",
        this.noPadding && this.isBreakpointXs ? `${e}--no-padding` : "",
        this.size === M.L ? `${e}--size-large` : ""
      ];
    },
    wrapperContainerClasses() {
      return [
        { "app-dialog--type-confirm": this.isConfirmDialog },
        { "app-dialog--scroll-wrapper": this.withScroll }
      ];
    }
  },
  methods: {
    initCountdownWhenNecessary() {
      this.timeoutId && this.clearTimeout(), this.closeAfter > 0 && this.runTimeout();
    },
    runTimeout() {
      this.timeoutId = setTimeout(this.timerCallback, this.closeAfter);
    },
    closeEvent() {
      this.$emit("update:modelValue", !1);
    },
    timerCallback() {
      this.clearTimeout(), this.closeEvent();
    },
    clearTimeout() {
      clearTimeout(this.timeoutId), this.timeoutId = null;
    }
  },
  emits: ["update:modelValue"],
  setup() {
    const {
      isBreakpointSm: e,
      isBreakpointXs: t,
      isRtl: n
    } = o1();
    return {
      isBreakpointSm: e,
      isBreakpointXs: t,
      isRtl: n
    };
  }
}, C0 = {
  key: 0,
  class: "d-flex align-center flex-grow-1"
}, _0 = {
  key: 1,
  class: "app-dialog__body"
}, g0 = {
  key: 2,
  class: "app-dialog__footer mt-8"
};
function y0(e, t, n, r, l, d) {
  const i = _("app-button-icon"), s = _("v-dialog");
  return a(), k(s, U({
    class: "app-dialog",
    "model-value": n.modelValue,
    "content-class": d.contentClasses,
    width: d.interpretedSize,
    persistent: n.persistent,
    fullscreen: n.fullscreen,
    attach: n.attach
  }, d.propsForMobileDevice, {
    "onUpdate:modelValue": t[0] || (t[0] = (f) => e.$emit("update:modelValue", f))
  }), {
    default: g(() => [
      o("div", {
        class: T(d.wrapperContainerClasses)
      }, [
        n.isHeaderVisible ? (a(), c("div", {
          key: 0,
          class: T(d.headerCssClasses)
        }, [
          e.$slots.header ? (a(), c("div", C0, [
            x(e.$slots, "header", {}, void 0, !0)
          ])) : A("", !0)
        ], 2)) : A("", !0),
        e.$slots.default ? (a(), c("div", _0, [
          x(e.$slots, "default", {}, void 0, !0)
        ])) : A("", !0),
        e.$slots.footer ? (a(), c("div", g0, [
          x(e.$slots, "footer", {}, void 0, !0)
        ])) : A("", !0),
        n.showCloseBtn ? (a(), k(i, {
          key: 3,
          class: T(d.iconClasses),
          icon: "close",
          onClick: d.closeEvent
        }, null, 8, ["class", "onClick"])) : A("", !0)
      ], 2)
    ]),
    _: 3
  }, 16, ["model-value", "content-class", "width", "persistent", "fullscreen", "attach"]);
}
const m0 = /* @__PURE__ */ u($0, [["render", y0], ["__scopeId", "data-v-8eb9e129"]]), h0 = {
  name: "app-dialog-confirm",
  components: {
    AppDialog: m0,
    AppButtonText: Dt,
    AppTitle: Le,
    AppIcon: G
  },
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    persistent: {
      type: Boolean,
      default: !1
    },
    action: {
      type: Function,
      required: !0
    },
    actionText: {
      type: String,
      default: "Confirm"
    },
    cancelText: {
      type: String,
      default: "Confirm"
    },
    title: {
      type: String,
      default: ""
    },
    reverse: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      validator: h.isIncludeValues([M.S, M.M, M.L], "size"),
      default: M.M
    }
  },
  data() {
    return {
      isActionInProgress: !1
    };
  },
  computed: {
    itCantBeClosed() {
      return this.persistent && this.isActionInProgress;
    },
    btnClasses() {
      return {
        action: this.reverse ? "order-1" : "ms-8",
        cancel: this.reverse ? "ms-8 mb-4 mb-sm-0" : null
      };
    },
    actionProps() {
      return {
        buttonType: this.reverse ? H.SECONDARY : H.CAUTION,
        loading: this.isActionInProgress
      };
    },
    cancelProps() {
      return {
        buttonType: this.reverse ? H.CAUTION : H.SECONDARY
      };
    },
    footerSlotProps() {
      return {
        on: {
          click: this.handleAction
        },
        loading: this.isActionInProgress
      };
    }
  },
  methods: {
    emitCloseEvent() {
      this.itCantBeClosed || this.$emit("update:modelValue", !1);
    },
    async handleAction() {
      this.isActionInProgress = !0;
      try {
        await Promise.resolve(this.action());
      } finally {
        this.isActionInProgress = !1, this.emitCloseEvent();
      }
    }
  },
  emits: ["update:modelValue"]
}, v0 = { class: "app-dialog__wrapper-btn d-flex justify-end" };
function b0(e, t, n, r, l, d) {
  const i = _("app-title"), s = _("app-icon"), f = _("app-button-text"), p = _("app-dialog");
  return a(), k(p, {
    "model-value": n.modelValue,
    persistent: d.itCantBeClosed,
    size: n.size,
    "show-close-btn": !1,
    "with-border": !0,
    "is-confirm-dialog": !0
  }, {
    header: g(() => [
      b(i, { level: 3 }, {
        default: g(() => [
          D(O(n.title), 1)
        ]),
        _: 1
      }),
      x(e.$slots, "header"),
      b(s, {
        class: "ms-auto",
        color: "gray-50",
        icon: "warning-triangle"
      })
    ]),
    footer: g(() => [
      x(e.$slots, "footer", {
        on: d.footerSlotProps.on,
        loading: d.footerSlotProps.loading
      }, () => [
        o("div", v0, [
          b(f, U({
            class: d.btnClasses.cancel
          }, d.cancelProps, {
            "data-qa-key": "app-dialog-confirm-cancel-button",
            onClick: d.emitCloseEvent
          }), {
            default: g(() => [
              D(O(n.cancelText), 1)
            ]),
            _: 1
          }, 16, ["class", "onClick"]),
          b(f, U({
            class: d.btnClasses.action
          }, d.actionProps, {
            "data-qa-key": "app-dialog-confirm-action-button",
            onClick: d.handleAction
          }), {
            default: g(() => [
              D(O(n.actionText), 1)
            ]),
            _: 1
          }, 16, ["class", "onClick"])
        ])
      ])
    ]),
    default: g(() => [
      x(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["model-value", "persistent", "size"]);
}
const T7 = /* @__PURE__ */ u(h0, [["render", b0]]), i1 = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error"
}, Ue = {
  [i1.SUCCESS]: C.SUCCESS,
  [i1.INFO]: C.LINK,
  [i1.ERROR]: C.ERROR,
  [i1.WARNING]: C.WARNING
};
const I0 = {
  // https://vuetifyjs.com/en/components/alerts/#usage
  name: "app-alert",
  components: {
    AppButtonIcon: Se,
    AppIcon: G,
    AppText: R,
    AppButtonText: Dt
  },
  props: {
    type: {
      type: String,
      validator: h.isIncludeValues(Object.values(i1), "type"),
      default: i1.INFO
    },
    closable: {
      type: Boolean,
      default: !0
    },
    title: {
      type: String,
      default: ""
    },
    width: {
      type: [String, Number],
      default: "100%"
    },
    linkText: {
      type: String,
      default: ""
    },
    to: {
      type: [String, Object],
      default: () => null
    }
  },
  emits: ["close"],
  setup(e) {
    const t = n1.find((f) => f === "close"), n = $(() => {
      const f = (v) => n1.find((y) => y === v);
      return {
        [i1.WARNING]: f("warning-triangle"),
        [i1.ERROR]: f("warning-circle"),
        [i1.INFO]: f("info-solid"),
        [i1.SUCCESS]: f("tick-circle")
      }[e.type];
    }), r = $(() => I(Ue[e.type], 80)), l = $(() => I(Ue[e.type], 100)), d = n1.find((f) => f === "arrow-top-right"), { lgAndUp: i } = o1(), s = $(() => i.value ? M.L : M.M);
    return {
      lgAndUp: i,
      iconByType: n,
      mainColor: l,
      alertIcon: s,
      iconColor: r,
      closeIcon: t,
      iconLink: d
    };
  }
}, M0 = {
  key: 0,
  class: "app-alert__title mb-1"
}, k0 = {
  key: 0,
  class: "app-alert__link align-self-start"
};
function x0(e, t, n, r, l, d) {
  const i = _("app-text"), s = _("app-button-text"), f = _("app-button-icon"), p = _("app-icon"), v = _("v-alert");
  return a(), k(v, {
    class: T(`app-alert pa-4 rounded-xl app-alert--${n.type}`),
    variant: "outlined",
    type: n.type,
    width: n.width,
    color: r.mainColor
  }, j1({
    prepend: g(() => [
      b(p, {
        icon: r.iconByType,
        size: r.alertIcon,
        color: r.iconColor
      }, null, 8, ["icon", "size", "color"])
    ]),
    default: g(() => [
      o("div", null, [
        n.title || e.$slots.title ? (a(), c("div", M0, [
          b(i, {
            color: r.mainColor,
            weight: "semi-bold"
          }, {
            default: g(() => [
              x(e.$slots, "title", {}, () => [
                D(O(n.title), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["color"])
        ])) : A("", !0),
        b(i, {
          class: "app-alert__body",
          variant: "caption",
          color: r.mainColor
        }, {
          default: g(() => [
            x(e.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["color"])
      ]),
      n.linkText ? (a(), c("div", k0, [
        b(s, {
          to: n.to,
          icon: r.iconLink,
          "icon-position": "right"
        }, {
          default: g(() => [
            D(O(n.linkText), 1)
          ]),
          _: 1
        }, 8, ["to", "icon"])
      ])) : A("", !0)
    ]),
    _: 2
  }, [
    n.closable ? {
      name: "close",
      fn: g(() => [
        b(f, {
          class: "app-alert__close align-self-baseline",
          icon: r.closeIcon,
          onClick: t[0] || (t[0] = (y) => e.$emit("close"))
        }, null, 8, ["icon"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["class", "type", "width", "color"]);
}
const D7 = /* @__PURE__ */ u(I0, [["render", x0], ["__scopeId", "data-v-5bacb8bb"]]);
const N0 = {
  name: "app-linear-stepper",
  components: {
    AppText: R
  },
  props: {
    numberSteps: {
      type: Number,
      default: 1
    },
    currentStep: {
      type: Number,
      default: 1
    },
    stepText: {
      type: String,
      default: "Step"
    }
  },
  setup(e) {
    const t = (l) => [
      "app-step",
      l <= e.currentStep ? "app-step--active" : ""
    ], n = I(C.GRAY, 80), r = Z.CAPTION;
    return {
      stepClasses: t,
      textColor: n,
      textVariant: r
    };
  }
}, S0 = { class: "app-linear-stepper" }, L0 = { class: "d-flex mb-2" };
function A0(e, t, n, r, l, d) {
  const i = _("app-text");
  return a(), c("div", S0, [
    o("div", L0, [
      (a(!0), c(t1, null, c1(n.numberSteps, (s) => (a(), c("div", {
        key: s,
        class: T(r.stepClasses(s))
      }, null, 2))), 128))
    ]),
    b(i, { variant: r.textVariant }, {
      default: g(() => [
        D(O(n.stepText) + " " + O(n.currentStep), 1)
      ]),
      _: 1
    }, 8, ["variant"]),
    b(i, {
      color: r.textColor,
      variant: r.textVariant
    }, {
      default: g(() => [
        D(" / " + O(n.numberSteps), 1)
      ]),
      _: 1
    }, 8, ["color", "variant"])
  ]);
}
const E7 = /* @__PURE__ */ u(N0, [["render", A0], ["__scopeId", "data-v-80f1b06b"]]), s1 = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error"
}, w0 = {
  [s1.SUCCESS]: C.SUCCESS,
  [s1.INFO]: C.LINK,
  [s1.ERROR]: C.ERROR,
  [s1.WARNING]: C.WARNING
};
const G1 = (e) => n1.find((t) => t === e), O0 = {
  [s1.WARNING]: G1("warning-triangle"),
  [s1.ERROR]: G1("warning-circle"),
  [s1.INFO]: G1("info-solid"),
  [s1.SUCCESS]: G1("tick-circle")
}, T0 = {
  name: "app-notification-template",
  components: {
    AppButtonIcon: Se,
    AppIcon: G,
    AppText: R
  },
  props: {
    type: {
      type: String,
      validator: h.isIncludeValues(Object.values(s1), "type"),
      default: s1.INFO
    },
    closable: {
      type: Boolean,
      default: !0
    },
    duration: {
      type: Number,
      default: 5e3
    }
  },
  emits: ["close"],
  setup(e) {
    const t = $(() => `--duration: ${e.duration}ms`), n = n1.find((i) => i === "close"), r = $(() => O0[e.type]), l = $(() => I(w0[e.type], 80)), d = M.L;
    return {
      borderDuration: t,
      closeIcon: n,
      iconByType: r,
      iconColor: l,
      iconSize: d
    };
  }
};
function D0(e, t, n, r, l, d) {
  const i = _("app-text"), s = _("app-button-icon"), f = _("app-icon"), p = _("v-alert");
  return a(), k(p, {
    class: "app-notification-template rounded py-6 px-4",
    variant: "text",
    border: "top",
    "border-color": r.iconColor,
    type: n.type,
    style: ke(r.borderDuration),
    color: "black"
  }, j1({
    prepend: g(() => [
      b(f, {
        icon: r.iconByType,
        color: r.iconColor,
        size: r.iconSize
      }, null, 8, ["icon", "color", "size"])
    ]),
    default: g(() => [
      b(i, null, {
        default: g(() => [
          x(e.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      })
    ]),
    _: 2
  }, [
    n.closable ? {
      name: "close",
      fn: g(() => [
        b(s, {
          class: "d-none d-sm-flex",
          icon: r.closeIcon,
          onClick: t[0] || (t[0] = (v) => e.$emit("close"))
        }, null, 8, ["icon"])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["border-color", "type", "style"]);
}
const V7 = /* @__PURE__ */ u(T0, [["render", D0], ["__scopeId", "data-v-e6c45ec7"]]), E0 = {
  // https://vuetifyjs.com/en/components/grids/#usage
  name: "app-col",
  props: [
    "alignSelf",
    "cols",
    "lg",
    "md",
    "offset",
    "offsetLg",
    "offsetMd",
    "offsetSm",
    "offsetXl",
    "order",
    "orderLg",
    "orderMd",
    "orderSm",
    "orderXl",
    "sm",
    "tag",
    "xl"
  ]
};
function V0(e, t, n, r, l, d) {
  const i = _("v-col");
  return a(), k(i, D1(Ne(e.$props)), {
    default: g(() => [
      x(e.$slots, "default")
    ]),
    _: 3
  }, 16);
}
const j0 = /* @__PURE__ */ u(E0, [["render", V0]]), P0 = {
  // https://vuetifyjs.com/en/components/grids/#usage
  name: "app-container",
  props: [
    "fluid",
    "id",
    "tag"
  ]
};
function H0(e, t, n, r, l, d) {
  const i = _("v-container");
  return a(), k(i, D1(Ne(e.$props)), {
    default: g(() => [
      x(e.$slots, "default")
    ]),
    _: 3
  }, 16);
}
const j7 = /* @__PURE__ */ u(P0, [["render", H0]]), R0 = {
  // https://vuetifyjs.com/en/components/grids/#usage
  name: "app-row",
  props: [
    "align",
    "alignContent",
    "alignContentLg",
    "alignContentMd",
    "alignContentSm",
    "alignContentXl",
    "alignLg",
    "alignMd",
    "alignSm",
    "alignXl",
    "dense",
    "justify",
    "justifyLg",
    "justifyMd",
    "justifySm",
    "justifyXl",
    "noGutters",
    "tag"
  ]
};
function B0(e, t, n, r, l, d) {
  const i = _("v-row");
  return a(), k(i, D1(Ne(e.$props)), {
    default: g(() => [
      x(e.$slots, "default")
    ]),
    _: 3
  }, 16);
}
const z0 = /* @__PURE__ */ u(R0, [["render", B0]]), q1 = {
  PRIMARY: "primary",
  WARNING: "warning"
};
const Ze = [...n1, ""], F0 = {
  [q1.PRIMARY]: I(C.GRAY, 90),
  [q1.WARNING]: I(C.ERROR, 70)
}, U0 = {
  name: "app-list-item",
  components: {
    AppIcon: G
  },
  props: {
    listItemType: {
      type: String,
      default: q1.PRIMARY,
      validator: h.isIncludeValues(Object.values(q1), "listItemType")
    },
    selected: {
      type: Boolean,
      default: !1
    },
    prependIcon: {
      type: String,
      default: "",
      validator: h.isIncludeValues(Ze, "prependIcon")
    },
    appendIcon: {
      type: String,
      default: "",
      validator: h.isIncludeValues(Ze, "appendIcon")
    },
    href: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: "_self"
    },
    to: {
      type: Object,
      default: () => null
    },
    exact: {
      type: Boolean,
      default: !1
    },
    prependIconSize: {
      type: String,
      validator: h.isIncludeValues(Object.values(M), "size"),
      default: M.M
    },
    appendIconSize: {
      type: String,
      validator: h.isIncludeValues(Object.values(M), "size"),
      default: M.M
    }
  },
  emits: ["click"],
  setup(e) {
    const { linkProps: t } = H1(e), n = $(() => e.selected ? z("tick-big") : e.appendIcon), r = $(() => e.selected ? I(C.LINK, 60) : I(C.GRAY, 50)), l = $(() => F0[e.listItemType]), d = "app-list-item", i = $(() => [
      d,
      `${d}--${e.listItemType}`
    ]);
    return {
      linkProps: t,
      appendIconName: n,
      appendIconColor: r,
      prependIconColor: l,
      rootClasses: i
    };
  }
};
function Z0(e, t, n, r, l, d) {
  const i = _("app-icon"), s = _("v-list-item");
  return a(), k(s, U({
    class: [r.rootClasses, "pa-3"],
    active: n.selected,
    ripple: !1,
    width: "100%",
    "active-class": "app-list-item--active",
    target: n.target
  }, r.linkProps, {
    onClick: t[0] || (t[0] = (f) => e.$emit("click"))
  }), j1({
    append: g(() => [
      n.appendIcon.length || n.selected ? (a(), k(i, {
        key: 0,
        class: "ms-auto",
        icon: r.appendIconName,
        color: r.appendIconColor,
        size: n.appendIconSize
      }, null, 8, ["icon", "color", "size"])) : A("", !0)
    ]),
    default: g(() => [
      n.prependIcon.length ? (a(), k(i, {
        key: 0,
        class: "me-3",
        icon: n.prependIcon,
        color: r.prependIconColor,
        size: n.prependIconSize
      }, null, 8, ["icon", "color", "size"])) : A("", !0)
    ]),
    _: 2
  }, [
    e.$slots.default ? {
      name: "title",
      fn: g(() => [
        x(e.$slots, "default", {}, void 0, !0)
      ]),
      key: "0"
    } : void 0
  ]), 1040, ["class", "active", "target"]);
}
const Ae = /* @__PURE__ */ u(U0, [["render", Z0], ["__scopeId", "data-v-a6cbdc77"]]);
const G0 = {
  name: "app-autocomplete",
  components: {
    AppText: R,
    AppListItem: Ae
  },
  props: {
    clearable: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    itemTitle: {
      type: String,
      default: "title"
    },
    itemValue: {
      type: String,
      default: "value"
    },
    label: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !1
    },
    message: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [String, Number, Object],
      default: ""
    },
    noDataText: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    returnObject: {
      type: Boolean,
      default: !1
    },
    isInputLtr: {
      type: Boolean,
      default: !1
    },
    rules: {
      type: Array,
      validator: h.isArrayOfOneOf(["str", "bool", "fn"], "rules"),
      default: () => []
    }
  },
  emits: ["update:modelValue", "focus"],
  setup(e, { emit: t }) {
    const n = w(e.modelValue), r = $(() => e.label ? "app-autocomplete--label" : ""), l = $(() => {
      const f = {
        transition: "scroll-y-transition",
        contentClass: "app-autocomplete__list",
        offset: 8
      };
      return e.loading ? { modelValue: !1, ...f } : f;
    }), d = (f) => e.returnObject && n.value ? f.value === n.value[e.itemValue] : f.value === n.value, i = (f) => {
      n.value = f, t("update:modelValue", f);
    }, s = $(
      () => n.value ? "app-autocomplete--dirty" : "app-autocomplete--no-dirty"
    );
    return {
      isLabelClasses: r,
      menuProps: l,
      textVariant: Z.CAPTION,
      colorLabel: I(C.GRAY, 80),
      clearIcon: z("close"),
      menuIcon: z("arrow-small-down"),
      inputModel: n,
      isSelected: d,
      updateValue: i,
      dirtyClass: s
    };
  }
}, Y0 = { class: "app-autocomplete__item" };
function W0(e, t, n, r, l, d) {
  const i = _("app-text"), s = _("app-list-item"), f = _("v-autocomplete");
  return a(), k(f, {
    "model-value": r.inputModel,
    class: T(["app-autocomplete", r.isLabelClasses, r.dirtyClass]),
    variant: "solo",
    "auto-select-first": !0,
    "center-affix": !0,
    clearable: n.clearable,
    "clear-icon": r.clearIcon,
    color: r.colorLabel,
    density: "comfortable",
    "error-messages": n.errorMessage,
    flat: !0,
    items: n.items,
    "item-title": n.itemTitle,
    "item-value": n.itemValue,
    label: n.label,
    loading: n.loading,
    "menu-icon": r.menuIcon,
    "menu-props": r.menuProps,
    messages: n.message,
    "no-data-text": n.noDataText,
    "persistent-placeholder": !0,
    placeholder: n.placeholder,
    "return-object": n.returnObject,
    reverse: n.isInputLtr,
    rules: n.rules,
    "onUpdate:focused": t[0] || (t[0] = (p) => e.$emit("focus")),
    "onUpdate:modelValue": r.updateValue
  }, j1({
    selection: g(({ item: p }) => [
      b(i, { variant: r.textVariant }, {
        default: g(() => [
          D(O(n.itemTitle ? p[n.itemTitle] : p), 1)
        ]),
        _: 2
      }, 1032, ["variant"])
    ]),
    _: 2
  }, [
    n.loading ? void 0 : {
      name: "item",
      fn: g(({ item: p, props: v }) => [
        o("div", Y0, [
          b(s, U(v, {
            selected: r.isSelected(p)
          }), {
            default: g(() => [
              b(i, { variant: r.textVariant }, {
                default: g(() => [
                  D(O(p.title), 1)
                ]),
                _: 2
              }, 1032, ["variant"])
            ]),
            _: 2
          }, 1040, ["selected"])
        ])
      ]),
      key: "0"
    }
  ]), 1032, ["model-value", "class", "clearable", "clear-icon", "color", "error-messages", "items", "item-title", "item-value", "label", "loading", "menu-icon", "menu-props", "messages", "no-data-text", "placeholder", "return-object", "reverse", "rules", "onUpdate:modelValue"]);
}
const P7 = /* @__PURE__ */ u(G0, [["render", W0], ["__scopeId", "data-v-fb1b67c9"]]);
const Q0 = {
  // https://vuetifyjs.com/en/components/checkboxes/
  name: "app-checkbox",
  components: {
    AppText: R
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [Boolean, String],
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    indeterminate: {
      type: Boolean,
      default: !1
    },
    hideDetails: {
      type: [Boolean, String],
      default: "auto"
    },
    error: {
      type: Boolean,
      default: !1
    },
    errorMessages: {
      type: [String, Array],
      default: ""
    },
    messages: {
      type: [String, Array],
      default: ""
    },
    rules: {
      type: Array,
      validator: h.isArrayOf("rules").fn,
      default: () => []
    }
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = w(e.modelValue), n = $(
      () => e.indeterminate && (e.modelValue === null || e.modelValue === void 0)
    ), r = $(() => {
      const d = ["app-checkbox"];
      return n.value && d.push("app-checkbox--indeterminate"), e.error && d.push("app-checkbox--error"), t.value ? d.push("app-checkbox--checked") : d.push("app-checkbox--not-checked"), d;
    }), l = $(() => e.disabled ? I(C.GRAY, 50) : I(C.BLACK));
    return { checked: t, classes: r, isIndeterminate: n, labelColor: l };
  }
};
function K0(e, t, n, r, l, d) {
  const i = _("app-text"), s = _("v-checkbox");
  return a(), k(s, {
    modelValue: r.checked,
    "onUpdate:modelValue": [
      t[0] || (t[0] = (f) => r.checked = f),
      t[1] || (t[1] = (f) => e.$emit("update:modelValue", f))
    ],
    class: T(r.classes),
    disabled: n.disabled,
    indeterminate: r.isIndeterminate,
    "hide-details": n.hideDetails,
    ripple: !1,
    error: n.error,
    "error-messages": n.errorMessages,
    messages: n.messages,
    rules: n.rules,
    "true-icon": "checkbox-checked",
    "false-icon": "",
    "indeterminate-icon": "checkbox-indeterminate"
  }, {
    label: g(() => [
      b(i, {
        variant: "caption",
        color: r.labelColor
      }, {
        default: g(() => [
          D(O(n.label), 1)
        ]),
        _: 1
      }, 8, ["color"])
    ]),
    _: 1
  }, 8, ["modelValue", "class", "disabled", "indeterminate", "hide-details", "error", "error-messages", "messages", "rules"]);
}
const H7 = /* @__PURE__ */ u(Q0, [["render", K0], ["__scopeId", "data-v-8b2cbdfe"]]), X0 = (e) => e == null ? !0 : Object.keys(e).length === 0, q0 = [
  "number",
  "string",
  "password"
];
const J0 = {
  // https://vuetifyjs.com/en/components/otp-input/
  name: "app-otp-input",
  components: {
    AppText: R,
    AppSpinnerDot: le
  },
  props: {
    type: {
      type: String,
      validator: h.isIncludeValues(q0, "type"),
      default: "number"
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    error: {
      type: String,
      default: ""
    },
    length: {
      type: Number,
      default: 6
    },
    loading: {
      type: Boolean,
      default: !1
    },
    message: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [String, Number],
      default: ""
    }
  },
  emits: ["finish", "update:model-value"],
  setup(e) {
    const t = $(() => [
      "app-otp-input",
      "mx-auto",
      e.error ? "app-otp-input--error" : ""
    ]), n = $(() => e.error ? I(C.ERROR, 100) : I(C.GRAY, 70)), r = $(() => !X0(e.error));
    return {
      messageColor: n,
      captionVariant: Z.CAPTION_2,
      blockDisplay: W1.BLOCK,
      bgColor: I(C.GRAY, 20),
      otpClasses: t,
      isErrorState: r
    };
  }
}, er = { class: "otp-wrap d-inline-flex flex-column" };
function tr(e, t, n, r, l, d) {
  const i = _("app-spinner-dot"), s = _("v-otp-input"), f = _("app-text");
  return a(), c("div", er, [
    b(s, {
      "model-value": n.modelValue,
      class: T(r.otpClasses),
      autofocus: n.autofocus,
      "bg-color": r.bgColor,
      "focus-all": !0,
      type: n.type,
      length: n.length,
      loading: n.loading,
      disabled: n.disabled,
      error: r.isErrorState,
      placeholder: n.placeholder,
      "onUpdate:modelValue": t[0] || (t[0] = (p) => e.$emit("update:model-value", p)),
      onFinish: t[1] || (t[1] = (p) => e.$emit("finish", p)),
      "onUpdate:focused": t[2] || (t[2] = (p) => e.$emit("focus", p))
    }, {
      loader: g(() => [
        b(i, {
          class: "ml-auto mr-auto",
          size: "s"
        })
      ]),
      _: 1
    }, 8, ["model-value", "class", "autofocus", "bg-color", "type", "length", "loading", "disabled", "error", "placeholder"]),
    n.error || n.message ? (a(), k(f, {
      key: 0,
      color: r.messageColor,
      display: r.blockDisplay,
      variant: r.captionVariant,
      class: "mb-0"
    }, {
      default: g(() => [
        D(O(n.error || n.message), 1)
      ]),
      _: 1
    }, 8, ["color", "display", "variant"])) : A("", !0)
  ]);
}
const R7 = /* @__PURE__ */ u(J0, [["render", tr], ["__scopeId", "data-v-17d7968a"]]);
const nr = {
  name: "app-switch",
  components: {
    AppText: R
  },
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = $(() => {
      const s = "app-switch";
      return [
        s,
        e.label ? `${s}--label` : "",
        e.disabled ? `${s}--disabled` : "",
        "d-flex align-center"
      ];
    }), r = $(() => e.disabled ? I(C.GRAY, 50) : I(C.BLACK)), l = (s) => {
      t("update:modelValue", s.target.checked);
    }, { uid: d } = en();
    return {
      uidSwitch: `switch-${d}`,
      rootClasses: n,
      textColor: r,
      onChange: l
    };
  }
}, rr = ["id", "checked", "aria-checked", "value", "disabled", "required"], or = ["for"];
function dr(e, t, n, r, l, d) {
  const i = _("app-text");
  return a(), c("div", {
    class: T(r.rootClasses)
  }, [
    o("input", {
      id: r.uidSwitch,
      class: "app-switch__input",
      type: "checkbox",
      checked: n.modelValue,
      "aria-checked": n.modelValue,
      value: n.modelValue,
      disabled: n.disabled,
      required: n.required,
      onChange: t[0] || (t[0] = (...s) => r.onChange && r.onChange(...s))
    }, null, 40, rr),
    o("label", {
      class: "app-switch__label",
      for: r.uidSwitch
    }, [
      n.label ? (a(), k(i, {
        key: 0,
        variant: "caption",
        color: r.textColor
      }, {
        default: g(() => [
          D(O(n.label), 1)
        ]),
        _: 1
      }, 8, ["color"])) : A("", !0)
    ], 8, or)
  ], 2);
}
const B7 = /* @__PURE__ */ u(nr, [["render", dr], ["__scopeId", "data-v-c7f5fea3"]]);
const Ge = [...n1, ""], lr = {
  // https://vuetifyjs.com/en/components/text-fields/
  name: "app-text-field",
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    autocomplete: {
      type: String,
      default: "on"
    },
    appendIconName: {
      type: String,
      validator: h.isIncludeValues(Ge, "appendIconName"),
      default: ""
    },
    clearable: {
      type: Boolean,
      default: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    hideDetails: {
      type: Boolean,
      default: !1
    },
    hint: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !1
    },
    message: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    persistentHint: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    prefix: {
      type: String,
      default: ""
    },
    prependIconName: {
      type: String,
      validator: h.isIncludeValues(Ge, "prependIconName"),
      default: ""
    },
    isInputLtr: {
      // reverse for RTL
      type: Boolean,
      default: !0
    },
    rules: {
      type: Array,
      validator: h.isArrayOfOneOf(["str", "bool", "fn"], "rules"),
      default: () => []
    },
    suffix: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    validateOn: {
      type: String,
      default: "input"
    }
  },
  emits: ["update:value", "focus", "click-append"],
  setup(e) {
    const t = $(() => z(e.appendIconName)), n = $(() => z(e.prependIconName)), r = $(() => ({ "app-text-field--ltr": e.isInputLtr }));
    return {
      appendIcon: t,
      clearIcon: z("close"),
      colorLabel: I(C.GRAY, 80),
      bgColor: C.WHITE,
      prependIcon: n,
      ltrClasses: r
    };
  }
};
function ar(e, t, n, r, l, d) {
  const i = _("v-text-field");
  return a(), k(i, {
    class: T(["app-text-field", r.ltrClasses]),
    variant: "solo",
    "model-value": n.value,
    autofocus: n.autofocus,
    autocomplete: n.autocomplete,
    "append-inner-icon": r.appendIcon,
    "bg-color": r.bgColor,
    clearable: n.clearable,
    "clear-icon": r.clearIcon,
    color: r.colorLabel,
    density: "comfortable",
    disabled: n.disabled,
    "error-messages": n.errorMessage,
    flat: !0,
    "hide-details": n.hideDetails,
    hint: n.hint,
    label: n.label,
    loading: n.loading,
    messages: n.message,
    name: n.name,
    "persistent-hint": n.persistentHint,
    placeholder: n.placeholder,
    prefix: n.prefix,
    "prepend-inner-icon": r.prependIcon,
    rules: n.rules,
    suffix: n.suffix,
    type: n.type,
    "validate-on": n.validateOn,
    "onUpdate:focused": t[0] || (t[0] = (s) => e.$emit("focus", s)),
    "onClick:appendInner": t[1] || (t[1] = (s) => e.$emit("click-append", s)),
    "onUpdate:modelValue": t[2] || (t[2] = (s) => e.$emit("update:value", s))
  }, null, 8, ["class", "model-value", "autofocus", "autocomplete", "append-inner-icon", "bg-color", "clearable", "clear-icon", "color", "disabled", "error-messages", "hide-details", "hint", "label", "loading", "messages", "name", "persistent-hint", "placeholder", "prefix", "prepend-inner-icon", "rules", "suffix", "type", "validate-on"]);
}
const ir = /* @__PURE__ */ u(lr, [["render", ar], ["__scopeId", "data-v-dfeb98c8"]]);
const Ye = [""].concat(n1), sr = {
  name: "app-textarea",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    counter: {
      type: Number,
      default: 250
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    autoGrow: {
      type: Boolean,
      default: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    errorMessage: {
      type: String,
      default: ""
    },
    hint: {
      type: String,
      default: ""
    },
    hideDetails: {
      type: [Boolean, String],
      default: "auto"
    },
    persistentHint: {
      type: Boolean,
      default: !0
    },
    persistentCounter: {
      type: Boolean,
      default: !0
    },
    placeholder: {
      type: String,
      default: ""
    },
    rules: {
      type: Array,
      validator: h.isArrayOfOneOf(["str", "bool", "fn"], "rules"),
      default: () => []
    },
    prependIconName: {
      type: String,
      validator: h.isIncludeValues(Ye, "prependIconName"),
      default: ""
    },
    appendIconName: {
      type: String,
      validator: h.isIncludeValues(Ye, "appendIconName"),
      default: ""
    },
    isInputLtr: {
      type: Boolean,
      default: !1
    },
    validateOn: {
      type: String,
      default: "input"
    }
  },
  emits: ["update:modelValue", "focus", "click-append"],
  setup(e) {
    const t = $(() => z(e.appendIconName)), n = $(() => z(e.prependIconName));
    return {
      appendIcon: t,
      prependIcon: n,
      colorLabel: I(C.GRAY, 80),
      clearIcon: z("close")
    };
  }
};
function cr(e, t, n, r, l, d) {
  const i = _("v-textarea");
  return a(), k(i, {
    "model-value": n.modelValue,
    class: "app-textarea",
    variant: "solo",
    autofocus: n.autofocus,
    "clear-icon": r.clearIcon,
    clearable: n.clearable,
    color: r.colorLabel,
    disabled: n.disabled,
    "error-messages": n.errorMessage,
    "auto-grow": n.autoGrow,
    messages: n.message,
    "persistent-hint": n.persistentHint,
    "persistent-counter": n.persistentCounter,
    hint: n.hint,
    "hide-details": n.hideDetails,
    placeholder: n.placeholder,
    rules: n.rules,
    "prepend-inner-icon": r.prependIcon,
    "append-inner-icon": r.appendIcon,
    loading: n.loading,
    counter: n.counter,
    label: n.label,
    density: "comfortable",
    flat: !0,
    reverse: n.isInputLtr,
    "validate-on": n.validateOn,
    "onUpdate:focused": t[0] || (t[0] = (s) => e.$emit("focus")),
    "onClick:appendInner": t[1] || (t[1] = (s) => e.$emit("click-append", s)),
    "onUpdate:modelValue": t[2] || (t[2] = (s) => e.$emit("update:modelValue", s))
  }, null, 8, ["model-value", "autofocus", "clear-icon", "clearable", "color", "disabled", "error-messages", "auto-grow", "messages", "persistent-hint", "persistent-counter", "hint", "hide-details", "placeholder", "rules", "prepend-inner-icon", "append-inner-icon", "loading", "counter", "label", "reverse", "validate-on"]);
}
const z7 = /* @__PURE__ */ u(sr, [["render", cr]]), ur = {
  // https://vuetifyjs.com/en/components/lists/
  components: {
    AppDivider: mn,
    AppText: R,
    AppListItem: Ae
  },
  props: {
    items: {
      type: Array,
      required: !0,
      validator: h.isArrayOf("items").obj
    },
    title: {
      type: String,
      default: ""
    }
  },
  setup() {
    const e = w([]), t = w(!1), { isRtl: n } = o1(), r = $(() => z(n.value ? "arrow-right" : "arrow-left")), l = () => {
      t.value = !t.value;
    };
    return {
      sublist: e,
      isSublistVisible: t,
      iconArrow: r,
      toggleList: l,
      handleClickEvent: (i) => {
        i.sublist && (e.value = i.sublist, l());
      }
    };
  }
}, fr = {
  key: 0,
  class: "app-list__main"
}, pr = {
  key: 1,
  class: "app-list__sub"
};
function $r(e, t, n, r, l, d) {
  const i = _("app-text"), s = _("app-divider"), f = _("app-list-item"), p = _("v-list");
  return a(), k(p, { class: "app-list d-flex pt-3 px-4 pb-4 rounded-md flex-column" }, {
    default: g(() => [
      r.isSublistVisible ? (a(), c("div", pr, [
        b(f, {
          "prepend-icon": r.iconArrow,
          onClick: r.toggleList
        }, {
          default: g(() => [
            b(i, {
              color: "gray",
              variant: "caption"
            }, {
              default: g(() => [
                D(O(r.sublist.title), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["prepend-icon", "onClick"]),
        b(s, { class: "my-1" }),
        (a(!0), c(t1, null, c1(r.sublist.items, (v) => (a(), c("div", {
          key: v.id,
          class: "app-list__subitem"
        }, [
          x(e.$slots, "default", { item: v })
        ]))), 128))
      ])) : (a(), c("div", fr, [
        n.title ? (a(), c(t1, { key: 0 }, [
          b(i, {
            class: "ma-0 py-3 px-2",
            color: "gray",
            variant: "caption",
            display: "block"
          }, {
            default: g(() => [
              D(O(n.title), 1)
            ]),
            _: 1
          }),
          b(s, { class: "my-1" })
        ], 64)) : A("", !0),
        (a(!0), c(t1, null, c1(n.items, (v) => (a(), c("div", {
          key: v.id,
          class: "app-list__item"
        }, [
          x(e.$slots, "default", {
            item: v,
            onClick: () => r.handleClickEvent(v)
          })
        ]))), 128))
      ]))
    ]),
    _: 3
  });
}
const Cr = /* @__PURE__ */ u(ur, [["render", $r]]), _r = {
  [M.XS]: 16,
  [M.S]: 20,
  [M.M]: 25,
  [M.L]: 31,
  [M.XL]: 38,
  [M.XXL]: 44
}, gr = {
  // https://vuetifyjs.com/en/components/progress-circular/
  name: "app-spinner",
  props: {
    color: {
      type: String,
      default: C.PRIMARY,
      validator: v1
    },
    size: {
      type: String,
      default: M.XS,
      validator: h.isIncludeValues(Object.values(M), "size")
    }
  },
  setup(e) {
    return {
      interpretedSize: $(() => _r[e.size])
    };
  }
};
function yr(e, t, n, r, l, d) {
  const i = _("v-progress-circular");
  return a(), k(i, {
    color: n.color,
    size: r.interpretedSize,
    width: 2,
    indeterminate: !0
  }, null, 8, ["color", "size"]);
}
const Et = /* @__PURE__ */ u(gr, [["render", yr]]), mr = {
  name: "app-preloader",
  components: {
    AppSpinner: Et,
    AppText: R
  },
  props: {
    isLoading: {
      type: Boolean,
      default: !0
    },
    isLoaded: {
      type: Boolean,
      default: !1
    },
    hasError: {
      type: Boolean,
      default: !1
    },
    isCentered: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const t = $(() => [
      "app-preloader",
      e.isCentered ? "text-center align-center" : ""
    ]), n = $(() => !e.hasError && e.isLoading), r = $(() => !e.hasError && !e.isLoading && e.isLoaded);
    return {
      rootClasses: t,
      isLoadingVisible: n,
      isLoadedVisible: r
    };
  }
};
function hr(e, t, n, r, l, d) {
  const i = _("app-spinner"), s = _("app-text");
  return a(), c("div", {
    class: T(r.rootClasses)
  }, [
    r.isLoadingVisible ? (a(), k(i, {
      key: 0,
      size: "xxl"
    })) : A("", !0),
    n.hasError ? (a(), k(s, { key: 1 }, {
      default: g(() => t[0] || (t[0] = [
        D(" something went wrong please try again later... ")
      ])),
      _: 1
    })) : A("", !0),
    r.isLoadedVisible ? x(e.$slots, "default", { key: 2 }) : A("", !0)
  ], 2);
}
const F7 = /* @__PURE__ */ u(mr, [["render", hr]]), vr = {
  name: "app-preloading",
  components: {
    AppSpinnerDot: le
  },
  props: {
    isLoading: {
      type: Boolean,
      default: !0
    },
    isCentered: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    return {
      spinnerClasses: $(() => [
        "d-block",
        e.isCentered ? "mx-auto" : ""
      ])
    };
  }
}, br = { class: "app-preloading" };
function Ir(e, t, n, r, l, d) {
  const i = _("app-spinner-dot");
  return a(), c("div", br, [
    n.isLoading ? (a(), k(i, {
      key: 0,
      class: T(r.spinnerClasses),
      size: "m"
    }, null, 8, ["class"])) : x(e.$slots, "default", { key: 1 })
  ]);
}
const U7 = /* @__PURE__ */ u(vr, [["render", Ir]]);
const Mr = {
  name: "app-progress-linear",
  props: {
    color: {
      type: String,
      validator: v1,
      default: C.LINK
    },
    bgColor: {
      type: String,
      default: I(C.LINK, 40),
      validator: v1
    },
    bgOpacity: {
      type: [Number, String],
      default: 0.12
      // from vuetify
    },
    value: {
      type: Number,
      required: !0
    },
    height: {
      type: Number,
      default: 4
    }
  }
};
function kr(e, t, n, r, l, d) {
  const i = _("v-progress-linear");
  return a(), k(i, {
    class: "app-progress-linear rounded-md",
    "model-value": n.value,
    color: n.color,
    "bg-color": n.bgColor,
    "bg-opacity": n.bgOpacity,
    height: n.height
  }, null, 8, ["model-value", "color", "bg-color", "bg-opacity", "height"]);
}
const xr = /* @__PURE__ */ u(Mr, [["render", kr], ["__scopeId", "data-v-089ea174"]]);
const Nr = {
  name: "app-select",
  components: {
    AppText: R,
    AppSpinner: Et,
    AppListItem: Ae
  },
  props: {
    modelValue: {
      type: [String, Number, Object],
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !1
    },
    returnObject: {
      type: Boolean,
      default: !1
    },
    description: {
      type: String,
      default: ""
    },
    errorMessage: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    rules: {
      type: Array,
      validator: h.isArrayOf("rules").fn,
      default: () => []
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    itemValue: {
      type: String,
      default: "value"
    },
    itemTitle: {
      type: String,
      default: "title"
    },
    customMenuProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = w(e.modelValue), r = $(() => ({ "mt-3": e.label })), l = $(() => {
      const p = {
        transition: "scroll-y-transition",
        contentClass: "app-select__list",
        offset: 8,
        ...e.customMenuProps
      };
      return e.loading ? { modelValue: !1, ...p } : p;
    }), d = (p) => e.returnObject && n.value ? p.value === n.value[e.itemValue] : p.value === n.value, i = (p) => {
      n.value = p, t("update:modelValue", p);
    }, s = $(
      () => e.errorMessage ? I(C.ERROR, 80) : I(C.GRAY, 60)
    ), f = $(
      () => n.value ? "app-select--dirty" : "app-select--no-dirty"
    );
    return {
      textVariant: Z.CAPTION,
      menuIcon: z("arrow-small-down"),
      closeIcon: z("close"),
      inputModel: n,
      selectionClass: r,
      menuProps: l,
      isSelected: d,
      updateValue: i,
      messageColor: s,
      dirtyClass: f
    };
  }
}, Sr = ["data-qa-value", "data-qa-value-2"];
function Lr(e, t, n, r, l, d) {
  const i = _("app-spinner"), s = _("app-text"), f = _("app-list-item"), p = _("v-select");
  return a(), k(p, {
    "model-value": r.inputModel,
    class: T(["app-select", r.dirtyClass]),
    items: n.items,
    "menu-props": r.menuProps,
    "menu-icon": r.menuIcon,
    "return-object": n.returnObject,
    flat: !1,
    hint: n.description,
    "persistent-hint": !0,
    "error-messages": n.errorMessage,
    messages: n.message,
    rules: n.rules,
    clearable: n.clearable,
    "item-title": n.itemTitle,
    "item-value": n.itemValue,
    label: n.label,
    "clear-icon": r.closeIcon,
    rounded: "lg",
    density: "comfortable",
    variant: "solo",
    "onUpdate:modelValue": r.updateValue
  }, j1({
    "prepend-inner": g(() => [
      x(e.$slots, "prepend-inner", {}, void 0, !0)
    ]),
    "append-inner": g(() => [
      n.loading ? (a(), k(i, {
        key: 0,
        class: "ms-auto"
      })) : A("", !0)
    ]),
    selection: g(({ item: v }) => [
      x(e.$slots, "selection", {
        item: v.raw
      }, () => [
        b(s, { variant: r.textVariant }, {
          default: g(() => [
            D(O(v.title), 1)
          ]),
          _: 2
        }, 1032, ["variant"])
      ], !0)
    ]),
    message: g(() => [
      b(s, {
        class: "mt-2",
        display: "block",
        variant: "caption-2",
        color: r.messageColor
      }, {
        default: g(() => [
          D(O(n.errorMessage || n.message), 1)
        ]),
        _: 1
      }, 8, ["color"])
    ]),
    _: 2
  }, [
    n.loading ? void 0 : {
      name: "item",
      fn: g(({ props: v, item: y }) => [
        o("div", {
          class: "app-select__item",
          "data-qa-key": "select-item",
          "data-qa-value": y == null ? void 0 : y.value,
          "data-qa-value-2": y == null ? void 0 : y.title
        }, [
          b(f, U(v, {
            class: "app-select__item",
            selected: r.isSelected(y)
          }), {
            default: g(() => [
              x(e.$slots, "item", { item: y }, () => [
                b(s, { variant: r.textVariant }, {
                  default: g(() => [
                    D(O(y.title), 1)
                  ]),
                  _: 2
                }, 1032, ["variant"])
              ], !0)
            ]),
            _: 2
          }, 1040, ["selected"])
        ], 8, Sr)
      ]),
      key: "0"
    }
  ]), 1032, ["model-value", "class", "items", "menu-props", "menu-icon", "return-object", "hint", "error-messages", "messages", "rules", "clearable", "item-title", "item-value", "label", "clear-icon", "onUpdate:modelValue"]);
}
const Z7 = /* @__PURE__ */ u(Nr, [["render", Lr], ["__scopeId", "data-v-a52f96fb"]]), Ar = (e, t) => t.every((n) => n in e && e[n] !== null), wr = (e, t) => e.every((n) => Ar(n, t)) || console.error(`The prop '${t.join(", ")}' is required, but is not present in the passed object.`), Or = ["title", "value"], Tr = {
  name: "app-table-display-header",
  components: {
    AppText: R,
    AppCol: j0,
    AppRow: z0
  },
  props: {
    headers: {
      type: Array,
      required: !0,
      validator: (e) => wr(e, Or)
    }
  },
  setup() {
    const e = $(() => {
      const n = "app-table-display-header";
      return (r = "center") => [
        `${n}__column`,
        `text-${r}`
      ];
    }), t = $(() => (n) => n === "right" ? "end" : n === "left" ? "start" : "center");
    return {
      captionTextVariants: Z.CAPTION,
      colorName: I(C.GRAY, 90),
      headerClasses: e,
      rowClasses: t
    };
  }
}, Dr = { class: "header__row" };
function Er(e, t, n, r, l, d) {
  const i = _("app-text"), s = _("app-col"), f = _("app-row");
  return a(), c("tr", Dr, [
    (a(!0), c(t1, null, c1(n.headers, (p) => (a(), c("th", {
      key: p.value,
      class: "header__cell py-3 px-0"
    }, [
      b(f, {
        dense: !0,
        class: "me-0 flex-nowrap",
        align: "center",
        justify: r.rowClasses(p.align)
      }, {
        default: g(() => [
          b(s, {
            cols: "auto",
            class: T(r.headerClasses(p.align))
          }, {
            default: g(() => [
              b(i, {
                variant: r.captionTextVariants,
                color: r.colorName
              }, {
                default: g(() => [
                  D(O(p.title), 1)
                ]),
                _: 2
              }, 1032, ["variant", "color"])
            ]),
            _: 2
          }, 1032, ["class"])
        ]),
        _: 2
      }, 1032, ["justify"])
    ]))), 128))
  ]);
}
const Vr = /* @__PURE__ */ u(Tr, [["render", Er]]);
const jr = {
  // https://vuetifyjs.com/en/components/data-tables/
  name: "app-table-display",
  components: {
    AppTableDisplayHeader: Vr
  },
  props: {
    headers: {
      type: Array,
      required: !0
    },
    items: {
      type: Array,
      required: !0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    noDataText: {
      type: String,
      default: "No data available"
    }
  }
};
function Pr(e, t, n, r, l, d) {
  const i = _("app-table-display-header"), s = _("v-data-table");
  return a(), k(s, {
    class: "app-table-display",
    headers: n.headers,
    items: n.items,
    loading: n.loading,
    "items-per-page": -1,
    "no-data-text": n.noDataText,
    density: "comfortable"
  }, {
    headers: g(({ headers: f }) => [
      b(i, {
        headers: f[0]
      }, null, 8, ["headers"])
    ]),
    item: g(({ item: f }) => [
      x(e.$slots, "item", { item: f }, void 0, !0)
    ]),
    bottom: g(() => [
      x(e.$slots, "bottom", {}, void 0, !0)
    ]),
    _: 3
  }, 8, ["headers", "items", "loading", "no-data-text"]);
}
const G7 = /* @__PURE__ */ u(jr, [["render", Pr], ["__scopeId", "data-v-66bdc40d"]]);
const Hr = {
  variant: Z.BUTTON,
  weight: T1.MEDIUM,
  class: "text-capitalize"
}, Rr = {
  name: "app-table-tabs",
  components: {
    AppText: R,
    AppTitle: Le
  },
  props: {
    tabs: {
      type: Array,
      required: !0,
      validator: h.isArrayOf("tabs").obj
    },
    title: {
      type: String,
      default: ""
    },
    modelValue: {
      type: String,
      default: ""
    },
    alignRight: {
      type: Boolean,
      default: !0
    },
    mandatory: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = (d) => t("update:modelValue", d), r = w(e.modelValue || e.tabs[0].key), l = $(() => ({
      bgColor: C.TRANSPARENT,
      color: C.WHITE,
      alignTabs: e.alignRight ? "end" : "start",
      mandatory: e.mandatory
    }));
    return {
      eventEmit: n,
      activeTab: r,
      propsVTabs: l,
      appTextProps: Hr
    };
  }
}, Br = { class: "d-flex app-table-tab__wrapper" };
function zr(e, t, n, r, l, d) {
  const i = _("app-title"), s = _("app-text"), f = _("v-tab"), p = _("v-tabs");
  return a(), k(p, U({
    modelValue: r.activeTab,
    "onUpdate:modelValue": t[0] || (t[0] = (v) => r.activeTab = v),
    class: "app-table-tabs",
    "hide-slider": !0
  }, r.propsVTabs, { "onUpdate:modelValue": r.eventEmit }), {
    default: g(() => [
      n.title ? (a(), k(i, {
        key: 0,
        level: 2,
        class: "flex-shrink-0"
      }, {
        default: g(() => [
          D(O(n.title), 1)
        ]),
        _: 1
      })) : A("", !0),
      o("div", Br, [
        (a(!0), c(t1, null, c1(n.tabs, ({ key: v, text: y }) => (a(), k(f, {
          key: v,
          value: v,
          ripple: !1,
          variant: "flat",
          class: "app-table-tab",
          "selected-class": "active-tab",
          tabindex: "0"
        }, {
          default: g(() => [
            b(s, U({ ref_for: !0 }, r.appTextProps), {
              default: g(() => [
                D(O(y), 1)
              ]),
              _: 2
            }, 1040)
          ]),
          _: 2
        }, 1032, ["value"]))), 128))
      ])
    ]),
    _: 1
  }, 16, ["modelValue", "onUpdate:modelValue"]);
}
const Y7 = /* @__PURE__ */ u(Rr, [["render", zr], ["__scopeId", "data-v-62a27f65"]]);
const Fr = {
  name: "app-tooltip-icon",
  components: {
    AppTooltip: Tt,
    AppIcon: G
  },
  props: {
    icon: {
      type: String,
      validator: h.isIncludeValues(n1, "icon"),
      required: !0
    },
    iconColor: {
      type: String,
      validator: v1,
      default: I(C.GRAY, 80)
    },
    iconSize: {
      type: String,
      validator: h.isIncludeValues(Object.values(M), "size"),
      default: M.S
    },
    maxWidth: {
      type: Number,
      default: 180
    },
    showByClick: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: M1.BOTTOM,
      validator: h.isIncludeValues(Object.values(M1), "position")
    },
    offset: {
      type: Number,
      default: 4
    },
    closeDelay: {
      type: Number,
      default: 300
    }
  },
  emits: ["visibility-change"]
}, Ur = { class: "app-tooltip-icon d-inline-flex justify-center align-center" };
function Zr(e, t, n, r, l, d) {
  const i = _("app-icon"), s = _("app-tooltip");
  return a(), c("div", Ur, [
    x(e.$slots, "prepend", {}, void 0, !0),
    b(s, {
      "max-width": n.maxWidth,
      "show-by-click": n.showByClick,
      offset: n.offset,
      "close-delay": n.closeDelay,
      onVisibilityChange: t[0] || (t[0] = (f) => e.$emit("visibility-change", f))
    }, {
      "tooltip-activator": g(() => [
        b(i, {
          icon: n.icon,
          size: n.iconSize,
          color: n.iconColor
        }, null, 8, ["icon", "size", "color"])
      ]),
      default: g(() => [
        x(e.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["max-width", "show-by-click", "offset", "close-delay"]),
    x(e.$slots, "append", {}, void 0, !0)
  ]);
}
const W7 = /* @__PURE__ */ u(Fr, [["render", Zr], ["__scopeId", "data-v-5ae19dca"]]), Ce = {
  BASIC: "basic",
  GOLD: "gold"
}, Gr = "data:image/svg+xml;base64,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", Yr = "data:image/svg+xml;base64,PHN2ZwogIHZpZXdCb3g9IjAgMCA0OCA0OCIKICBmaWxsPSJub25lIgogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKPgogIDxwYXRoCiAgICBkPSJNMTcuOTQ5NyA1LjMzNDMyTDQuMDMwOTggNDMuMzQ3N0MzLjkxMTg0IDQzLjY0NDIgNC4xNTAyMiA0NCA0LjUwNzg0IDQ0SDcuNzU2NTVDOC4zODI0MiA0NCA4Ljk0ODcyIDQzLjYxNDUgOS4xNTc0MSA0My4wMjE1TDIwLjg3MDUgMTAuOTA4OEMyMS4wNDkzIDEwLjQ2NDEgMjEuNjc1MiAxMC40NjQxIDIxLjgyNDIgMTAuOTA4OEwyNy42OTU4IDI2Ljk4SDE4LjA2ODlDMTcuNDQzIDI2Ljk4IDE2Ljg3NjcgMjcuMzY1NSAxNi42NjgxIDI3Ljk1ODVMMTUuNDQ2MSAzMS4zMDkxQzE1LjMyNjkgMzEuNjA1NyAxNS41NjU0IDMxLjk2MTUgMTUuOTIzIDMxLjk2MTVIMjkuNTQzNkwzMC4yODg3IDMzLjk0ODJIMTUuNTM1NUMxNC45MDk2IDMzLjk0ODIgMTQuMzQzMyAzNC4zMzM2IDE0LjEzNDcgMzQuOTI2NkwxMi45MTI4IDM4LjI3NzJDMTIuNzkzNSAzOC41NzM3IDEzLjAzMiAzOC45Mjk2IDEzLjM4OTYgMzguOTI5NkgzMi4xMzY3TDMzLjYxNzggNDMuMDE5NkMzMy44MjY1IDQzLjYxMjYgMzQuMzgyOCA0My45OTgxIDM1LjAwODcgNDMuOTk4MUw0MS4yMTg4IDQ0QzQxLjU3NjUgNDQgNDEuODE0OSA0My42NzM4IDQxLjY5NTcgNDMuMzQ3N0w0MC4wOTQ0IDM4Ljk1OTJINDMuNDkyMkM0My44NDk4IDM4Ljk1OTIgNDQuMDg4MiAzOC42MzMxIDQzLjk2OSAzOC4zMDY5TDQyLjc0NyAzNC45NTYzQzQyLjUzODQgMzQuMzYzMyA0MS45NzIxIDMzLjk3NzggNDEuMzQ2MiAzMy45Nzc4SDM4LjI3NjRMMzcuNTMxMyAzMS45OTExSDQwLjkyODlDNDEuMjg2NiAzMS45OTExIDQxLjUyNSAzMS42NjUgNDEuNDA1OCAzMS4zMzg3TDQwLjE4MzggMjcuOTg4MUMzOS45NzUyIDI3LjM5NTEgMzkuNDA4OSAyNy4wMDk3IDM4Ljc4MyAyNy4wMDk3SDM1LjcxMzFMMjcuNzg1MSA1LjMzNDMyQzI3LjQ4NzEgNC41MzM3MyAyNi43MTIyIDQgMjUuODQ3OCA0SDE5Ljg4NjlDMTkuMDIyNyA0IDE4LjI0NzggNC41MzM3MyAxNy45NDk3IDUuMzM0MzJaIgogICAgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzIwNDhfMjcpIgogIC8+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQKICAgICAgaWQ9InBhaW50MF9saW5lYXJfMjA0OF8yNyIKICAgICAgeDE9IjIzLjk5NTUiCiAgICAgIHkxPSI1LjY4MjM3IgogICAgICB4Mj0iMjMuOTk1NSIKICAgICAgeTI9IjQ2LjA5OTYiCiAgICAgIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIgogICAgPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjRjM5MjAwIiAvPgogICAgICA8c3RvcAogICAgICAgIG9mZnNldD0iMSIKICAgICAgICBzdG9wLWNvbG9yPSIjRjA3RTAwIgogICAgICAvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+Cjwvc3ZnPgo=";
const Wr = {
  name: "app-logo",
  components: {
    AppLink: J2
  },
  props: {
    to: {
      type: [String, Object],
      required: !0
    },
    logoType: {
      type: String,
      default: Ce.BASIC,
      validator: h.isIncludeValues(Object.values(Ce), "logoType")
    }
  },
  setup(e) {
    return {
      isGoldType: $(() => e.logoType === Ce.GOLD)
    };
  }
}, Qr = {
  key: 0,
  src: Gr,
  alt: "AMarkets Gold"
}, Kr = {
  key: 1,
  src: Yr,
  alt: "AMarkets"
};
function Xr(e, t, n, r, l, d) {
  const i = _("app-link");
  return a(), k(i, {
    to: n.to,
    class: "app-logo"
  }, {
    default: g(() => [
      r.isGoldType ? (a(), c("img", Qr)) : (a(), c("img", Kr))
    ]),
    _: 1
  }, 8, ["to"]);
}
const Q7 = /* @__PURE__ */ u(Wr, [["render", Xr], ["__scopeId", "data-v-c591ecc2"]]);
const qr = {
  name: "app-tips-list",
  components: {
    AppText: R,
    AppProgressLinear: xr,
    AppIcon: G
  },
  props: {
    items: {
      type: Array,
      required: !0,
      validator: h.isArrayOf("items").obj
    }
  },
  setup(e) {
    const t = $(() => e.items.length), n = $(() => e.items.filter((i) => i.success).length), r = $(() => n.value / t.value * 100), l = $(() => n.value === t.value ? I(C.SUCCESS, 80) : n.value >= t.value / 2 ? I(C.WARNING, 80) : I(C.LINK, 80)), d = (i) => i.success ? I(C.SUCCESS, 90) : I(C.GRAY, 60);
    return {
      titleTextVariant: Z.CAPTION,
      totalConditionsCount: t,
      fulfilledConditionsCount: n,
      linearBgColor: I(C.GRAY, 40),
      linearValue: r,
      linearColor: l,
      successIcon: z("tick-circle"),
      successIconColor: I(C.SUCCESS, 80),
      getItemColor: d
    };
  }
}, Jr = { class: "app-tips-list py-2" }, eo = { class: "app-tips-list__list d-flex flex-column px-0 pt-2" }, to = {
  key: 1,
  class: "app-tips-list__list-item-circle"
};
function no(e, t, n, r, l, d) {
  const i = _("app-text"), s = _("app-progress-linear"), f = _("app-icon");
  return a(), c("div", Jr, [
    b(i, { variant: r.titleTextVariant }, {
      default: g(() => [
        x(e.$slots, "title", {
          fulfilledConditionsCount: r.fulfilledConditionsCount,
          totalConditionsCount: r.totalConditionsCount
        }, void 0, !0)
      ]),
      _: 3
    }, 8, ["variant"]),
    b(s, {
      "bg-color": r.linearBgColor,
      color: r.linearColor,
      value: r.linearValue
    }, null, 8, ["bg-color", "color", "value"]),
    o("ul", eo, [
      (a(!0), c(t1, null, c1(n.items, (p) => (a(), c("li", {
        key: p.key,
        class: "app-tips-list__list-item d-flex align-center justify-start"
      }, [
        p.success ? (a(), k(f, {
          key: 0,
          icon: r.successIcon,
          color: r.successIconColor
        }, null, 8, ["icon", "color"])) : (a(), c("div", to)),
        b(i, {
          color: r.getItemColor(p)
        }, {
          default: g(() => [
            D(O(p.text), 1)
          ]),
          _: 2
        }, 1032, ["color"])
      ]))), 128))
    ])
  ]);
}
const K7 = /* @__PURE__ */ u(qr, [["render", no], ["__scopeId", "data-v-6e0d0e7d"]]);
const ro = {
  // https://vuetifyjs.com/en/components/menus/
  name: "app-menu-dropdown",
  components: {
    AppList: Cr,
    AppIcon: G
  },
  props: {
    items: {
      type: Array,
      required: !0,
      validator: h.isArrayOf("items").obj
    },
    minWidth: {
      type: Number,
      default: 297
    },
    location: {
      type: String,
      default: "bottom"
    },
    title: {
      type: String,
      default: ""
    },
    attach: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    closeOnContentClick: {
      type: Boolean,
      default: !0
    }
  },
  setup() {
    const e = w(!1), t = $(() => {
      const n = "app-menu-dropdown";
      return [
        `${n}__slot`,
        "d-flex",
        "rounded-md",
        "width-fit",
        "align-center",
        e.value ? `${n}--active` : ""
      ];
    });
    return {
      isActive: e,
      slotClasses: t
    };
  }
};
function oo(e, t, n, r, l, d) {
  const i = _("app-icon"), s = _("app-list"), f = _("v-menu");
  return a(), k(f, {
    modelValue: r.isActive,
    "onUpdate:modelValue": t[0] || (t[0] = (p) => r.isActive = p),
    class: "app-menu-dropdown",
    "content-class": "app-menu-dropdown__content",
    transition: "fade-transition",
    "min-width": n.minWidth,
    offset: 20,
    location: n.location,
    attach: n.attach,
    disabled: n.disabled,
    "close-on-content-click": n.closeOnContentClick
  }, {
    activator: g(({ props: p }) => [
      o("span", U(p, { class: r.slotClasses }), [
        x(e.$slots, "activator", {}, void 0, !0),
        b(i, {
          class: "app-menu-dropdown__icon ms-3",
          icon: "arrow-small-down",
          color: "gray"
        })
      ], 16)
    ]),
    default: g(() => [
      b(s, {
        items: n.items,
        title: n.title
      }, {
        default: g(({ item: p, onClick: v }) => [
          x(e.$slots, "default", {
            item: p,
            onClick: v
          }, void 0, !0)
        ]),
        _: 3
      }, 8, ["items", "title"])
    ]),
    _: 3
  }, 8, ["modelValue", "min-width", "location", "attach", "disabled", "close-on-content-click"]);
}
const X7 = /* @__PURE__ */ u(ro, [["render", oo], ["__scopeId", "data-v-f59a9d66"]]);
var lo = At, ao = function() {
  return lo.Date.now();
}, io = ao, so = /\s/;
function co(e) {
  for (var t = e.length; t-- && so.test(e.charAt(t)); )
    ;
  return t;
}
var uo = co, fo = uo, po = /^\s+/;
function $o(e) {
  return e && e.slice(0, fo(e) + 1).replace(po, "");
}
var Co = $o, _o = P1, go = oe, yo = "[object Symbol]";
function mo(e) {
  return typeof e == "symbol" || go(e) && _o(e) == yo;
}
var ho = mo, vo = Co, We = de, bo = ho, Qe = 0 / 0, Io = /^[-+]0x[0-9a-f]+$/i, Mo = /^0b[01]+$/i, ko = /^0o[0-7]+$/i, xo = parseInt;
function No(e) {
  if (typeof e == "number")
    return e;
  if (bo(e))
    return Qe;
  if (We(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = We(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = vo(e);
  var n = Mo.test(e);
  return n || ko.test(e) ? xo(e.slice(2), n ? 2 : 8) : Io.test(e) ? Qe : +e;
}
var So = No, Lo = de, _e = io, Ke = So, Ao = "Expected a function", wo = Math.max, Oo = Math.min;
function To(e, t, n) {
  var r, l, d, i, s, f, p = 0, v = !1, y = !1, V = !0;
  if (typeof e != "function")
    throw new TypeError(Ao);
  t = Ke(t) || 0, Lo(n) && (v = !!n.leading, y = "maxWait" in n, d = y ? wo(Ke(n.maxWait) || 0, t) : d, V = "trailing" in n ? !!n.trailing : V);
  function N(P) {
    var q = r, Q = l;
    return r = l = void 0, p = P, i = e.apply(Q, q), i;
  }
  function B(P) {
    return p = P, s = setTimeout(W, t), v ? N(P) : i;
  }
  function r1(P) {
    var q = P - f, Q = P - p, a1 = t - q;
    return y ? Oo(a1, d - Q) : a1;
  }
  function J(P) {
    var q = P - f, Q = P - p;
    return f === void 0 || q >= t || q < 0 || y && Q >= d;
  }
  function W() {
    var P = _e();
    if (J(P))
      return d1(P);
    s = setTimeout(W, r1(P));
  }
  function d1(P) {
    return s = void 0, V && r ? N(P) : (r = l = void 0, i);
  }
  function u1() {
    s !== void 0 && clearTimeout(s), p = 0, r = f = l = s = void 0;
  }
  function l1() {
    return s === void 0 ? i : d1(_e());
  }
  function X() {
    var P = _e(), q = J(P);
    if (r = arguments, l = this, f = P, q) {
      if (s === void 0)
        return B(f);
      if (y)
        return clearTimeout(s), s = setTimeout(W, t), N(f);
    }
    return s === void 0 && (s = setTimeout(W, t)), i;
  }
  return X.cancel = u1, X.flush = l1, X;
}
var Do = To;
const Eo = /* @__PURE__ */ L1(Do), Vo = Eo, Xe = {
  START: "start",
  CENTER: "center"
};
const jo = {
  name: "app-slider",
  components: { AppIcon: G },
  emits: ["update:activeSlide"],
  props: {
    slides: {
      type: Array,
      validator: h.isArrayOf("slides").obj,
      required: !0
    },
    activeSlide: {
      type: Number,
      default: 0
    },
    showNavigation: {
      type: Boolean,
      default: !0
    },
    revertNavigation: {
      type: Boolean,
      default: !1
    },
    showPagination: {
      type: Boolean,
      default: !0
    },
    cycle: {
      type: Boolean,
      default: !1
    },
    delay: {
      type: Number || null,
      default: null
    },
    scroll: {
      type: Boolean,
      default: !1
    },
    sticky: {
      type: Boolean,
      default: !1
    },
    stickyPosition: {
      type: String,
      default: Xe.CENTER,
      validator: h.isIncludeValues(Object.values(Xe), "stickyPosition")
    }
  },
  setup(e, { emit: t }) {
    const { isRtl: n } = o1(), r = w(null), l = w([]), d = w(e.cycle ? e.activeSlide + 1 : e.activeSlide), i = w(!0), s = w(null), f = w(null), p = w([]), v = $(() => e.cycle ? [
      e.slides[e.slides.length - 1],
      ...e.slides,
      e.slides[0]
    ] : e.slides), y = $(() => e.sticky && e.scroll);
    let V = null;
    const N = $(() => {
      const S = p.value;
      if (!Array.isArray(S) || !S.length)
        return 0;
      const j = S.find((p1) => p1.isIntersecting);
      return j ? j.index : 0;
    }), B = $(() => y.value || e.scroll ? {} : {
      transform: n.value ? `translateX(${100 * d.value}%)` : `translateX(${100 * -d.value}%)`
    }), r1 = $(() => [
      "app-slider__wrapper d-flex w-100 h-100",
      `app-slider__wrapper--sticky-${e.stickyPosition}`,
      {
        "app-slider__wrapper--scroll": e.scroll,
        "app-slider__wrapper--sticky": e.sticky
      }
    ]), J = (S) => {
      S && l.value.push(S);
    }, W = (S) => {
      !e.delay || !e.cycle || e.scroll || (f.value = setInterval(() => {
        S();
      }, e.delay));
    }, d1 = () => {
      f.value && (clearInterval(f.value), f.value = null);
    }, u1 = (S) => {
      const j = l.value.find((x1, R1) => R1 === S), p1 = n.value ? j.offsetWidth * S * -1 : j.offsetLeft;
      r.value.scrollTo({
        left: p1,
        behavior: "smooth"
      });
    }, l1 = (S) => {
      const j = p.value.find((x1) => x1.index === S);
      if (!j) {
        u1(S);
        return;
      }
      const p1 = n.value ? j.target.offsetWidth * S * -1 : j.target.offsetLeft;
      r.value.scrollTo({
        left: p1,
        behavior: "smooth"
      });
    }, X = () => {
      if (y.value) {
        l1(N.value + 1);
        return;
      }
      if (!i.value || e.scroll)
        return;
      const S = e.cycle ? v.value.length - 2 : v.value.length - 1, j = d.value === S;
      j && !e.cycle || (d.value += 1, e.cycle ? d.value - 1 < e.slides.length && t("update:activeSlide", d.value - 1) : t("update:activeSlide", d.value), d1(), W(X), j && e.cycle && (i.value = !1, s.value = 1));
    }, P = () => {
      if (y.value) {
        l1(N.value - 1);
        return;
      }
      if (!i.value || e.scroll)
        return;
      const S = e.cycle ? 1 : 0, j = d.value === S;
      j && !e.cycle || (d.value -= 1, e.cycle && d.value - 1 >= 0 ? t("update:activeSlide", d.value - 1) : t("update:activeSlide", d.value), d1(), W(X), j && e.cycle && (i.value = !1, s.value = v.value.length - 2));
    }, q = (S) => {
      if (y.value) {
        l1(S);
        return;
      }
      e.scroll || (d.value = S, t("update:activeSlide", e.cycle ? d.value - 1 : d.value), d1(), W(X));
    }, Q = () => {
      if (e.revertNavigation) {
        P();
        return;
      }
      X();
    }, a1 = () => {
      if (e.revertNavigation) {
        X();
        return;
      }
      P();
    }, ce = (S) => y.value ? N.value === S - 1 : e.cycle ? S === d.value : S - 1 === d.value, ue = (S) => {
      q(e.cycle ? S : S - 1);
    }, A1 = () => {
      if (i.value)
        return;
      r.value.style.transition = "none", q(s.value);
      const S = setTimeout(() => {
        r.value.style.transition = "", i.value = !0, clearTimeout(S);
      }, 100);
    }, I1 = Vo((S) => {
      if (p.value && p.value.length) {
        S.forEach((j) => {
          const p1 = p.value.find((x1) => x1.index === Number(j.target.dataset.index));
          p1.isIntersecting = j.isIntersecting;
        }), N.value >= 0 && t("update:activeSlide", N.value);
        return;
      }
      p.value = S.map((j) => ({
        isIntersecting: j.isIntersecting,
        target: j.target,
        index: Number(j.target.dataset.index)
      })), N.value >= 0 && t("update:activeSlide", N.value);
    }), f1 = () => {
      !y.value || !r.value || (V = new IntersectionObserver(I1, {
        root: r.value,
        threshold: 0.25
      }), l.value.forEach((S) => {
        V.observe(S);
      }), e.activeSlide && l1(e.activeSlide));
    }, fe = () => {
      V && (l.value.forEach((S) => {
        V.unobserve(S);
      }), V = null);
    };
    return Lt(() => {
      W(X), f1(), e.scroll && e.activeSlide && u1(e.activeSlide), e.cycle && r.value.addEventListener("transitionend", A1);
    }), St(() => {
      d1(), fe(), r.value && (r.value.removeEventListener("transitionend", A1), r.value.removeEventListener("scroll", I1));
    }), h1(() => e.activeSlide, (S) => {
      if (y.value)
        return;
      const j = e.cycle ? S + 1 : S;
      j !== d.value && j >= 0 && j < v.value.length && q(j);
    }), {
      prevIconName: z("chevron-left"),
      nextIconName: z("chevron-right"),
      sliderWrapperElem: r,
      localActiveSlide: y.value ? N : d,
      localSlides: v,
      sliderPositionStyle: B,
      sliderWrapperClasses: r1,
      addSlideElem: J,
      clickOnNext: Q,
      clickOnPrev: a1,
      isActivePagination: ce,
      clickOnPagination: ue
    };
  }
}, Po = { class: "app-slider pb-8 pb-md-0" }, Ho = { class: "d-flex h-100" }, Ro = { class: "app-slider__slider w-100" }, Bo = ["data-index"], zo = { class: "app-slider__pagination d-flex ga-2" }, Fo = ["onClick"];
function Uo(e, t, n, r, l, d) {
  const i = _("app-icon"), s = ne("touch");
  return a(), c("div", Po, [
    o("div", Ho, [
      n.showNavigation ? x(e.$slots, "prev", {
        key: 0,
        goToPrev: r.clickOnPrev,
        goToNext: r.clickOnNext
      }, () => [
        b(i, {
          class: "app-slider__prev",
          icon: r.prevIconName,
          onClick: r.clickOnPrev
        }, null, 8, ["icon", "onClick"])
      ], !0) : A("", !0),
      o("div", Ro, [
        S1((a(), c("div", {
          ref: "sliderWrapperElem",
          class: T(r.sliderWrapperClasses),
          style: ke(r.sliderPositionStyle)
        }, [
          e.$slots.prepend && n.scroll && n.sticky ? (a(), c("div", {
            key: 0,
            ref: r.addSlideElem,
            class: "app-slider__slide flex-shrink-1",
            "data-index": -1
          }, [
            x(e.$slots, "prepend", {}, void 0, !0)
          ], 512)) : A("", !0),
          (a(!0), c(t1, null, c1(r.localSlides, (f, p) => (a(), c("div", {
            key: p,
            ref_for: !0,
            ref: r.addSlideElem,
            class: T([
              "app-slider__slide",
              {
                "w-100": !n.scroll,
                "flex-shrink-0": !n.scroll,
                "flex-shrink-1": n.scroll
              }
            ]),
            "data-index": p
          }, [
            x(e.$slots, "slide", {
              slide: f,
              index: p,
              isActive: p === r.localActiveSlide
            }, void 0, !0)
          ], 10, Bo))), 128))
        ], 6)), [
          [s, { left: r.clickOnNext, right: r.clickOnPrev }]
        ])
      ]),
      n.showNavigation ? x(e.$slots, "next", {
        key: 1,
        goToNext: r.clickOnNext,
        goToPrev: r.clickOnPrev
      }, () => [
        b(i, {
          class: "app-slider__next",
          icon: r.nextIconName,
          onClick: r.clickOnNext
        }, null, 8, ["icon", "onClick"])
      ], !0) : A("", !0)
    ]),
    n.showPagination ? x(e.$slots, "pagination", {
      key: 0,
      isActivePagination: r.isActivePagination,
      clickOnPagination: r.clickOnPagination
    }, () => [
      o("div", zo, [
        (a(!0), c(t1, null, c1(n.slides.length, (f) => (a(), c("div", {
          key: f,
          class: T([
            "app-slider__pagination-item",
            { "app-slider__pagination-item--active": r.isActivePagination(f) }
          ]),
          "aria-hidden": "true",
          onClick: (p) => r.clickOnPagination(f)
        }, null, 10, Fo))), 128))
      ])
    ], !0) : A("", !0)
  ]);
}
const q7 = /* @__PURE__ */ u(jo, [["render", Uo], ["__scopeId", "data-v-f2a66e5b"]]), Zo = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[047]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:395|76[018])\\d{5}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-79]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|3[178]|50|68|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0(4(?:[14]4|56)|[579])?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[189]"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-579])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-246-9])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|97"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d\\d|606)\\d{5}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1289]|5[3-579]|6[0-489]|7[08]|8[0-689]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:395|76[018])\\d{5}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([3-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|(?:[235-8]\\d|99)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29[1289]|389)", "529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5293[01]\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|9[0-289])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[0189]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"], ["80\\d{7}"], ["89\\d{7}"], 0, 0, 0, 0, ["592(?:4[0-2]|93)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:395|76[018])\\d{5}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "1(?:(?:[27]2|44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[04]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]|59"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[47]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-579]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|[89]0", "50(?:[0367]|88)|[89]0"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[59]|80"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7|86"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-3]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:0[0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|6[0-6]|7[0-27]|8[0-8]|9[0-479]))|9(?:399[0-2]|4790|76(?:2[27]|3[0-37]|9\\d)))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, 0, ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-6]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3478]|64|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "(?:00|[1-57-9]\\d)\\d{7}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:47220[01]|5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|4[46]))|57200))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "(?:0004|4)\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [7, 8, 10, 13], [["(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "810", "(?:33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[35-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "(?:(?:(?:26|63)9|80\\d)\\d\\d|93980)\\d{4}", [9], 0, "0", 0, 0, 0, 0, "269|63|9398"], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "[0-36-9]\\d{8}", [9], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[013-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function Vt(e, t) {
  var n = Array.prototype.slice.call(t);
  return n.push(Zo), e.apply(this, n);
}
function ve(e) {
  "@babel/helpers - typeof";
  return ve = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ve(e);
}
function qe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Go(e, t, n) {
  return t && qe(e.prototype, t), n && qe(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Yo(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Wo(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && E1(e, t);
}
function Qo(e) {
  var t = Pt();
  return function() {
    var r = V1(e), l;
    if (t) {
      var d = V1(this).constructor;
      l = Reflect.construct(r, arguments, d);
    } else
      l = r.apply(this, arguments);
    return Ko(this, l);
  };
}
function Ko(e, t) {
  if (t && (ve(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return jt(e);
}
function jt(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function be(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return be = function(r) {
    if (r === null || !Xo(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r))
        return t.get(r);
      t.set(r, l);
    }
    function l() {
      return Q1(r, arguments, V1(this).constructor);
    }
    return l.prototype = Object.create(r.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), E1(l, r);
  }, be(e);
}
function Q1(e, t, n) {
  return Pt() ? Q1 = Reflect.construct : Q1 = function(l, d, i) {
    var s = [null];
    s.push.apply(s, d);
    var f = Function.bind.apply(l, s), p = new f();
    return i && E1(p, i.prototype), p;
  }, Q1.apply(null, arguments);
}
function Pt() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Xo(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function E1(e, t) {
  return E1 = Object.setPrototypeOf || function(r, l) {
    return r.__proto__ = l, r;
  }, E1(e, t);
}
function V1(e) {
  return V1 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, V1(e);
}
var C1 = /* @__PURE__ */ function(e) {
  Wo(n, e);
  var t = Qo(n);
  function n(r) {
    var l;
    return Yo(this, n), l = t.call(this, r), Object.setPrototypeOf(jt(l), n.prototype), l.name = l.constructor.name, l;
  }
  return Go(n);
}(/* @__PURE__ */ be(Error)), we = 2, qo = 17, Jo = 3, b1 = "0-9０-９٠-٩۰-۹", ed = "-‐-―−ー－", td = "／/", nd = "．.", rd = "  ­​⁠　", od = "()（）［］\\[\\]", dd = "~⁓∼～", J1 = "".concat(ed).concat(td).concat(nd).concat(rd).concat(od).concat(dd), Oe = "+＋";
function Je(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var n = e[0].split("."), r = t[0].split("."), l = 0; l < 3; l++) {
    var d = Number(n[l]), i = Number(r[l]);
    if (d > i)
      return 1;
    if (i > d)
      return -1;
    if (!isNaN(d) && isNaN(i))
      return 1;
    if (isNaN(d) && !isNaN(i))
      return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
function ee(e) {
  "@babel/helpers - typeof";
  return ee = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ee(e);
}
function ae(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function et(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function ie(e, t, n) {
  return t && et(e.prototype, t), n && et(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var ld = "1.2.0", ad = "1.7.35", tt = " ext. ", id = /^\d+$/, Y = /* @__PURE__ */ function() {
  function e(t) {
    ae(this, e), fd(t), this.metadata = t, Ht.call(this, t);
  }
  return ie(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var r = this.countryCallingCodes()[n];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, r) {
      if (n && id.test(n) && (r = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new nt(this.getCountryMetadata(n), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new nt(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var r = this.countryCallingCodes()[n];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var r = this.getCountryCodesForCallingCode(n);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var r = this.getCountryCodeForCallingCode(n);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var l = this.nonGeographic()[n];
        if (l)
          return l;
      } else {
        var d = this.countryCallingCodes()[n];
        if (d && d.length === 1 && d[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), nt = /* @__PURE__ */ function() {
  function e(t, n) {
    ae(this, e), this.globalMetadataObject = n, this.metadata = t, Ht.call(this, n.metadata);
  }
  return ie(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(l) {
        return new sd(l, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && rt(this.types(), n))
        return new ud(rt(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? tt : this.metadata[13] || tt;
    }
  }]), e;
}(), sd = /* @__PURE__ */ function() {
  function e(t, n) {
    ae(this, e), this._format = t, this.metadata = n;
  }
  return ie(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !cd.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), cd = /^\(?\$1\)?$/, ud = /* @__PURE__ */ function() {
  function e(t, n) {
    ae(this, e), this.type = t, this.metadata = n;
  }
  return ie(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function rt(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function fd(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!ge(e) || !ge(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(ge(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + pd(e) + ": " + e, "."));
}
var ge = function(t) {
  return ee(t) === "object";
}, pd = function(t) {
  return ee(t);
};
function Te(e, t) {
  if (t = new Y(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function $d(e, t) {
  return t.countries[e] !== void 0;
}
function Ht(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? Je(t, ld) === -1 ? this.v2 = !0 : Je(t, ad) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var Cd = ";ext=", N1 = function(t) {
  return "([".concat(b1, "]{1,").concat(t, "})");
};
function Rt(e) {
  var t = "20", n = "15", r = "9", l = "6", d = "[  \\t,]*", i = "[:\\.．]?[  \\t,-]*", s = "#?", f = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", p = "(?:[xｘ#＃~～]|int|ｉｎｔ)", v = "[- ]+", y = "[  \\t]*", V = "(?:,{2}|;)", N = Cd + N1(t), B = d + f + i + N1(t) + s, r1 = d + p + i + N1(r) + s, J = v + N1(l) + "#", W = y + V + i + N1(n) + s, d1 = y + "(?:,)+" + i + N1(r) + s;
  return N + "|" + B + "|" + r1 + "|" + J + "|" + W + "|" + d1;
}
var _d = "[" + b1 + "]{" + we + "}", gd = "[" + Oe + "]{0,1}(?:[" + J1 + "]*[" + b1 + "]){3,}[" + J1 + b1 + "]*", yd = new RegExp("^[" + Oe + "]{0,1}(?:[" + J1 + "]*[" + b1 + "]){1,2}$", "i"), md = gd + // Phone number extensions
"(?:" + Rt() + ")?", hd = new RegExp(
  // Either a short two-digit-only phone number
  "^" + _d + "$|^" + md + "$",
  "i"
);
function Bt(e) {
  return e.length >= we && hd.test(e);
}
function vd(e) {
  return yd.test(e);
}
var ot = new RegExp("(?:" + Rt() + ")$", "i");
function bd(e) {
  var t = e.search(ot);
  if (t < 0)
    return {};
  for (var n = e.slice(0, t), r = e.match(ot), l = 1; l < r.length; ) {
    if (r[l])
      return {
        number: n,
        ext: r[l]
      };
    l++;
  }
}
var Id = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Md(e) {
  return Id[e];
}
function kd(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = xd(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xd(e, t) {
  if (e) {
    if (typeof e == "string")
      return dt(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return dt(e, t);
  }
}
function dt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function lt(e) {
  for (var t = "", n = kd(e.split("")), r; !(r = n()).done; ) {
    var l = r.value;
    t += Nd(l, t) || "";
  }
  return t;
}
function Nd(e, t) {
  return e === "+" ? t ? void 0 : "+" : Md(e);
}
function Sd(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Ld(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ld(e, t) {
  if (e) {
    if (typeof e == "string")
      return at(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return at(e, t);
  }
}
function at(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Ad(e, t) {
  for (var n = e.slice(), r = Sd(t), l; !(l = r()).done; ) {
    var d = l.value;
    e.indexOf(d) < 0 && n.push(d);
  }
  return n.sort(function(i, s) {
    return i - s;
  });
}
function se(e, t) {
  return zt(e, void 0, t);
}
function zt(e, t, n) {
  var r = n.type(t), l = r && r.possibleLengths() || n.possibleLengths();
  if (!l)
    return "IS_POSSIBLE";
  if (t === "FIXED_LINE_OR_MOBILE") {
    if (!n.type("FIXED_LINE"))
      return zt(e, "MOBILE", n);
    var d = n.type("MOBILE");
    d && (l = Ad(l, d.possibleLengths()));
  } else if (t && !r)
    return "INVALID_LENGTH";
  var i = e.length, s = l[0];
  return s === i ? "IS_POSSIBLE" : s > i ? "TOO_SHORT" : l[l.length - 1] < i ? "TOO_LONG" : l.indexOf(i, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function wd(e, t, n) {
  if (t === void 0 && (t = {}), n = new Y(n), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!n.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      n.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return Ft(e.phone || e.nationalNumber, n);
  if (e.countryCallingCode && n.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function Ft(e, t) {
  switch (se(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function Od(e, t) {
  return Ed(e) || Dd(e, t) || Ut(e, t) || Td();
}
function Td() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Dd(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], l = !0, d = !1, i, s;
    try {
      for (n = n.call(e); !(l = (i = n.next()).done) && (r.push(i.value), !(t && r.length === t)); l = !0)
        ;
    } catch (f) {
      d = !0, s = f;
    } finally {
      try {
        !l && n.return != null && n.return();
      } finally {
        if (d)
          throw s;
      }
    }
    return r;
  }
}
function Ed(e) {
  if (Array.isArray(e))
    return e;
}
function Vd(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Ut(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ut(e, t) {
  if (e) {
    if (typeof e == "string")
      return it(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return it(e, t);
  }
}
function it(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function jd(e) {
  var t, n;
  e = e.replace(/^tel:/, "tel=");
  for (var r = Vd(e.split(";")), l; !(l = r()).done; ) {
    var d = l.value, i = d.split("="), s = Od(i, 2), f = s[0], p = s[1];
    switch (f) {
      case "tel":
        t = p;
        break;
      case "ext":
        n = p;
        break;
      case "phone-context":
        p[0] === "+" && (t = p + t);
        break;
    }
  }
  if (!Bt(t))
    return {};
  var v = {
    number: t
  };
  return n && (v.ext = n), v;
}
function Pd(e) {
  var t = e.number, n = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(n ? ";ext=" + n : "");
}
function g1(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function Hd(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Rd(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Rd(e, t) {
  if (e) {
    if (typeof e == "string")
      return st(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return st(e, t);
  }
}
function st(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var Bd = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function De(e, t, n) {
  if (t = t || {}, !!e.country) {
    n = new Y(n), n.selectNumberingPlan(e.country, e.countryCallingCode);
    var r = t.v2 ? e.nationalNumber : e.phone;
    if (g1(r, n.nationalNumberPattern())) {
      if (ye(r, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || ye(r, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var l = Hd(Bd), d; !(d = l()).done; ) {
        var i = d.value;
        if (ye(r, i, n))
          return i;
      }
    }
  }
}
function ye(e, t, n) {
  return t = n.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : g1(e, t.pattern());
}
function zd(e, t, n) {
  if (t = t || {}, n = new Y(n), n.selectNumberingPlan(e.country, e.countryCallingCode), n.hasTypes())
    return De(e, t, n.metadata) !== void 0;
  var r = t.v2 ? e.nationalNumber : e.phone;
  return g1(r, n.nationalNumberPattern());
}
function Fd(e, t, n) {
  var r = new Y(n), l = r.getCountryCodesForCallingCode(e);
  return l ? l.filter(function(d) {
    return Ud(t, d, n);
  }) : [];
}
function Ud(e, t, n) {
  var r = new Y(n);
  return r.selectNumberingPlan(t), r.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
function Zd(e) {
  return e.replace(new RegExp("[".concat(J1, "]+"), "g"), " ").trim();
}
var Gd = /(\$\d)/;
function Yd(e, t, n) {
  var r = n.useInternationalFormat, l = n.withNationalPrefix;
  n.carrierCode, n.metadata;
  var d = e.replace(new RegExp(t.pattern()), r ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    l && t.nationalPrefixFormattingRule() ? t.format().replace(Gd, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return r ? Zd(d) : d;
}
var Wd = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function Qd(e, t, n) {
  var r = new Y(n);
  if (r.selectNumberingPlan(e, t), r.defaultIDDPrefix())
    return r.defaultIDDPrefix();
  if (Wd.test(r.IDDPrefix()))
    return r.IDDPrefix();
}
function Kd(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Xd(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xd(e, t) {
  if (e) {
    if (typeof e == "string")
      return ct(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return ct(e, t);
  }
}
function ct(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function ut(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(l) {
      return Object.getOwnPropertyDescriptor(e, l).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ft(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ut(Object(n), !0).forEach(function(r) {
      qd(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ut(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function qd(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var pt = {
  formatExtension: function(t, n, r) {
    return "".concat(t).concat(r.ext()).concat(n);
  }
};
function Jd(e, t, n, r) {
  if (n ? n = ft(ft({}, pt), n) : n = pt, r = new Y(r), e.country && e.country !== "001") {
    if (!r.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    r.country(e.country);
  } else if (e.countryCallingCode)
    r.selectNumberingPlan(e.countryCallingCode);
  else
    return e.phone || "";
  var l = r.countryCallingCode(), d = n.v2 ? e.nationalNumber : e.phone, i;
  switch (t) {
    case "NATIONAL":
      return d ? (i = te(d, e.carrierCode, "NATIONAL", r, n), me(i, e.ext, r, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return d ? (i = te(d, null, "INTERNATIONAL", r, n), i = "+".concat(l, " ").concat(i), me(i, e.ext, r, n.formatExtension)) : "+".concat(l);
    case "E.164":
      return "+".concat(l).concat(d);
    case "RFC3966":
      return Pd({
        number: "+".concat(l).concat(d),
        ext: e.ext
      });
    case "IDD":
      if (!n.fromCountry)
        return;
      var s = tl(d, e.carrierCode, l, n.fromCountry, r);
      return me(s, e.ext, r, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function te(e, t, n, r, l) {
  var d = el(r.formats(), e);
  return d ? Yd(e, d, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(d.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && l && l.nationalPrefix === !1),
    carrierCode: t,
    metadata: r
  }) : e;
}
function el(e, t) {
  for (var n = Kd(e), r; !(r = n()).done; ) {
    var l = r.value;
    if (l.leadingDigitsPatterns().length > 0) {
      var d = l.leadingDigitsPatterns()[l.leadingDigitsPatterns().length - 1];
      if (t.search(d) !== 0)
        continue;
    }
    if (g1(t, l.pattern()))
      return l;
  }
}
function me(e, t, n, r) {
  return t ? r(e, t, n) : e;
}
function tl(e, t, n, r, l) {
  var d = Te(r, l.metadata);
  if (d === n) {
    var i = te(e, t, "NATIONAL", l);
    return n === "1" ? n + " " + i : i;
  }
  var s = Qd(r, void 0, l.metadata);
  if (s)
    return "".concat(s, " ").concat(n, " ").concat(te(e, null, "INTERNATIONAL", l));
}
function $t(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(l) {
      return Object.getOwnPropertyDescriptor(e, l).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ct(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $t(Object(n), !0).forEach(function(r) {
      nl(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $t(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function nl(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function rl(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _t(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function ol(e, t, n) {
  return t && _t(e.prototype, t), n && _t(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var dl = /* @__PURE__ */ function() {
  function e(t, n, r) {
    if (rl(this, e), !t)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!n)
      throw new TypeError("`nationalNumber` not passed");
    if (!r)
      throw new TypeError("`metadata` not passed");
    var l = al(t, r), d = l.country, i = l.countryCallingCode;
    this.country = d, this.countryCallingCode = i, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.metadata = r;
  }
  return ol(e, [{
    key: "setExt",
    value: function(n) {
      this.ext = n;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : Fd(this.countryCallingCode, this.nationalNumber, this.metadata);
    }
  }, {
    key: "isPossible",
    value: function() {
      return wd(this, {
        v2: !0
      }, this.metadata);
    }
  }, {
    key: "isValid",
    value: function() {
      return zd(this, {
        v2: !0
      }, this.metadata);
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new Y(this.metadata);
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.metadata)
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return De(this, {
        v2: !0
      }, this.metadata);
    }
  }, {
    key: "format",
    value: function(n, r) {
      return Jd(this, n, r ? Ct(Ct({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.metadata);
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]), e;
}(), ll = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function al(e, t) {
  var n, r, l = new Y(t);
  return ll(e) ? (n = e, l.selectNumberingPlan(n), r = l.countryCallingCode()) : r = e, {
    country: n,
    countryCallingCode: r
  };
}
var il = new RegExp("([" + b1 + "])");
function sl(e, t, n, r) {
  if (t) {
    var l = new Y(r);
    l.selectNumberingPlan(t, n);
    var d = new RegExp(l.IDDPrefix());
    if (e.search(d) === 0) {
      e = e.slice(e.match(d)[0].length);
      var i = e.match(il);
      if (!(i && i[1] != null && i[1].length > 0 && i[1] === "0"))
        return e;
    }
  }
}
function cl(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), r = n.exec(e);
    if (r) {
      var l, d, i = r.length - 1, s = i > 0 && r[i];
      if (t.nationalPrefixTransformRule() && s)
        l = e.replace(n, t.nationalPrefixTransformRule()), i > 1 && (d = r[1]);
      else {
        var f = r[0];
        l = e.slice(f.length), s && (d = r[1]);
      }
      var p;
      if (s) {
        var v = e.indexOf(r[1]), y = e.slice(0, v);
        y === t.numberingPlan.nationalPrefix() && (p = t.numberingPlan.nationalPrefix());
      } else
        p = r[0];
      return {
        nationalNumber: l,
        nationalPrefix: p,
        carrierCode: d
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function Ie(e, t) {
  var n = cl(e, t), r = n.carrierCode, l = n.nationalNumber;
  if (l !== e) {
    if (!ul(e, l, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !fl(l, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: l,
    carrierCode: r
  };
}
function ul(e, t, n) {
  return !(g1(e, n.nationalNumberPattern()) && !g1(t, n.nationalNumberPattern()));
}
function fl(e, t) {
  switch (se(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function pl(e, t, n, r) {
  var l = t ? Te(t, r) : n;
  if (e.indexOf(l) === 0) {
    r = new Y(r), r.selectNumberingPlan(t, n);
    var d = e.slice(l.length), i = Ie(d, r), s = i.nationalNumber, f = Ie(e, r), p = f.nationalNumber;
    if (!g1(p, r.nationalNumberPattern()) && g1(s, r.nationalNumberPattern()) || se(p, r) === "TOO_LONG")
      return {
        countryCallingCode: l,
        number: d
      };
  }
  return {
    number: e
  };
}
function $l(e, t, n, r) {
  if (!e)
    return {};
  if (e[0] !== "+") {
    var l = sl(e, t, n, r);
    if (l && l !== e)
      e = "+" + l;
    else {
      if (t || n) {
        var d = pl(e, t, n, r), i = d.countryCallingCode, s = d.number;
        if (i)
          return {
            countryCallingCode: i,
            number: s
          };
      }
      return {
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  r = new Y(r);
  for (var f = 2; f - 1 <= Jo && f <= e.length; ) {
    var p = e.slice(1, f);
    if (r.hasCallingCode(p))
      return r.selectNumberingPlan(p), {
        countryCallingCode: p,
        number: e.slice(f)
      };
    f++;
  }
  return {};
}
function Cl(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = _l(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _l(e, t) {
  if (e) {
    if (typeof e == "string")
      return gt(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return gt(e, t);
  }
}
function gt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function gl(e, t, n) {
  n = new Y(n);
  for (var r = Cl(e), l; !(l = r()).done; ) {
    var d = l.value;
    if (n.country(d), n.leadingDigits()) {
      if (t && t.search(n.leadingDigits()) === 0)
        return d;
    } else if (De({
      phone: t,
      country: d
    }, void 0, n.metadata))
      return d;
  }
}
var yl = !1;
function ml(e, t, n) {
  if (yl && n.isNonGeographicCallingCode(e))
    return "001";
  var r = n.getCountryCodesForCallingCode(e);
  if (r)
    return r.length === 1 ? r[0] : gl(r, t, n.metadata);
}
var hl = 250, vl = new RegExp("[" + Oe + b1 + "]"), bl = new RegExp("[^" + b1 + "#]+$");
function Il(e, t, n) {
  if (t = t || {}, n = new Y(n), t.defaultCountry && !n.hasCountry(t.defaultCountry))
    throw t.v2 ? new C1("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var r = kl(e, t.v2, t.extract), l = r.number, d = r.ext, i = r.error;
  if (!l) {
    if (t.v2)
      throw i === "TOO_SHORT" ? new C1("TOO_SHORT") : new C1("NOT_A_NUMBER");
    return {};
  }
  var s = Nl(l, t.defaultCountry, t.defaultCallingCode, n), f = s.country, p = s.nationalNumber, v = s.countryCallingCode, y = s.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new C1("INVALID_COUNTRY");
    return {};
  }
  if (!p || p.length < we) {
    if (t.v2)
      throw new C1("TOO_SHORT");
    return {};
  }
  if (p.length > qo) {
    if (t.v2)
      throw new C1("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var V = new dl(v, p, n.metadata);
    return f && (V.country = f), y && (V.carrierCode = y), d && (V.ext = d), V;
  }
  var N = (t.extended ? n.hasSelectedNumberingPlan() : f) ? g1(p, n.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: f,
    countryCallingCode: v,
    carrierCode: y,
    valid: N,
    possible: N ? !0 : !!(t.extended === !0 && n.possibleLengths() && Ft(p, n)),
    phone: p,
    ext: d
  } : N ? xl(f, p, d) : {};
}
function Ml(e, t, n) {
  if (e) {
    if (e.length > hl) {
      if (n)
        throw new C1("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var r = e.search(vl);
    if (!(r < 0))
      return e.slice(r).replace(bl, "");
  }
}
function kl(e, t, n) {
  if (e && e.indexOf("tel:") === 0)
    return jd(e);
  var r = Ml(e, n, t);
  if (!r)
    return {};
  if (!Bt(r))
    return vd(r) ? {
      error: "TOO_SHORT"
    } : {};
  var l = bd(r);
  return l.ext ? l : {
    number: r
  };
}
function xl(e, t, n) {
  var r = {
    country: e,
    phone: t
  };
  return n && (r.ext = n), r;
}
function Nl(e, t, n, r) {
  var l = $l(lt(e), t, n, r.metadata), d = l.countryCallingCode, i = l.number, s;
  if (d)
    r.selectNumberingPlan(d);
  else if (i && (t || n))
    r.selectNumberingPlan(t, n), t && (s = t), d = n || Te(t, r.metadata);
  else
    return {};
  if (!i)
    return {
      countryCallingCode: d
    };
  var f = Ie(lt(i), r), p = f.nationalNumber, v = f.carrierCode, y = ml(d, p, r);
  return y && (s = y, y === "001" || r.country(s)), {
    country: s,
    countryCallingCode: d,
    nationalNumber: p,
    carrierCode: v
  };
}
function yt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(l) {
      return Object.getOwnPropertyDescriptor(e, l).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function mt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yt(Object(n), !0).forEach(function(r) {
      Sl(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : yt(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Sl(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Zt(e, t, n) {
  return Il(e, mt(mt({}, t), {}, {
    v2: !0
  }), n);
}
function Me(e) {
  "@babel/helpers - typeof";
  return Me = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Me(e);
}
function ht(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(l) {
      return Object.getOwnPropertyDescriptor(e, l).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ll(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ht(Object(n), !0).forEach(function(r) {
      Al(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ht(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Al(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function wl(e, t) {
  return El(e) || Dl(e, t) || Tl(e, t) || Ol();
}
function Ol() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Tl(e, t) {
  if (e) {
    if (typeof e == "string")
      return vt(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return vt(e, t);
  }
}
function vt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Dl(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], l = !0, d = !1, i, s;
    try {
      for (n = n.call(e); !(l = (i = n.next()).done) && (r.push(i.value), !(t && r.length === t)); l = !0)
        ;
    } catch (f) {
      d = !0, s = f;
    } finally {
      try {
        !l && n.return != null && n.return();
      } finally {
        if (d)
          throw s;
      }
    }
    return r;
  }
}
function El(e) {
  if (Array.isArray(e))
    return e;
}
function Gt(e) {
  var t = Array.prototype.slice.call(e), n = wl(t, 4), r = n[0], l = n[1], d = n[2], i = n[3], s, f, p;
  if (typeof r == "string")
    s = r;
  else
    throw new TypeError("A text for parsing must be a string.");
  if (!l || typeof l == "string")
    i ? (f = d, p = i) : (f = void 0, p = d), l && (f = Ll({
      defaultCountry: l
    }, f));
  else if (Vl(l))
    d ? (f = l, p = d) : p = l;
  else
    throw new Error("Invalid second argument: ".concat(l));
  return {
    text: s,
    options: f,
    metadata: p
  };
}
var Vl = function(t) {
  return Me(t) === "object";
};
function bt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(l) {
      return Object.getOwnPropertyDescriptor(e, l).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function It(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bt(Object(n), !0).forEach(function(r) {
      jl(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : bt(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function jl(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Pl(e, t, n) {
  t && t.defaultCountry && !$d(t.defaultCountry, n) && (t = It(It({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return Zt(e, t, n);
  } catch (r) {
    if (!(r instanceof C1))
      throw r;
  }
}
function Hl() {
  var e = Gt(arguments), t = e.text, n = e.options, r = e.metadata;
  return Pl(t, n, r);
}
function Mt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(l) {
      return Object.getOwnPropertyDescriptor(e, l).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function kt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mt(Object(n), !0).forEach(function(r) {
      Rl(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Mt(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Rl(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Bl() {
  var e = Gt(arguments), t = e.text, n = e.options, r = e.metadata;
  n = kt(kt({}, n), {}, {
    extract: !1
  });
  try {
    var l = Zt(t, n, r);
    r = new Y(r), r.selectNumberingPlan(l.countryCallingCode);
    var d = se(l.nationalNumber, r);
    if (d !== "IS_POSSIBLE")
      return d;
  } catch (i) {
    if (i instanceof C1)
      return i.message;
    throw i;
  }
}
function he() {
  return Vt(Hl, arguments);
}
function zl() {
  return Vt(Bl, arguments);
}
const Fl = "https://api.du3b.com/v1/client_ip", _1 = {
  INVALID_NUMBER: "verification.phone.invalidPhone",
  TOO_SHORT: "verification.phone.tooShort",
  TOO_LONG: "verification.phone.tooLong",
  INVALID_LENGTH: "verification.phone.invalidPhone",
  NOT_A_NUMBER: "verification.phone.invalidPhone",
  INVALID_COUNTRY: "verification.phone.invalidPhone",
  NORMAL: ""
}, xt = {
  INVALID_COUNTRY: _1.INVALID_COUNTRY,
  NOT_A_NUMBER: _1.NOT_A_NUMBER,
  TOO_SHORT: _1.TOO_SHORT,
  TOO_LONG: _1.TOO_LONG,
  INVALID_LENGTH: _1.INVALID_LENGTH
}, Nt = {
  TEL: "tel",
  NUMBER: "number"
}, Yt = [
  "ao",
  "am",
  "af",
  "bj",
  "bw",
  "bi",
  "ga",
  "gm",
  "gd",
  "gn",
  "gw",
  "gy",
  "ht",
  "hn",
  "dk",
  "zm",
  "zw",
  "iq",
  "cv",
  "kh",
  "km",
  "cg",
  "ki",
  "la",
  "ls",
  "lr",
  "mg",
  "mw",
  "mv",
  "mr",
  "mn",
  "mz",
  "na",
  "nr",
  "np",
  "nz",
  "ni",
  "ne",
  "ps",
  "py",
  "kp",
  "sn",
  "gb",
  "us",
  "so",
  "sd",
  "sr",
  "sl",
  "td",
  "me",
  "et",
  "ss",
  "jm",
  "jp",
  "at",
  "be",
  "bg",
  "hu",
  "de",
  "gr",
  "ie",
  "is",
  "es",
  "it",
  "cy",
  "lv",
  "lt",
  "li",
  "lu",
  "mt",
  "nl",
  "no",
  "pl",
  "pt",
  "ro",
  "sk",
  "si",
  "fi",
  "fr",
  "hr",
  "cz",
  "ch",
  "se",
  "ee"
], Ul = [
  [
    "Afghanistan (‫افغانستان‬‎)",
    "af",
    "93"
  ],
  [
    "Albania (Shqipëri)",
    "al",
    "355"
  ],
  [
    "Algeria (‫الجزائر‬‎)",
    "dz",
    "213"
  ],
  [
    "American Samoa",
    "as",
    "1684"
  ],
  [
    "Andorra",
    "ad",
    "376"
  ],
  [
    "Angola",
    "ao",
    "244"
  ],
  [
    "Anguilla",
    "ai",
    "1264"
  ],
  [
    "Antigua and Barbuda",
    "ag",
    "1268"
  ],
  [
    "Argentina",
    "ar",
    "54"
  ],
  [
    "Armenia (Հայաստան)",
    "am",
    "374"
  ],
  [
    "Aruba",
    "aw",
    "297"
  ],
  [
    "Australia",
    "au",
    "61"
  ],
  [
    "Austria (Österreich)",
    "at",
    "43"
  ],
  [
    "Azerbaijan (Azərbaycan)",
    "az",
    "994"
  ],
  [
    "Bahamas",
    "bs",
    "1242"
  ],
  [
    "Bahrain (‫البحرين‬‎)",
    "bh",
    "973"
  ],
  [
    "Bangladesh (বাংলাদেশ)",
    "bd",
    "880"
  ],
  [
    "Barbados",
    "bb",
    "1246"
  ],
  [
    "Belarus (Беларусь)",
    "by",
    "375"
  ],
  [
    "Belgium (België)",
    "be",
    "32"
  ],
  [
    "Belize",
    "bz",
    "501"
  ],
  [
    "Benin (Bénin)",
    "bj",
    "229"
  ],
  [
    "Bermuda",
    "bm",
    "1441"
  ],
  [
    "Bhutan (འབྲུག)",
    "bt",
    "975"
  ],
  [
    "Bolivia",
    "bo",
    "591"
  ],
  [
    "Bosnia and Herzegovina (Босна и Херцеговина)",
    "ba",
    "387"
  ],
  [
    "Botswana",
    "bw",
    "267"
  ],
  [
    "Brazil (Brasil)",
    "br",
    "55"
  ],
  [
    "British Indian Ocean Territory",
    "io",
    "246"
  ],
  [
    "British Virgin Islands",
    "vg",
    "1284"
  ],
  [
    "Brunei",
    "bn",
    "673"
  ],
  [
    "Bulgaria (България)",
    "bg",
    "359"
  ],
  [
    "Burkina Faso",
    "bf",
    "226"
  ],
  [
    "Burundi (Uburundi)",
    "bi",
    "257"
  ],
  [
    "Cambodia (កម្ពុជា)",
    "kh",
    "855"
  ],
  [
    "Cameroon (Cameroun)",
    "cm",
    "237"
  ],
  [
    "Canada",
    "ca",
    "1"
  ],
  [
    "Cape Verde (Kabu Verdi)",
    "cv",
    "238"
  ],
  [
    "Caribbean Netherlands",
    "bq",
    "599"
  ],
  [
    "Cayman Islands",
    "ky",
    "1345"
  ],
  [
    "Central African Republic (République centrafricaine)",
    "cf",
    "236"
  ],
  [
    "Chad (Tchad)",
    "td",
    "235"
  ],
  [
    "Chile",
    "cl",
    "56"
  ],
  [
    "China (中国)",
    "cn",
    "86"
  ],
  [
    "Christmas Island",
    "cx",
    "61"
  ],
  [
    "Cocos (Keeling) Islands",
    "cc",
    "61"
  ],
  [
    "Colombia",
    "co",
    "57"
  ],
  [
    "Comoros (‫جزر القمر‬‎)",
    "km",
    "269"
  ],
  [
    "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    "cd",
    "243"
  ],
  [
    "Congo (Republic) (Congo-Brazzaville)",
    "cg",
    "242"
  ],
  [
    "Cook Islands",
    "ck",
    "682"
  ],
  [
    "Costa Rica",
    "cr",
    "506"
  ],
  [
    "Côte d’Ivoire",
    "ci",
    "225"
  ],
  [
    "Croatia (Hrvatska)",
    "hr",
    "385"
  ],
  [
    "Cuba",
    "cu",
    "53"
  ],
  [
    "Curaçao",
    "cw",
    "599"
  ],
  [
    "Cyprus (Κύπρος)",
    "cy",
    "357"
  ],
  [
    "Czech Republic (Česká republika)",
    "cz",
    "420"
  ],
  [
    "Denmark (Danmark)",
    "dk",
    "45"
  ],
  [
    "Djibouti",
    "dj",
    "253"
  ],
  [
    "Dominica",
    "dm",
    "1767"
  ],
  [
    "Dominican Republic (República Dominicana)",
    "do",
    "1"
  ],
  [
    "Ecuador",
    "ec",
    "593"
  ],
  [
    "Egypt (‫مصر‬‎)",
    "eg",
    "20"
  ],
  [
    "El Salvador",
    "sv",
    "503"
  ],
  [
    "Equatorial Guinea (Guinea Ecuatorial)",
    "gq",
    "240"
  ],
  [
    "Eritrea",
    "er",
    "291"
  ],
  [
    "Estonia (Eesti)",
    "ee",
    "372"
  ],
  [
    "Ethiopia",
    "et",
    "251"
  ],
  [
    "Falkland Islands (Islas Malvinas)",
    "fk",
    "500"
  ],
  [
    "Faroe Islands (Føroyar)",
    "fo",
    "298"
  ],
  [
    "Fiji",
    "fj",
    "679"
  ],
  [
    "Finland (Suomi)",
    "fi",
    "358"
  ],
  [
    "France",
    "fr",
    "33"
  ],
  [
    "French Guiana (Guyane française)",
    "gf",
    "594"
  ],
  [
    "French Polynesia (Polynésie française)",
    "pf",
    "689"
  ],
  [
    "Gabon",
    "ga",
    "241"
  ],
  [
    "Gambia",
    "gm",
    "220"
  ],
  [
    "Georgia (საქართველო)",
    "ge",
    "995"
  ],
  [
    "Germany (Deutschland)",
    "de",
    "49"
  ],
  [
    "Ghana (Gaana)",
    "gh",
    "233"
  ],
  [
    "Gibraltar",
    "gi",
    "350"
  ],
  [
    "Greece (Ελλάδα)",
    "gr",
    "30"
  ],
  [
    "Greenland (Kalaallit Nunaat)",
    "gl",
    "299"
  ],
  [
    "Grenada",
    "gd",
    "1473"
  ],
  [
    "Guadeloupe",
    "gp",
    "590"
  ],
  [
    "Guam",
    "gu",
    "1671"
  ],
  [
    "Guatemala",
    "gt",
    "502"
  ],
  [
    "Guernsey",
    "gg",
    "44",
    1
  ],
  [
    "Guinea (Guinée)",
    "gn",
    "224"
  ],
  [
    "Guinea-Bissau (Guiné Bissau)",
    "gw",
    "245"
  ],
  [
    "Guyana",
    "gy",
    "592"
  ],
  [
    "Haiti",
    "ht",
    "509"
  ],
  [
    "Honduras",
    "hn",
    "504"
  ],
  [
    "Hong Kong (香港)",
    "hk",
    "852"
  ],
  [
    "Hungary (Magyarország)",
    "hu",
    "36"
  ],
  [
    "Iceland (Ísland)",
    "is",
    "354"
  ],
  [
    "India (भारत)",
    "in",
    "91"
  ],
  [
    "Indonesia",
    "id",
    "62"
  ],
  [
    "Iran (‫ایران‬‎)",
    "ir",
    "98"
  ],
  [
    "Iraq (‫العراق‬‎)",
    "iq",
    "964"
  ],
  [
    "Ireland",
    "ie",
    "353"
  ],
  [
    "Isle of Man",
    "im",
    "44"
  ],
  [
    "Israel (‫ישראל‬‎)",
    "il",
    "972"
  ],
  [
    "Italy (Italia)",
    "it",
    "39"
  ],
  [
    "Jamaica",
    "jm",
    "1876"
  ],
  [
    "Japan (日本)",
    "jp",
    "81"
  ],
  [
    "Jersey",
    "je",
    "44"
  ],
  [
    "Jordan (‫الأردن‬‎)",
    "jo",
    "962"
  ],
  [
    "Kazakhstan (Казахстан)",
    "kz",
    "7"
  ],
  [
    "Kenya",
    "ke",
    "254"
  ],
  [
    "Kiribati",
    "ki",
    "686"
  ],
  [
    "Kosovo",
    "xk",
    "383"
  ],
  [
    "Kuwait (‫الكويت‬‎)",
    "kw",
    "965"
  ],
  [
    "Kyrgyzstan (Кыргызстан)",
    "kg",
    "996"
  ],
  [
    "Laos (ລາວ)",
    "la",
    "856"
  ],
  [
    "Latvia (Latvija)",
    "lv",
    "371"
  ],
  [
    "Lebanon (‫لبنان‬‎)",
    "lb",
    "961"
  ],
  [
    "Lesotho",
    "ls",
    "266"
  ],
  [
    "Liberia",
    "lr",
    "231"
  ],
  [
    "Libya (‫ليبيا‬‎)",
    "ly",
    "218"
  ],
  [
    "Liechtenstein",
    "li",
    "423"
  ],
  [
    "Lithuania (Lietuva)",
    "lt",
    "370"
  ],
  [
    "Luxembourg",
    "lu",
    "352"
  ],
  [
    "Macau (澳門)",
    "mo",
    "853"
  ],
  [
    "Macedonia (FYROM) (Македонија)",
    "mk",
    "389"
  ],
  [
    "Madagascar (Madagasikara)",
    "mg",
    "261"
  ],
  [
    "Malawi",
    "mw",
    "265"
  ],
  [
    "Malaysia",
    "my",
    "60"
  ],
  [
    "Maldives",
    "mv",
    "960"
  ],
  [
    "Mali",
    "ml",
    "223"
  ],
  [
    "Malta",
    "mt",
    "356"
  ],
  [
    "Marshall Islands",
    "mh",
    "692"
  ],
  [
    "Martinique",
    "mq",
    "596"
  ],
  [
    "Mauritania (‫موريتانيا‬‎)",
    "mr",
    "222"
  ],
  [
    "Mauritius (Moris)",
    "mu",
    "230"
  ],
  [
    "Mayotte",
    "yt",
    "262"
  ],
  [
    "Mexico (México)",
    "mx",
    "52"
  ],
  [
    "Micronesia",
    "fm",
    "691"
  ],
  [
    "Moldova (Republica Moldova)",
    "md",
    "373"
  ],
  [
    "Monaco",
    "mc",
    "377"
  ],
  [
    "Mongolia (Монгол)",
    "mn",
    "976"
  ],
  [
    "Montenegro (Crna Gora)",
    "me",
    "382"
  ],
  [
    "Montserrat",
    "ms",
    "1664"
  ],
  [
    "Morocco (‫المغرب‬‎)",
    "ma",
    "212"
  ],
  [
    "Mozambique (Moçambique)",
    "mz",
    "258"
  ],
  [
    "Myanmar (Burma) (မြန်မာ)",
    "mm",
    "95"
  ],
  [
    "Namibia (Namibië)",
    "na",
    "264"
  ],
  [
    "Nauru",
    "nr",
    "674"
  ],
  [
    "Nepal (नेपाल)",
    "np",
    "977"
  ],
  [
    "Netherlands (Nederland)",
    "nl",
    "31"
  ],
  [
    "New Caledonia (Nouvelle-Calédonie)",
    "nc",
    "687"
  ],
  [
    "New Zealand",
    "nz",
    "64"
  ],
  [
    "Nicaragua",
    "ni",
    "505"
  ],
  [
    "Niger (Nijar)",
    "ne",
    "227"
  ],
  [
    "Nigeria",
    "ng",
    "234"
  ],
  [
    "Niue",
    "nu",
    "683"
  ],
  [
    "Norfolk Island",
    "nf",
    "672"
  ],
  [
    "North Korea (조선 민주주의 인민 공화국)",
    "kp",
    "850"
  ],
  [
    "Northern Mariana Islands",
    "mp",
    "1670"
  ],
  [
    "Norway (Norge)",
    "no",
    "47"
  ],
  [
    "Oman (‫عُمان‬‎)",
    "om",
    "968"
  ],
  [
    "Pakistan (‫پاکستان‬‎)",
    "pk",
    "92"
  ],
  [
    "Palau",
    "pw",
    "680"
  ],
  [
    "Palestine (‫فلسطين‬‎)",
    "ps",
    "970"
  ],
  [
    "Panama (Panamá)",
    "pa",
    "507"
  ],
  [
    "Papua New Guinea",
    "pg",
    "675"
  ],
  [
    "Paraguay",
    "py",
    "595"
  ],
  [
    "Peru (Perú)",
    "pe",
    "51"
  ],
  [
    "Philippines",
    "ph",
    "63"
  ],
  [
    "Poland (Polska)",
    "pl",
    "48"
  ],
  [
    "Portugal",
    "pt",
    "351"
  ],
  [
    "Puerto Rico",
    "pr",
    "1"
  ],
  [
    "Qatar (‫قطر‬‎)",
    "qa",
    "974"
  ],
  [
    "Réunion (La Réunion)",
    "re",
    "262"
  ],
  [
    "Romania (România)",
    "ro",
    "40"
  ],
  [
    "Russia (Россия)",
    "ru",
    "7"
  ],
  [
    "Rwanda",
    "rw",
    "250"
  ],
  [
    "Saint Barthélemy",
    "bl",
    "590"
  ],
  [
    "Saint Helena",
    "sh",
    "290"
  ],
  [
    "Saint Kitts and Nevis",
    "kn",
    "1869"
  ],
  [
    "Saint Lucia",
    "lc",
    "1758"
  ],
  [
    "Saint Martin (Saint-Martin (partie française))",
    "mf",
    "590"
  ],
  [
    "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    "pm",
    "508"
  ],
  [
    "Saint Vincent and the Grenadines",
    "vc",
    "1784"
  ],
  [
    "Samoa",
    "ws",
    "685"
  ],
  [
    "San Marino",
    "sm",
    "378"
  ],
  [
    "São Tomé and Príncipe (São Tomé e Príncipe)",
    "st",
    "239"
  ],
  [
    "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
    "sa",
    "966"
  ],
  [
    "Senegal (Sénégal)",
    "sn",
    "221"
  ],
  [
    "Serbia (Србија)",
    "rs",
    "381"
  ],
  [
    "Seychelles",
    "sc",
    "248"
  ],
  [
    "Sierra Leone",
    "sl",
    "232"
  ],
  [
    "Singapore",
    "sg",
    "65"
  ],
  [
    "Sint Maarten",
    "sx",
    "1721"
  ],
  [
    "Slovakia (Slovensko)",
    "sk",
    "421"
  ],
  [
    "Slovenia (Slovenija)",
    "si",
    "386"
  ],
  [
    "Solomon Islands",
    "sb",
    "677"
  ],
  [
    "Somalia (Soomaaliya)",
    "so",
    "252"
  ],
  [
    "South Africa",
    "za",
    "27"
  ],
  [
    "South Korea (대한민국)",
    "kr",
    "82"
  ],
  [
    "South Sudan (‫جنوب السودان‬‎)",
    "ss",
    "211"
  ],
  [
    "Spain (España)",
    "es",
    "34"
  ],
  [
    "Sri Lanka (ශ්‍රී ලංකාව)",
    "lk",
    "94"
  ],
  [
    "Sudan (‫السودان‬‎)",
    "sd",
    "249"
  ],
  [
    "Suriname",
    "sr",
    "597"
  ],
  [
    "Svalbard and Jan Mayen",
    "sj",
    "47"
  ],
  [
    "Swaziland",
    "sz",
    "268"
  ],
  [
    "Sweden (Sverige)",
    "se",
    "46"
  ],
  [
    "Switzerland (Schweiz)",
    "ch",
    "41"
  ],
  [
    "Syria (‫سوريا‬‎)",
    "sy",
    "963"
  ],
  [
    "Taiwan (台灣)",
    "tw",
    "886"
  ],
  [
    "Tajikistan",
    "tj",
    "992"
  ],
  [
    "Tanzania",
    "tz",
    "255"
  ],
  [
    "Thailand (ไทย)",
    "th",
    "66"
  ],
  [
    "Timor-Leste",
    "tl",
    "670"
  ],
  [
    "Togo",
    "tg",
    "228"
  ],
  [
    "Tokelau",
    "tk",
    "690"
  ],
  [
    "Tonga",
    "to",
    "676"
  ],
  [
    "Trinidad and Tobago",
    "tt",
    "1868"
  ],
  [
    "Tunisia (‫تونس‬‎)",
    "tn",
    "216"
  ],
  [
    "Turkey (Türkiye)",
    "tr",
    "90"
  ],
  [
    "Turkmenistan",
    "tm",
    "993"
  ],
  [
    "Turks and Caicos Islands",
    "tc",
    "1649"
  ],
  [
    "Tuvalu",
    "tv",
    "688"
  ],
  [
    "U.S. Virgin Islands",
    "vi",
    "1340"
  ],
  [
    "Uganda",
    "ug",
    "256"
  ],
  [
    "Ukraine (Україна)",
    "ua",
    "380"
  ],
  [
    "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
    "ae",
    "971"
  ],
  [
    "United Kingdom",
    "gb",
    "44"
  ],
  [
    "United States",
    "us",
    "1"
  ],
  [
    "Uruguay",
    "uy",
    "598"
  ],
  [
    "Uzbekistan (Oʻzbekiston)",
    "uz",
    "998"
  ],
  [
    "Vanuatu",
    "vu",
    "678"
  ],
  [
    "Vatican City (Città del Vaticano)",
    "va",
    "39"
  ],
  [
    "Venezuela",
    "ve",
    "58"
  ],
  [
    "Vietnam (Việt Nam)",
    "vn",
    "84"
  ],
  [
    "Wallis and Futuna (Wallis-et-Futuna)",
    "wf",
    "681"
  ],
  [
    "Western Sahara (‫الصحراء الغربية‬‎)",
    "eh",
    "212"
  ],
  [
    "Yemen (‫اليمن‬‎)",
    "ye",
    "967"
  ],
  [
    "Zambia",
    "zm",
    "260"
  ],
  [
    "Zimbabwe",
    "zw",
    "263"
  ],
  [
    "Åland Islands",
    "ax",
    "358"
  ]
], Zl = Ul.map(([e, t, n]) => ({
  name: e,
  iso2: t,
  dialCode: n
}));
function Gl() {
  return typeof fetch != "function" ? Promise.resolve("") : fetch(Fl).then((e) => e.json()).then((e) => {
    const t = e.iso_code.toLowerCase();
    if (!t || Yt.includes(t))
      throw new Error("unable to fetch the country");
    return t;
  });
}
function Yl(e, t) {
  e.focus(), e.setSelectionRange(t, t);
}
const Wl = {
  name: "app-phone-input-list",
  components: { AppText: R },
  props: {
    countries: {
      type: Array,
      required: !0
    },
    preferredCountries: {
      type: Array,
      required: !0
    },
    isDialCodeVisible: {
      type: Boolean,
      default: !1
    },
    activeCountryCode: {
      type: String,
      default: ""
    },
    selectedIndex: {
      type: Number,
      default: 0
    },
    isShowCountryList: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["select-country", "update-select-index"],
  setup(e) {
    const t = w(null), n = (l, d) => {
      const i = e.selectedIndex === l, s = l === e.preferredCountries.length - 1, f = e.preferredCountries.some((p) => p === d);
      return {
        highlighted: i,
        "last-preferred": s,
        preferred: f
      };
    }, r = (l = !0) => {
      const d = window.pageYOffset || document.documentElement.scrollTop, i = t.value, s = i.children[e.selectedIndex], f = i.offsetHeight, p = i.getBoundingClientRect().top + d, v = p + f, y = s.offsetHeight, V = s.getBoundingClientRect().top + d, N = V + y, B = f / 2 - y / 2;
      let r1 = V - p + i.scrollTop;
      if (V < p)
        l && (r1 -= B), i.scrollTop = r1;
      else if (N > v) {
        l && (r1 += B);
        const J = f - y;
        i.scrollTop = r1 - J;
      }
    };
    return h1(() => e.isShowCountryList, (l) => {
      l && O1(() => {
        r();
      });
    }), {
      list: t,
      getItemClasses: n
    };
  }
}, Ql = {
  ref: "list",
  class: "app-phone-input__dropdown-list",
  role: "listbox",
  "aria-label": "List of countries"
}, Kl = ["tabindex", "aria-selected", "onClick", "onMousemove", "onKeyup"], Xl = { class: "item__flag-wrapper" };
function ql(e, t, n, r, l, d) {
  const i = _("app-text");
  return a(), c("ul", Ql, [
    (a(!0), c(t1, null, c1(n.countries, (s, f) => (a(), c("li", {
      key: s.iso2 + (s.preferred ? "-preferred" : ""),
      role: "option",
      class: T(["app-phone-input__dropdown-item item", r.getItemClasses(f, s.iso2)]),
      tabindex: f === n.selectedIndex ? 0 : -1,
      "aria-selected": f === n.selectedIndex,
      onClick: (p) => e.$emit("select-country", s),
      onMousemove: (p) => e.$emit("update-select-index", f),
      onKeyup: Y1((p) => e.$emit("select-country", s), ["enter"])
    }, [
      o("div", Xl, [
        o("span", {
          class: T(["flag", s.iso2])
        }, null, 2)
      ]),
      b(i, { class: "item__country-name" }, {
        default: g(() => [
          D(O(s.name), 1)
        ]),
        _: 2
      }, 1024),
      n.isDialCodeVisible ? (a(), k(i, {
        key: 0,
        class: "item__code"
      }, {
        default: g(() => [
          D(" +" + O(s.dialCode), 1)
        ]),
        _: 2
      }, 1024)) : A("", !0)
    ], 42, Kl))), 128))
  ], 512);
}
const Jl = /* @__PURE__ */ u(Wl, [["render", ql]]);
const ea = {
  name: "vue-tel-input",
  components: {
    AppIcon: G,
    AppText: R,
    AppTextField: ir,
    AppPhoneInputList: Jl
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    inputType: {
      type: String,
      default: "tel"
    },
    required: {
      type: Boolean,
      default: !1
    },
    showSearchBox: {
      type: Boolean,
      default: !0
    },
    validCharactersOnly: {
      type: Boolean,
      default: !0
    },
    allCountries: {
      type: Array,
      required: !0
    },
    autoFormat: {
      type: Boolean,
      default: !0
    },
    customValidate: {
      type: [Boolean, RegExp],
      default: !1
    },
    defaultCountry: {
      type: [String, Number],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    autoDefaultCountry: {
      type: Boolean,
      default: !0
    },
    ignoredCountries: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: "international"
    },
    onlyCountries: {
      type: Array,
      default: () => []
    },
    preferredCountries: {
      type: Array,
      default: () => []
    },
    isDialCodeVisible: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["input", "clicked-outside", "click-on-input", "country-list-open", "country-list-close", "select-country"],
  setup(e, { emit: t }) {
    const n = w(null), r = w(null), l = w(null), d = w(""), i = w(""), s = w(!1), f = w(!1), p = w(null), v = w(""), y = w(null), V = w("above"), N = w(""), B = C.GRAY, r1 = {
      up: "chevron-up",
      down: "chevron-down"
    }, J = $(() => ({
      type: e.inputType,
      required: e.required,
      showDialCode: !1
    })), W = $(() => ({
      showSearchBox: e.showSearchBox,
      disabled: !1
    })), d1 = $(() => [
      "app-phone-input__dropdown",
      s.value ? "open" : "",
      e.disabled ? "disabled" : ""
    ]), u1 = $(() => e.onlyCountries.length ? e.allCountries.filter(({ iso2: m }) => e.onlyCountries.some((L) => L === m)) : e.ignoredCountries.length ? e.allCountries.filter(
      ({ iso2: m }) => !e.ignoredCountries.includes(m.toLowerCase())
    ) : e.allCountries), l1 = (m = "") => {
      const L = m.toLowerCase();
      return u1.value.find((E) => E.iso2 === L);
    }, X = $(() => l1(i.value)), P = $(() => e.mode === "auto" ? !d.value || d.value[0] !== "+" ? "national" : "international" : ["international", "national"].includes(e.mode) ? e.mode : (console.error('Invalid value of prop "mode"'), "international")), q = (m = []) => m.map((L) => l1(L)).filter(Boolean), Q = $(() => {
      const L = [...q(e.preferredCountries).map((E) => ({ ...E, preferred: !0 })), ...u1.value];
      return W.value.showSearchBox ? L.filter(
        (E) => new RegExp(N.value, "i").test(E.name) || new RegExp(N.value, "i").test(E.iso2) || new RegExp(N.value, "i").test(E.dialCode)
      ) : L;
    }), a1 = $(() => {
      var $1, B1, z1, Ve;
      if (!f.value)
        return {};
      let m;
      (($1 = d.value) == null ? void 0 : $1[0]) === "+" ? m = he(d.value) || {} : m = he(d.value, i.value.toUpperCase()) || {}, J.value.showDialCode && ((B1 = d.value) == null ? void 0 : B1[0]) !== "+" && Object.assign(m, { country: "--" });
      const {
        metadata: L,
        // eslint-disable-next-line no-shadow
        ...E
      } = m;
      let F = (z1 = m.isValid) == null ? void 0 : z1.call(m), K = d.value;
      return F && (K = (Ve = m.format) == null ? void 0 : Ve.call(m, P.value.toUpperCase()), K = K.split(" ").splice(1).join(" ")), m.country && (e.ignoredCountries.length || e.onlyCountries.length) && (l1(m.country) || (F = !1, Object.assign(m, { country: "--" }))), Object.assign(E, {
        countryCode: m.country,
        valid: F,
        country: X.value,
        formatted: K
      }), E;
    }), ce = $(() => [
      "app-phone-input__wrapper",
      "d-flex",
      e.disabled ? "disabled" : "",
      a1.value.valid ? "valid" : "",
      V.value === "above" ? "above" : "flex-column"
    ]), ue = (m) => u1.value.find((L) => Number(L.dialCode) === m), A1 = () => {
      Yl(r.value, d.value.length);
    }, I1 = (m) => {
      t("input", m, a1.value, r.value);
    }, f1 = (m) => {
      var E, F;
      s.value = !1, A1();
      let L = m;
      if (typeof L == "string" && (L = l1(L)), !!L) {
        if (((E = d.value) == null ? void 0 : E[0]) === "+" && L.iso2 && a1.value.nationalNumber) {
          i.value = L.iso2, d.value = he(
            a1.value.nationalNumber,
            L.iso2.toUpperCase()
          ).formatInternational();
          return;
        }
        if ((F = J.value) != null && F.showDialCode && L) {
          d.value = `+${L.dialCode}`, i.value = L.iso2 || "";
          return;
        }
        i.value = L.iso2 || "", I1(d.value);
      }
    }, fe = (m) => {
      f1(m), t("select-country", m), t("country-list-close");
    }, S = () => new Promise((m) => {
      var E;
      if (((E = d.value) == null ? void 0 : E[0]) === "+") {
        m();
        return;
      }
      if (e.defaultCountry) {
        if (typeof e.defaultCountry == "string") {
          f1(e.defaultCountry), m();
          return;
        }
        if (typeof e.defaultCountry == "number") {
          const F = ue(e.defaultCountry);
          if (F) {
            f1(F.iso2), m();
            return;
          }
        }
      }
      const L = e.preferredCountries[0] || u1.value[0];
      e.autoDefaultCountry ? Gl().then((F) => {
        f1(F || i.value);
      }).catch((F) => {
        console.warn(F), f1(L);
      }).then(() => {
        m();
      }) : (f1(L), m());
    }), j = (m) => {
      p.value = m;
    }, p1 = () => {
      const m = d.value;
      if (e.validCharactersOnly) {
        const L = d.value.match(/[()\-+0-9\s]*/g);
        d.value = L.join("");
      }
      if (e.customValidate && e.customValidate instanceof RegExp) {
        const L = d.value.match(e.customValidate);
        d.value = L.join("");
      }
      m !== d.value && I1(d.value);
    }, x1 = () => e.customValidate instanceof RegExp ? e.customValidate.test(d.value) : !1, R1 = () => e.validCharactersOnly && !/^[()\-+0-9\s]*$/.test(d.value) ? !1 : e.customValidate ? x1() : !0, pe = () => {
      I1(d.value);
    }, Qt = async (m) => {
      var L, E;
      e.disabled || W.value.disabled || ((E = (L = m == null ? void 0 : m.path) == null ? void 0 : L[0]) == null ? void 0 : E.type) === "text" || (N.value = "", s.value = !s.value, p.value = Q.value.findIndex(({ iso2: F }) => F === i.value), await O1(), t(`country-list-${s.value ? "open" : "close"}`));
    }, Ee = () => {
      N.value = "", s.value && (s.value = !1, t("country-list-close"));
    }, Kt = () => {
      t("click-on-input"), Ee();
    }, Xt = () => {
      s.value = !1, t("clicked-outside", a1.value);
    }, qt = (m) => {
      const L = {
        DOWN_ARROW: "ArrowDown",
        UP_ARROW: "ArrowUp",
        ENTER: "Enter"
      }, E = l.value.list, F = () => E.children[p.value];
      if (m.key === L.DOWN_ARROW) {
        m.preventDefault(), p.value === null ? p.value = 0 : p.value = Math.min(Q.value.length - 1, p.value + 1);
        const K = F();
        K.offsetTop + K.clientHeight > E.scrollTop + E.clientHeight && (E.scrollTop = K.offsetTop - E.clientHeight + K.clientHeight);
      } else if (m.key === L.UP_ARROW) {
        m.preventDefault(), p.value === null ? p.value = Q.value.length - 1 : p.value = Math.max(0, p.value - 1);
        const K = F();
        K.offsetTop < E.scrollTop && (E.scrollTop = K.offsetTop);
      } else if (m.key === L.ENTER)
        p.value !== null && f1(Q.value[p.value]);
      else {
        v.value += m.key, clearTimeout(y.value), y.value = setTimeout(() => {
          v.value = "";
        }, 700);
        const K = Q.value.slice(e.preferredCountries.length).findIndex(($1) => $1.name.toLowerCase().startsWith(v.value));
        if (K >= 0) {
          p.value = e.preferredCountries.length + K;
          const $1 = F(), B1 = $1.offsetTop < E.scrollTop, z1 = $1.offsetTop + $1.clientHeight > E.scrollTop + E.clientHeight;
          (B1 || z1) && (E.scrollTop = $1.offsetTop - E.clientHeight / 2);
        }
      }
    }, Jt = () => {
      p.value = Q.value.map((m) => m.iso2).indexOf(i.value), s.value = !1;
    };
    return Lt(() => {
      e.value && (d.value = e.value.trim()), p1(), S().then(() => {
        var m;
        !d.value && ((m = J.value) != null && m.showDialCode) && i.value && (d.value = `+${i.value}`);
      }).catch(console.error).then(() => {
        f.value = !0;
      });
    }), h1(() => "activeCountry.value", (m, L) => {
      R1() ? d.value = m : O1(() => {
        d.value = L, pe();
      });
    }), h1(() => "phoneObject.value.countryCode", (m) => {
      m && (X.value = m.toLowerCase() || "");
    }), h1(() => "phoneObject.value.formatted", (m) => {
      !e.autoFormat || e.customValidate || (I1(m), O1(() => {
        m && !e.value && (d.value = m);
      }));
    }), h1(() => e.value, (m, L) => {
      R1() ? d.value = m : O1(() => {
        d.value = L, pe();
      });
    }), {
      el: n,
      input: r,
      list: l,
      phone: d,
      iconArrowColor: B,
      icons: r1,
      wrapperClasses: ce,
      clickedOutside: Xt,
      dropdownClasses: d1,
      isShowCountryList: s,
      handleKeyDown: qt,
      toggleDropdown: Qt,
      closeDropdown: Ee,
      reset: Jt,
      activeCountryCode: i,
      activeCountry: X,
      inputOptions: J,
      onFocus: A1,
      onInput: pe,
      onClick: Kt,
      dropdownOptions: W,
      searchQuery: N,
      sortedCountries: Q,
      selectCountryByUser: fe,
      setSelectIndex: j,
      selectedIndex: p
    };
  }
}, ta = {
  ref: "el",
  class: "app-phone-input",
  dir: "ltr"
}, na = { class: "input-wrapper d-flex" }, ra = ["aria-expanded"], oa = { class: "app-phone-input__selection" }, da = ["type", "placeholder", "required", "disabled"], la = { class: "dropdown-list__wrapper" };
function aa(e, t, n, r, l, d) {
  const i = _("app-text"), s = _("app-icon"), f = _("app-text-field"), p = _("app-phone-input-list"), v = ne("click-outside");
  return a(), c("div", ta, [
    S1((a(), c("div", {
      class: T(r.wrapperClasses)
    }, [
      o("div", na, [
        o("div", {
          class: T(r.dropdownClasses),
          "aria-label": "Country Code Selector",
          "aria-haspopup": "listbox",
          "aria-expanded": r.isShowCountryList,
          role: "button",
          tabindex: 0,
          onKeydown: [
            t[0] || (t[0] = (...y) => r.handleKeyDown && r.handleKeyDown(...y)),
            t[2] || (t[2] = Y1((...y) => r.toggleDropdown && r.toggleDropdown(...y), ["space"])),
            t[3] || (t[3] = Y1((...y) => r.reset && r.reset(...y), ["esc"])),
            t[4] || (t[4] = Y1((...y) => r.reset && r.reset(...y), ["tab"]))
          ],
          onClick: t[1] || (t[1] = (...y) => r.toggleDropdown && r.toggleDropdown(...y))
        }, [
          o("span", oa, [
            o("span", {
              class: T(["flag", r.activeCountryCode])
            }, null, 2),
            b(i, {
              "class-name": "wrapper__country-code",
              variant: "caption",
              color: "gray"
            }, {
              default: g(() => [
                D(" +" + O(r.activeCountry && r.activeCountry.dialCode), 1)
              ]),
              _: 1
            }),
            b(s, {
              class: "app-icon",
              icon: r.isShowCountryList ? r.icons.up : r.icons.down,
              color: r.iconArrowColor
            }, null, 8, ["icon", "color"])
          ])
        ], 42, ra),
        S1(o("input", {
          ref: "input",
          "onUpdate:modelValue": t[5] || (t[5] = (y) => r.phone = y),
          class: "app-phone-input__input",
          type: r.inputOptions.type,
          placeholder: n.placeholder,
          required: r.inputOptions.required,
          disabled: n.disabled,
          autocomplete: "on",
          autofocus: !0,
          maxlength: 25,
          name: "phone",
          readonly: !1,
          tabindex: 0,
          onFocus: t[6] || (t[6] = (...y) => r.onFocus && r.onFocus(...y)),
          onInput: t[7] || (t[7] = (...y) => r.onInput && r.onInput(...y)),
          onClick: t[8] || (t[8] = (...y) => r.onClick && r.onClick(...y))
        }, null, 40, da), [
          [tn, r.phone]
        ])
      ]),
      S1(o("div", la, [
        r.dropdownOptions.showSearchBox ? (a(), k(f, {
          key: 0,
          modelValue: r.searchQuery,
          "onUpdate:modelValue": t[9] || (t[9] = (y) => r.searchQuery = y),
          "aria-label": "Search by country name or country code",
          class: "app-phone-input__search_box",
          "prepend-icon-name": "search",
          "hide-details": !0,
          role: "searchbox",
          type: "search",
          tabindex: 0,
          onClick: t[10] || (t[10] = re(() => {
          }, ["stop"]))
        }, null, 8, ["modelValue"])) : A("", !0),
        b(p, {
          ref: "list",
          countries: r.sortedCountries,
          "preferred-countries": n.preferredCountries,
          "active-country-code": r.activeCountryCode,
          "selected-index": r.selectedIndex,
          "is-show-country-list": r.isShowCountryList,
          "is-dial-code-visible": n.isDialCodeVisible,
          onSelectCountry: r.selectCountryByUser,
          onUpdateSelectIndex: r.setSelectIndex
        }, null, 8, ["countries", "preferred-countries", "active-country-code", "selected-index", "is-show-country-list", "is-dial-code-visible", "onSelectCountry", "onUpdateSelectIndex"])
      ], 512), [
        [nn, r.isShowCountryList]
      ]),
      x(e.$slots, "icon-right")
    ], 2)), [
      [v, r.clickedOutside]
    ]),
    x(e.$slots, "error-message")
  ], 512);
}
const ia = /* @__PURE__ */ u(ea, [["render", aa]]);
const sa = {
  name: "app-phone-input",
  components: {
    VueTelInput: ia,
    AppText: R
  },
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    i18nTranslate: {
      type: Function,
      default: (e) => e
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    showSearchBox: {
      type: Boolean,
      default: !0
    },
    inputType: {
      type: String,
      default: Nt.TEL,
      validator: h.isIncludeValues(Object.values(Nt), "inputType")
    },
    placeholder: {
      type: String,
      default: ""
    },
    invalidMsg: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    ignoredCountries: {
      type: Array,
      default: () => Yt
    },
    allCountries: {
      type: Array,
      default: () => Zl
    },
    isDialCodeVisible: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "click-on-input", "country-list-open", "country-list-close", "select-country"],
  setup(e, { emit: t }) {
    const n = w(e.modelValue), r = w(""), l = C.ERROR, { isRtl: d } = o1(), i = $(() => !!e.invalidMsg || !!r.value), s = $(() => d.value ? "rtl" : "ltr"), f = $(() => ({ "app-phone-input__error": i.value })), p = (N, B) => {
      n.value = N, r.value = _1.NORMAL, t("update:modelValue", N, B);
    }, v = (N) => {
      if (N.valid)
        return _1.NORMAL;
      if (N.formatted && N.countryCode) {
        const B = zl(N.formatted, N.countryCode);
        if (xt[B])
          return xt[B];
      }
      return _1.INVALID_NUMBER;
    }, y = (N) => {
      const B = v(N);
      r.value = e.i18nTranslate(B);
    };
    return {
      phone: n,
      errorMessage: r,
      errorColor: l,
      errorClass: f,
      onTelInput: p,
      onClickedOutside: (N) => {
        var B;
        (B = N == null ? void 0 : N.formatted) != null && B.length && !N.valid ? y(N) : r.value = _1.NORMAL;
      },
      showError: i,
      directionAppText: s
    };
  }
};
function ca(e, t, n, r, l, d) {
  const i = _("app-text"), s = _("vue-tel-input");
  return a(), k(s, {
    class: T(r.errorClass),
    value: r.phone,
    placeholder: n.placeholder,
    disabled: n.disabled,
    required: n.required,
    "input-type": n.inputType,
    "show-search-box": n.showSearchBox,
    "ignored-countries": n.ignoredCountries,
    "all-countries": n.allCountries,
    "is-dial-code-visible": n.isDialCodeVisible,
    onInput: r.onTelInput,
    onClickedOutside: r.onClickedOutside,
    onClickOnInput: t[0] || (t[0] = (f) => e.$emit("click-on-input")),
    onCountryListClose: t[1] || (t[1] = (f) => e.$emit("country-list-close")),
    onCountryListOpen: t[2] || (t[2] = (f) => e.$emit("country-list-open")),
    onSelectCountry: t[3] || (t[3] = (f) => e.$emit("select-country", f))
  }, {
    "error-message": g(() => [
      r.showError ? (a(), k(i, {
        key: 0,
        color: r.errorColor,
        dir: r.directionAppText,
        variant: "caption-2",
        class: "d-block mt-2 px-1"
      }, {
        default: g(() => [
          D(O(n.invalidMsg || r.errorMessage), 1)
        ]),
        _: 1
      }, 8, ["color", "dir"])) : A("", !0)
    ]),
    _: 1
  }, 8, ["class", "value", "placeholder", "disabled", "required", "input-type", "show-search-box", "ignored-countries", "all-countries", "is-dial-code-visible", "onInput", "onClickedOutside"]);
}
const J7 = /* @__PURE__ */ u(sa, [["render", ca]]), ua = {
  PRIMARY: "primary",
  ERROR: "error",
  SUCCESS: "success",
  WARNING: "warning",
  GRAY: "gray",
  LINK: "link"
};
const fa = {
  name: "app-badge",
  components: {
    AppText: R
  },
  props: {
    text: {
      type: String,
      required: !0
    },
    color: {
      type: String,
      required: !0,
      validator: h.isIncludeValues(Object.values(ua), "color")
    }
  },
  setup(e) {
    return {
      styleClasses: [`bg-${e.color}-40`, `border-${e.color}-90`],
      textColor: `${e.color}-100`
    };
  }
};
function pa(e, t, n, r, l, d) {
  const i = _("app-text");
  return a(), c("div", {
    class: T(["app-badge px-2 py-0 border-sm", r.styleClasses])
  }, [
    b(i, {
      class: "text-uppercase",
      variant: "small",
      weight: "semi-bold",
      color: r.textColor
    }, {
      default: g(() => [
        D(O(n.text), 1)
      ]),
      _: 1
    }, 8, ["color"])
  ], 2);
}
const ec = /* @__PURE__ */ u(fa, [["render", pa], ["__scopeId", "data-v-3603cbac"]]);
const $a = {
  name: "app-simple-card",
  props: {
    isActive: {
      type: Boolean,
      default: !1
    },
    hideShadow: {
      type: Boolean,
      default: !1
    }
  }
}, Ca = { class: "app-simple-card__content position-relative z-1" };
function _a(e, t, n, r, l, d) {
  return a(), c("div", {
    class: T(["app-simple-card position-relative app-simple-card__border-radius pa-2 bg-white", { "app-simple-card--shadow": !n.hideShadow }])
  }, [
    o("div", {
      class: T(["app-simple-card__border app-simple-card__border-radius position-absolute", { "app-simple-card__border--active": n.isActive }])
    }, null, 2),
    o("div", Ca, [
      x(e.$slots, "default", {}, void 0, !0)
    ])
  ], 2);
}
const tc = /* @__PURE__ */ u($a, [["render", _a], ["__scopeId", "data-v-17252a78"]]);
const ga = {
  name: "app-bottom-bar",
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    return { clickOutside: () => {
      t("update:modelValue", !1);
    } };
  }
}, ya = {
  key: 0,
  class: "app-bottom-bar py-0 py-lg-2 position-fixed bg-white"
}, ma = { class: "v-container" };
function ha(e, t, n, r, l, d) {
  const i = ne("click-outside");
  return a(), k(rn, { name: "slide-up" }, {
    default: g(() => [
      n.modelValue ? S1((a(), c("div", ya, [
        o("div", ma, [
          x(e.$slots, "default", {}, void 0, !0)
        ])
      ])), [
        [i, r.clickOutside]
      ]) : A("", !0)
    ]),
    _: 3
  });
}
const nc = /* @__PURE__ */ u(ga, [["render", ha], ["__scopeId", "data-v-b33546a7"]]);
function rc(e) {
  return {
    fa: "app--farsi",
    tr: "app--tr",
    vi: "app--vi",
    th: "app--th"
  }[e] || "";
}
const va = {};
function ba(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M13.07 10.41A5 5 0 0 0 13.07 4.59A3.39 3.39 0 0 1 15 4A3.5 3.5 0 0 1 15 11A3.39 3.39 0 0 1 13.07 10.41M5.5 7.5A3.5 3.5 0 1 1 9 11A3.5 3.5 0 0 1 5.5 7.5M7.5 7.5A1.5 1.5 0 1 0 9 6A1.5 1.5 0 0 0 7.5 7.5M16 17V19H2V17S2 13 9 13 16 17 16 17M14 17C13.86 16.22 12.67 15 9 15S4.07 16.31 4 17M15.95 13A5.32 5.32 0 0 1 18 17V19H22V17S22 13.37 15.94 13Z" }, null, -1)
  ]));
}
const Ia = /* @__PURE__ */ u(va, [["render", ba]]), Ma = {}, ka = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
function xa(e, t) {
  return a(), c("svg", ka, t[0] || (t[0] = [
    o("path", { d: "M22.1027 11.8187L20.9006 10.6166C20.7444 10.4604 20.4911 10.4604 20.3349 10.6166L13.2198 17.7317L13.2198 2.51664C13.2198 2.29572 13.0408 2.11664 12.8198 2.11664H11.1198C10.8989 2.11664 10.7198 2.29572 10.7198 2.51664L10.7198 17.6681L3.66837 10.6166C3.51216 10.4604 3.2589 10.4604 3.10269 10.6166L1.9006 11.8187C1.74439 11.9749 1.74439 12.2282 1.9006 12.3844L11.7188 22.2026C11.875 22.3588 12.1283 22.3588 12.2845 22.2026L22.1027 12.3844C22.2589 12.2282 22.2589 11.9749 22.1027 11.8187Z" }, null, -1)
  ]));
}
const Na = /* @__PURE__ */ u(Ma, [["render", xa]]), Sa = {}, La = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
function Aa(e, t) {
  return a(), c("svg", La, t[0] || (t[0] = [
    o("path", { d: "M12.4011 2.11716L13.6031 3.31924C13.7594 3.47545 13.7594 3.72871 13.6031 3.88492L6.48807 11H21.7031C21.9241 11 22.1031 11.1791 22.1031 11.4V13.1C22.1031 13.3209 21.9241 13.5 21.7031 13.5H6.55168L13.6031 20.5515C13.7594 20.7077 13.7594 20.9609 13.6031 21.1172L12.4011 22.3192C12.2449 22.4755 11.9916 22.4755 11.8354 22.3192L2.01718 12.501C1.86097 12.3448 1.86097 12.0916 2.01718 11.9354L11.8354 2.11716C11.9916 1.96095 12.2449 1.96095 12.4011 2.11716Z" }, null, -1)
  ]));
}
const wa = /* @__PURE__ */ u(Sa, [["render", Aa]]), Oa = {}, Ta = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
function Da(e, t) {
  return a(), c("svg", Ta, t[0] || (t[0] = [
    o("path", { d: "M11.6021 2.11716L10.4 3.31924C10.2438 3.47545 10.2438 3.72871 10.4 3.88492L17.5151 11H2.30002C2.07911 11 1.90002 11.1791 1.90002 11.4V13.1C1.90002 13.3209 2.07911 13.5 2.30002 13.5H17.4515L10.4 20.5515C10.2438 20.7077 10.2438 20.9609 10.4 21.1172L11.6021 22.3192C11.7583 22.4755 12.0116 22.4755 12.1678 22.3192L21.986 12.501C22.1422 12.3448 22.1422 12.0916 21.986 11.9354L12.1678 2.11716C12.0116 1.96095 11.7583 1.96095 11.6021 2.11716Z" }, null, -1)
  ]));
}
const Ea = /* @__PURE__ */ u(Oa, [["render", Da]]), Va = {}, ja = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
function Pa(e, t) {
  return a(), c("svg", ja, t[0] || (t[0] = [
    o("path", { d: "M22.1027 12.6177L20.9006 13.8198C20.7444 13.976 20.4911 13.976 20.3349 13.8198L13.2198 6.70468L13.2198 21.9198C13.2198 22.1407 13.0408 22.3198 12.8198 22.3198H11.1198C10.8989 22.3198 10.7198 22.1407 10.7198 21.9198L10.7198 6.76829L3.66837 13.8198C3.51216 13.976 3.2589 13.976 3.10269 13.8198L1.9006 12.6177C1.74439 12.4615 1.74439 12.2082 1.9006 12.052L11.7188 2.23379C11.875 2.07758 12.1283 2.07758 12.2845 2.23379L22.1027 12.052C22.2589 12.2082 22.2589 12.4615 22.1027 12.6177Z" }, null, -1)
  ]));
}
const Ha = /* @__PURE__ */ u(Va, [["render", Pa]]), Ra = {};
function Ba(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M11.7 14.8 3.4 6.4a.4.4 0 0 0-.6 0L1.6 7.6c-.2.2-.2.4 0 .6l9.8 9.8c.2.2.4.2.6 0l9.8-9.8c.2-.2.2-.4 0-.6l-1.2-1.2a.4.4 0 0 0-.6 0l-8.3 8.4Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const za = /* @__PURE__ */ u(Ra, [["render", Ba]]), Fa = {};
function Ua(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M9.2 12.2 17.5 4c.2-.2.2-.4 0-.6l-1.2-1.2a.4.4 0 0 0-.6 0L6 12v.6l9.8 9.8c.2.2.4.2.6 0l1.2-1.2c.2-.1.2-.4 0-.5l-8.3-8.4Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Za = /* @__PURE__ */ u(Fa, [["render", Ua]]), Ga = {};
function Ya(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M14.8 12.2 6.5 4a.4.4 0 0 1 0-.6l1.2-1.2h.6L18 12v.6l-9.8 9.8c-.2.2-.4.2-.6 0l-1.2-1.2a.4.4 0 0 1 0-.5l8.3-8.4Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Wa = /* @__PURE__ */ u(Ga, [["render", Ya]]), Qa = {};
function Ka(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M5.4 10.2a.4.4 0 0 1 0-.6l1.2-1.2c.2-.2.4-.2.6 0l4.8 4.8 4.8-4.8c.2-.2.4-.2.6 0l1.2 1.2c.2.2.2.4 0 .6l-6.3 6.3h-.6l-6.3-6.3Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Xa = /* @__PURE__ */ u(Qa, [["render", Ka]]), qa = {};
function Ja(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M18.6 14.7c.2.2.2.4 0 .6l-1.2 1.2h-.6L12 11.7l-4.8 4.8h-.6l-1.2-1.2a.4.4 0 0 1 0-.6l6.3-6.3c.2-.2.4-.2.6 0l6.3 6.3Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const ei = /* @__PURE__ */ u(qa, [["render", Ja]]), ti = {};
function ni(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("line", {
      x1: "7",
      y1: "17",
      x2: "17",
      y2: "7"
    }, null, -1),
    o("polyline", { points: "7 7 17 7 17 17" }, null, -1)
  ]));
}
const ri = /* @__PURE__ */ u(ti, [["render", ni]]), oi = {};
function di(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M11.7 9.7 3.4 18c-.2.2-.4.2-.6 0l-1.2-1.2a.4.4 0 0 1 0-.6l9.8-9.8h.6l9.8 9.8c.2.2.2.5 0 .6L20.6 18c-.2.2-.4.2-.6 0l-8.3-8.3Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const li = /* @__PURE__ */ u(oi, [["render", di]]), ai = {};
function ii(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M 3.308594 18.683594 C 3.308594 18.421875 3.515625 18.207031 3.777344 18.207031 L 20.71875 18.207031 C 20.976562 18.207031 21.1875 18.421875 21.1875 18.683594 L 21.1875 20.601562 C 21.1875 20.867188 20.976562 21.082031 20.71875 21.082031 L 3.777344 21.082031 C 3.515625 21.082031 3.308594 20.867188 3.308594 20.601562 Z M 3.308594 18.683594 " }, null, -1),
    o("path", { d: "M 6.128906 9.65625 C 6.128906 9.390625 6.339844 9.175781 6.601562 9.175781 L 8.484375 9.175781 C 8.742188 9.175781 8.953125 9.390625 8.953125 9.65625 L 8.953125 16.363281 C 8.953125 16.628906 8.742188 16.84375 8.484375 16.84375 L 6.601562 16.84375 C 6.339844 16.84375 6.128906 16.628906 6.128906 16.363281 Z M 6.128906 9.65625 " }, null, -1),
    o("path", { d: "M 10.835938 9.65625 C 10.835938 9.390625 11.046875 9.175781 11.308594 9.175781 L 13.1875 9.175781 C 13.449219 9.175781 13.660156 9.390625 13.660156 9.65625 L 13.660156 16.363281 C 13.660156 16.628906 13.449219 16.84375 13.1875 16.84375 L 11.308594 16.84375 C 11.046875 16.84375 10.835938 16.628906 10.835938 16.363281 Z M 10.835938 9.65625 " }, null, -1),
    o("path", { d: "M 15.542969 9.65625 C 15.542969 9.390625 15.753906 9.175781 16.011719 9.175781 L 17.894531 9.175781 C 18.15625 9.175781 18.367188 9.390625 18.367188 9.65625 L 18.367188 16.363281 C 18.367188 16.628906 18.15625 16.84375 17.894531 16.84375 L 16.011719 16.84375 C 15.753906 16.84375 15.542969 16.628906 15.542969 16.363281 Z M 15.542969 9.65625 " }, null, -1),
    o("path", { d: "M 12.480469 1.265625 C 12.636719 1.167969 12.832031 1.171875 12.984375 1.277344 L 21.308594 6.9375 C 21.699219 7.199219 21.515625 7.816406 21.050781 7.816406 L 3.574219 7.816406 C 3.101562 7.816406 2.925781 7.179688 3.332031 6.925781 Z M 12.480469 1.265625 " }, null, -1)
  ]));
}
const si = /* @__PURE__ */ u(ai, [["render", ii]]), ci = {};
function ui(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: `M4.99159 6.75936C2.42208 10.1866 2.69583 15.0702 5.81282 18.1872C8.92981 21.3042 13.8134 21.5779
      17.2406 19.0084L4.99159 6.75936ZM6.75936 4.99159L19.0084 17.2406C21.5779 13.8134 21.3042 8.92981
      18.1872 5.81282C15.0702 2.69583 10.1866 2.42208 6.75936 4.99159ZM4.04505 19.955C-0.34835 15.5616
      -0.34835 8.43845 4.04505 4.04505C8.43845 -0.34835 15.5616 -0.34835 19.955 4.04505C24.3483 8.43845
      24.3483 15.5616 19.955 19.955C15.5616 24.3483 8.43845 24.3483 4.04505 19.955Z`,
      fill: "currentColor"
    }, null, -1)
  ]));
}
const fi = /* @__PURE__ */ u(ci, [["render", ui]]), pi = {};
function $i(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: `M20 21V21C18.895 21 18 20.105 18 19V5C18 3.895 18.895 3 20
        3V3C21.105 3 22 3.895 22 5V19C22 20.105 21.105 21 20 21Z`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: `M4 21V21C2.895 21 2 20.105 2 19V10.684C2 9.57901 2.895 8.68401
        4 8.68401V8.68401C5.105 8.68401 6 9.57901 6 10.684V19C6 20.105 5.105 21 4 21Z`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: `M12 21V21C10.895 21 10 20.105 10 19V16.368C10 15.263 10.895 14.368
        12 14.368V14.368C13.105 14.368 14 15.263 14 16.368V19C14 20.105 13.105 21 12 21Z`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const Ci = /* @__PURE__ */ u(pi, [["render", $i]]), _i = {};
function gi(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M9.5 5.2c.5.6.5 1.6-.2 2.3l-.4.8c-.3 1.2.2 2.4.9 3.5l1 1.3 1.4 1c1 .7 2.2 1.1 3.4 1l1-.5c.6-.6 1.6-.6 2.2 0l2 2c.3.3.3.9 0 1.2L19.5 19c-1 .9-2 1.5-3.2 1.9H15c-3-.1-5.7-2-7.9-4.1-2.1-2.2-4-5-4.2-8L3 7.6c.4-1.2 1-2.3 2-3.2l1-1.1a1 1 0 0 1 1.4 0l2 2Z" }, null, -1)
  ]));
}
const yi = /* @__PURE__ */ u(_i, [["render", gi]]), mi = {};
function hi(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M11.4821 20.5096C10.8944 20.1873 10.5219 19.5186 10.5219 18.7861V17.5V15.0219H9.26443C9.04066 15.0219 8.91843 14.8136 9.06168 14.6763L11.7972 11.5758C11.85 11.5253 11.925 11.5 12 11.5C12.075 11.5 12.15 11.5253 12.2028 11.5758L14.9383 14.6763C15.0816 14.8136 14.9593 15.0219 14.7356 15.0219H13.4781L13.4878 17.5L13.4988 21.307C13.4993 21.4493 13.3661 21.5428 13.252 21.4802L11.4821 20.5096Z",
      fill: "#A0B0C0"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M21.6 3.5H6C3.79086 3.5 2 5.29086 2 7.5V17.1C2 17.3209 2.17909 17.5 2.4 17.5H10.5219V15.0219H9.26443C9.04066 15.0219 8.91843 14.8136 9.06168 14.6763L11.7972 11.5758C11.85 11.5253 11.925 11.5 12 11.5C12.075 11.5 12.15 11.5253 12.2028 11.5758L14.9383 14.6763C15.0816 14.8136 14.9593 15.0219 14.7356 15.0219H13.4781L13.4878 17.5H18C20.2091 17.5 22 15.7091 22 13.5V3.9C22 3.67909 21.8209 3.5 21.6 3.5ZM9.6 6.5H5.4C5.17909 6.5 5 6.67909 5 6.9V8.6C5 8.82091 5.17909 9 5.4 9H9.6C9.82091 9 10 8.82091 10 8.6V6.9C10 6.67909 9.82091 6.5 9.6 6.5ZM18.6 6.5H11.4C11.1791 6.5 11 6.67909 11 6.9V8.6C11 8.82091 11.1791 9 11.4 9H18.6C18.8209 9 19 8.82091 19 8.6V6.9C19 6.67909 18.8209 6.5 18.6 6.5Z",
      fill: "#454D54"
    }, null, -1),
    o("path", {
      d: "M5 6.9C5 6.67909 5.17909 6.5 5.4 6.5H9.6C9.82091 6.5 10 6.67909 10 6.9V8.6C10 8.82091 9.82091 9 9.6 9H5.4C5.17909 9 5 8.82091 5 8.6V6.9Z",
      fill: "#F6F7F8"
    }, null, -1),
    o("path", {
      d: "M11 6.9C11 6.67909 11.1791 6.5 11.4 6.5H18.6C18.8209 6.5 19 6.67909 19 6.9V8.6C19 8.82091 18.8209 9 18.6 9H11.4C11.1791 9 11 8.82091 11 8.6V6.9Z",
      fill: "#F6F7F8"
    }, null, -1)
  ]));
}
const vi = /* @__PURE__ */ u(mi, [["render", hi]]), bi = {};
function Ii(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("line", {
      x1: "18",
      y1: "20",
      x2: "18",
      y2: "10"
    }, null, -1),
    o("line", {
      x1: "12",
      y1: "20",
      x2: "12",
      y2: "4"
    }, null, -1),
    o("line", {
      x1: "6",
      y1: "20",
      x2: "6",
      y2: "14"
    }, null, -1)
  ]));
}
const Mi = /* @__PURE__ */ u(bi, [["render", Ii]]), ki = {}, xi = {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ni(e, t) {
  return a(), c("svg", xi, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.99999 0.667969C3.9499 0.667969 0.666656 3.95121 0.666656 8.0013C0.666656 12.0514 3.9499 15.3346 7.99999 15.3346C12.0501 15.3346 15.3333 12.0514 15.3333 8.0013C15.3333 3.95121 12.0501 0.667969 7.99999 0.667969ZM11.4007 6.59125C11.5049 6.48711 11.5049 6.31827 11.4007 6.21413L10.5993 5.41274C10.4952 5.3086 10.3264 5.3086 10.2222 5.41274L7.00003 8.63492L5.77785 7.41274C5.67371 7.3086 5.50486 7.3086 5.40072 7.41274L4.59933 8.21413C4.49519 8.31827 4.49519 8.48711 4.59933 8.59125L6.81147 10.8034C6.91561 10.9075 7.08445 10.9075 7.18859 10.8034L11.4007 6.59125Z"
    }, null, -1)
  ]));
}
const Si = /* @__PURE__ */ u(ki, [["render", Ni]]), Li = {};
function Ai(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "stroke-width": "1.5",
      d: "M19.6 7.4 12 15l-3.8-3.8"
    }, null, -1),
    o("path", {
      "stroke-width": "1.5",
      d: "M21 12a9 9 0 1 1-5-8"
    }, null, -1)
  ]));
}
const wi = /* @__PURE__ */ u(Li, [["render", Ai]]), Oi = {}, Ti = { points: "20 6 9 17 4 12" };
function Di(e, t) {
  return a(), c("polyline", Ti);
}
const Ei = /* @__PURE__ */ u(Oi, [["render", Di]]), Vi = {}, ji = {
  stroke: "none",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17.101 9.60104C17.2572 9.75725 17.2572 10.0105 17.101 10.1667L10.7828 16.4849C10.6266 16.6411 10.3734 16.6411 10.2172 16.4849L6.89896 13.1667C6.74275 13.0105 6.74275 12.7572 6.89896 12.601L8.10104 11.399C8.25725 11.2427 8.51051 11.2427 8.66672 11.399L10.5 13.2322L15.3333 8.39896C15.4895 8.24275 15.7427 8.24275 15.899 8.39896L17.101 9.60104Z",
  fill: "currentColor"
};
function Pi(e, t) {
  return a(), c("path", ji);
}
const Hi = /* @__PURE__ */ u(Vi, [["render", Pi]]), Ri = {}, Bi = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.39998 10.75L17.6 10.75C17.8209 10.75 18 10.9291 18 11.15V12.85C18 13.0709 17.8209 13.25 17.6 13.25H6.39998C6.17907 13.25 5.99998 13.0709 5.99998 12.85V11.15C5.99998 10.9291 6.17907 10.75 6.39998 10.75Z",
  stroke: "none",
  fill: "currentColor"
};
function zi(e, t) {
  return a(), c("path", Bi);
}
const Fi = /* @__PURE__ */ u(Ri, [["render", zi]]), Ui = {}, Zi = { points: "6 9 12 15 18 9" };
function Gi(e, t) {
  return a(), c("polyline", Zi);
}
const Yi = /* @__PURE__ */ u(Ui, [["render", Gi]]), Wi = {}, Qi = { points: "15 18 9 12 15 6" };
function Ki(e, t) {
  return a(), c("polyline", Qi);
}
const Xi = /* @__PURE__ */ u(Wi, [["render", Ki]]), qi = {}, Ji = { points: "9 18 15 12 9 6" };
function e9(e, t) {
  return a(), c("polyline", Ji);
}
const t9 = /* @__PURE__ */ u(qi, [["render", e9]]), n9 = {}, r9 = { points: "18 15 12 9 6 15" };
function o9(e, t) {
  return a(), c("polyline", r9);
}
const d9 = /* @__PURE__ */ u(n9, [["render", o9]]), l9 = {};
function a9(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, -1),
    o("line", {
      x1: "15",
      y1: "9",
      x2: "9",
      y2: "15"
    }, null, -1),
    o("line", {
      x1: "9",
      y1: "9",
      x2: "15",
      y2: "15"
    }, null, -1)
  ]));
}
const i9 = /* @__PURE__ */ u(l9, [["render", a9]]), s9 = {};
function c9(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M10.2 12 5.7 7.5a.4.4 0 0 1 0-.6L7 5.7h.6l4.5 4.5 4.5-4.5h.6L18.3 7v.6L13.8 12l4.5 4.5v.6L17 18.3h-.6L12 13.8l-4.5 4.5H7L5.7 17a.4.4 0 0 1 0-.6l4.5-4.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const u9 = /* @__PURE__ */ u(s9, [["render", c9]]), f9 = {};
function p9(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("rect", {
      width: "14",
      height: "14",
      "stroke-width": "1.5",
      rx: "2",
      transform: "matrix(-1 0 0 1 17 7)"
    }, null, -1),
    o("path", {
      "stroke-width": "1.5",
      d: "M17 17h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2"
    }, null, -1)
  ]));
}
const $9 = /* @__PURE__ */ u(f9, [["render", p9]]), C9 = {};
function _9(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M20.8 2H18c-.2 0-.4.2-.4.4v1.7c0 .2.2.4.4.4h.7v.6c0 .2.2.4.4.4h1.7c.3 0 .4-.2.4-.4V2.4c0-.2-.1-.4-.4-.4Zm-2.1 4.9c0-.2.2-.4.4-.4h1.7c.3 0 .4.2.4.4V10c0 .2-.1.4-.3.4H19a.4.4 0 0 1-.4-.4V6.9Zm.4 4.5c-.2 0-.4.2-.4.4V15c0 .2.2.4.4.4H21c.2 0 .4-.2.4-.4v-3.2c0-.2-.2-.4-.4-.4h-2ZM8.1 2c-.2 0-.4.2-.4.4v1.7c0 .2.2.4.4.4h3.2c.2 0 .4-.2.4-.4V2.4c0-.2-.2-.4-.4-.4H8.1Zm4.6.4c0-.2.2-.4.4-.4h3.1c.2 0 .4.2.4.4v1.7c0 .2-.2.4-.4.4h-3.1a.4.4 0 0 1-.4-.4V2.4Z" }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      d: "M3 6.8c0-.6.4-1 1-1h12.5c.6 0 1 .4 1 1v14.4c0 .6-.4 1-1 1H4a1 1 0 0 1-1-1V6.8Zm2.5 12.6c0 .2.2.4.4.4h8.7c.2 0 .4-.2.4-.4V8.7c0-.3-.2-.4-.4-.4H5.9c-.2 0-.4.1-.4.3v10.8Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const g9 = /* @__PURE__ */ u(C9, [["render", _9]]), y9 = {};
function m9(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M7 5.4C7 5.17909 6.82091 5 6.6 5H2.4C2.17909 5 2 5.17909 2 5.4V9.6C2 9.82091 2.18089 9.99583 2.39745 10.0395C3.31161 10.2238 4 11.0315 4 12C4 12.9685 3.31161 13.7762 2.39745 13.9605C2.18089 14.0042 2 14.1791 2 14.4V18.6C2 18.8209 2.17909 19 2.4 19H6.6C6.82091 19 7 18.8209 7 18.6V5.4Z" }, null, -1),
    o("path", { d: "M22 5.4C22 5.17909 21.8209 5 21.6 5H8.9C8.67909 5 8.5 5.17909 8.5 5.4V18.6C8.5 18.8209 8.67909 19 8.9 19H21.6C21.8209 19 22 18.8209 22 18.6V14.4C22 14.1791 21.8191 14.0042 21.6026 13.9605C20.6884 13.7762 20 12.9685 20 12C20 11.0315 20.6884 10.2238 21.6026 10.0395C21.8191 9.99583 22 9.82091 22 9.6V5.4Z" }, null, -1)
  ]));
}
const h9 = /* @__PURE__ */ u(y9, [["render", m9]]), v9 = {};
function b9(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M3 7H21",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M9.57 11H7",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M8 17H6C4.343 17 3 15.657 3 14V6C3 4.343 4.343 3 6 3H18C19.657 3 21 4.343 21 6V10",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M22.5 16.5L21 15L19.5 16.5",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M11.5 17.5L13 19L14.5 17.5",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M13 19V15C13 13.895 13.895 13 15 13H18",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M21 15V19C21 20.1 20.1 21 19 21H16.011",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const I9 = /* @__PURE__ */ u(v9, [["render", b9]]), M9 = {};
function k9(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M12 21V12",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M10 19L12 21L14 19",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M3 8H21",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M8 16H6C4.343 16 3 14.657 3 13V6C3 4.343 4.343 3 6 3H18C19.657 3 21 4.343 21 6V13C21 14.657 19.657 16 18 16H16",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const x9 = /* @__PURE__ */ u(M9, [["render", k9]]), N9 = {}, S9 = {
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function L9(e, t) {
  return a(), c("svg", S9, t[0] || (t[0] = [
    o("circle", {
      cx: "4",
      cy: "4",
      r: "4",
      fill: "#E3E8ED"
    }, null, -1)
  ]));
}
const A9 = /* @__PURE__ */ u(N9, [["render", L9]]), w9 = {}, O9 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function T9(e, t) {
  return a(), c("svg", O9, t[0] || (t[0] = [
    k1('<path d="M3 21.4C3 21.1791 3.17909 21 3.4 21H20.6C20.8209 21 21 21.1791 21 21.4V22.6C21 22.8209 20.8209 23 20.6 23H3.4C3.17909 23 3 22.8209 3 22.6V21.4Z" fill="#56351D"></path><path d="M10.7915 3.09088C9.4203 3.77121 8.5511 5.18288 8.5511 6.72944V12.5648H5.617C5.09488 12.5648 4.80966 13.0047 5.14391 13.2944L11.5269 19.8399C11.65 19.9466 11.825 20 12 20C12.175 20 12.35 19.9466 12.4731 19.8399L18.8561 13.2944C19.1903 13.0047 18.9051 12.5648 18.383 12.5648H15.4489L15.4972 1.40746C15.4985 1.10694 15.1877 0.909625 14.9212 1.04183L10.7915 3.09088Z" fill="url(#paint0_linear_1623_1053)"></path><defs><linearGradient id="paint0_linear_1623_1053" x1="19" y1="1.19792" x2="0.852783" y2="14.5696" gradientUnits="userSpaceOnUse"><stop stop-color="#E1A329"></stop><stop offset="1" stop-color="#BB8B10"></stop></linearGradient></defs>', 3)
  ]));
}
const D9 = /* @__PURE__ */ u(w9, [["render", T9]]), E9 = {}, V9 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function j9(e, t) {
  return a(), c("svg", V9, t[0] || (t[0] = [
    o("path", {
      d: "M3 21.4C3 21.1791 3.17909 21 3.4 21H20.6C20.8209 21 21 21.1791 21 21.4V22.6C21 22.8209 20.8209 23 20.6 23H3.4C3.17909 23 3 22.8209 3 22.6V21.4Z",
      fill: "#A0B0C0"
    }, null, -1),
    o("path", {
      d: "M10.7915 3.09088C9.4203 3.77121 8.5511 5.18288 8.5511 6.72944V12.5648H5.617C5.09488 12.5648 4.80966 13.0047 5.14391 13.2944L11.5269 19.8399C11.65 19.9466 11.825 20 12 20C12.175 20 12.35 19.9466 12.4731 19.8399L18.8561 13.2944C19.1903 13.0047 18.9051 12.5648 18.383 12.5648H15.4489L15.4972 1.40746C15.4985 1.10694 15.1877 0.909625 14.9212 1.04183L10.7915 3.09088Z",
      fill: "#454D54"
    }, null, -1)
  ]));
}
const P9 = /* @__PURE__ */ u(E9, [["render", j9]]), H9 = {};
function R9(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M14.119 1.87868C12.9474 0.707107 11.0479 0.707106 9.87631 1.87868L8.41262 3.34237H6.34254C4.68568 3.34237 3.34254 4.68551 3.34254 6.34237V8.41245L1.87868 9.87631C0.707107 11.0479 0.707106 12.9474 1.87868 14.1189L3.34254 15.5828V17.6527C3.34254 19.3096 4.68568 20.6527 6.34253 20.6527H8.41245L9.87631 22.1166C11.0479 23.2882 12.9474 23.2882 14.1189 22.1166L15.5828 20.6527H17.6529C19.3097 20.6527 20.6529 19.3096 20.6529 17.6527V15.5826L22.1166 14.119C23.2882 12.9474 23.2882 11.0479 22.1166 9.87631L20.6529 8.41262V6.34237C20.6529 4.68551 19.3097 3.34237 17.6529 3.34237H15.5826L14.119 1.87868Z",
      fill: "#454D54"
    }, null, -1),
    o("path", {
      d: "M15.2527 7.33307C15.4089 7.17686 15.6622 7.17686 15.8184 7.33307L16.6669 8.1816C16.8232 8.33781 16.8232 8.59108 16.6669 8.74729L8.74735 16.6669C8.59114 16.8231 8.33787 16.8231 8.18166 16.6669L7.33314 15.8184C7.17693 15.6621 7.17693 15.4089 7.33314 15.2527L15.2527 7.33307Z",
      fill: "#F6F7F8"
    }, null, -1),
    o("path", {
      d: "M9.87872 9.87866C9.29293 10.4644 8.34319 10.4644 7.7574 9.87866C7.17161 9.29287 7.17161 8.34313 7.7574 7.75734C8.34319 7.17155 9.29293 7.17155 9.87872 7.75734C10.4645 8.34313 10.4645 9.29287 9.87872 9.87866Z",
      fill: "#F6F7F8"
    }, null, -1),
    o("path", {
      d: "M16.2427 16.2426C15.6569 16.8284 14.7071 16.8284 14.1214 16.2426C13.5356 15.6568 13.5356 14.7071 14.1214 14.1213C14.7071 13.5355 15.6569 13.5355 16.2427 14.1213C16.8285 14.7071 16.8285 15.6568 16.2427 16.2426Z",
      fill: "#F6F7F8"
    }, null, -1)
  ]));
}
const B9 = /* @__PURE__ */ u(H9, [["render", R9]]), z9 = {};
function F9(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "stroke-width": "1.5",
      d: "M10 8.2a2.2 2.2 0 1 1-3 3.1 2.2 2.2 0 0 1 3-3.1"
    }, null, -1),
    o("path", {
      "stroke-width": "1.5",
      d: "M2 18.5v-13c0-1 1-2 2-2h16a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2Z",
      "clip-rule": "evenodd"
    }, null, -1),
    o("path", {
      "stroke-width": "1.5",
      d: "M15 9.5h4m-1.6 4H15m-2.9 3c-.2-.4-.4-.8-.8-1.2v0c-.6-.5-1.4-.8-2.2-.8H8c-.8 0-1.6.3-2.2.8v0c-.4.4-.6.8-.8 1.2"
    }, null, -1)
  ]));
}
const U9 = /* @__PURE__ */ u(z9, [["render", F9]]), Z9 = {};
function G9(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M11.9221 10.7778C9.46927 10.1222 8.68047 9.44444 8.68047 8.38889C8.68047 7.17778 9.77182 6.33333 11.598 6.33333C13.3403 6.33333 14.0895 7.10836 14.2633 8.28673C14.2945 8.49811 14.4674 8.66667 14.6811 8.66667H16.2712C16.4983 8.66667 16.6817 8.47723 16.6507 8.25224C16.41 6.5063 15.0947 4.95876 13.0007 4.43333V2.4C13.0007 2.17909 12.8216 2 12.6007 2L10.3771 2C10.1562 2 9.97713 2.17909 9.97713 2.4V4.4C7.88086 4.86667 6.1952 6.26667 6.1952 8.41111C6.1952 10.9778 8.25905 12.2556 11.2738 13C13.9752 13.6667 14.5154 14.6444 14.5154 15.6778C14.5154 16.4444 13.986 17.6667 11.598 17.6667C9.58108 17.6667 8.6731 16.8274 8.43192 15.6945C8.38883 15.4921 8.21946 15.3333 8.01254 15.3333H6.42259C6.19331 15.3333 6.00921 15.5264 6.04061 15.7535C6.34082 17.925 8.02504 19.1602 9.97713 19.5889V21.6C9.97713 21.8209 10.1562 22 10.3771 22H12.6007C12.8216 22 13.0007 21.8209 13.0007 21.6V19.6111C15.1078 19.2 17.0007 17.9444 17.0007 15.6667C17.0007 12.5111 14.375 11.4333 11.9221 10.7778Z",
      fill: "url(#paint0_linear_2877_949)"
    }, null, -1),
    o("defs", null, [
      o("linearGradient", {
        id: "paint0_linear_2877_949",
        x1: "17.0007",
        y1: "2.20833",
        x2: "0.140134",
        y2: "11.451",
        gradientUnits: "userSpaceOnUse"
      }, [
        o("stop", { "stop-color": "#E1A329" }),
        o("stop", {
          offset: "1",
          "stop-color": "#BB8B10"
        })
      ])
    ], -1)
  ]));
}
const Y9 = /* @__PURE__ */ u(Z9, [["render", G9]]), W9 = {};
function Q9(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M5.97006 9.17341C7.71953 5.95839 11.4271 4.33988 14.9742 5.24276C18.5213 6.14564 21.0039 9.33981 21.0033 13",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M13 10.545V9.99875",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M13 15.456V16.0013",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: `M11.5784 14.8708C11.7886 15.2313 12.1735 15.4541 12.5908 15.457H13.4912C14.0707
       15.4558 14.5587 15.0234 14.6296 14.4482C14.7005 13.873 14.3322 13.335 13.7703
       13.1931L12.2357 12.8079C11.6725 12.6677 11.3024 12.1294 11.3732 11.5534C11.444
       10.9773 11.9334 10.5446 12.5138 10.545H13.4142C13.8302 10.5477 14.214 10.7698 14.4236 11.1292`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M4.99666 13C4.9961 16.6602 7.47868 19.8544 11.0258 20.7572C14.5728 21.6601 18.2805 20.0416 20.0299 16.8266",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M9.04535 9.17341H5.50888V5.63593",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M16.9546 16.8266H20.4911V20.3641",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const K9 = /* @__PURE__ */ u(W9, [["render", Q9]]), X9 = {};
function q9(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M11.9221 10.7778C9.46927 10.1222 8.68047 9.44444 8.68047 8.38889C8.68047 7.17778 9.77182 6.33333 11.598 6.33333C13.3403 6.33333 14.0895 7.10836 14.2633 8.28673C14.2945 8.49811 14.4674 8.66667 14.6811 8.66667H16.2712C16.4983 8.66667 16.6817 8.47723 16.6507 8.25224C16.41 6.5063 15.0947 4.95876 13.0007 4.43333V2.4C13.0007 2.17909 12.8216 2 12.6007 2L10.3771 2C10.1562 2 9.97713 2.17909 9.97713 2.4V4.4C7.88086 4.86667 6.1952 6.26667 6.1952 8.41111C6.1952 10.9778 8.25905 12.2556 11.2738 13C13.9752 13.6667 14.5154 14.6444 14.5154 15.6778C14.5154 16.4444 13.986 17.6667 11.598 17.6667C9.58108 17.6667 8.6731 16.8274 8.43192 15.6945C8.38883 15.4921 8.21946 15.3333 8.01254 15.3333H6.42259C6.19331 15.3333 6.00921 15.5264 6.04061 15.7535C6.34082 17.925 8.02504 19.1602 9.97713 19.5889V21.6C9.97713 21.8209 10.1562 22 10.3771 22H12.6007C12.8216 22 13.0007 21.8209 13.0007 21.6V19.6111C15.1078 19.2 17.0007 17.9444 17.0007 15.6667C17.0007 12.5111 14.375 11.4333 11.9221 10.7778Z" }, null, -1)
  ]));
}
const J9 = /* @__PURE__ */ u(X9, [["render", q9]]), e3 = {};
function t3(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.7407 7.22292L10.324 10.8062L10.324 2.22396C10.324 2.00305 10.5031 1.82396 10.724 1.82396L12.424 1.82396C12.6449 1.82396 12.824 2.00305 12.824 2.22396L12.824 10.8062L16.4072 7.22292C16.5635 7.06671 16.8167 7.06671 16.9729 7.22292L18.175 8.425C18.3312 8.58121 18.3312 8.83448 18.175 8.99069L11.8568 15.3089C11.7006 15.4651 11.4473 15.4651 11.2911 15.3089L4.97293 8.99069C4.81672 8.83448 4.81672 8.58121 4.97293 8.425L6.17502 7.22292C6.33123 7.06671 6.58449 7.06671 6.7407 7.22292Z"
    }, null, -1),
    o("path", { d: "M18.824 14.826V19.676H4.32397L4.32397 14.826C4.32397 14.6051 4.14489 14.426 3.92398 14.426H2.22397C2.00306 14.426 1.82397 14.6051 1.82397 14.826L1.82397 21.776C1.82397 21.997 2.00306 22.176 2.22397 22.176H20.924C21.1449 22.176 21.324 21.997 21.324 21.776V14.826C21.324 14.6051 21.1449 14.426 20.924 14.426H19.224C19.0031 14.426 18.824 14.6051 18.824 14.826Z" }, null, -1)
  ]));
}
const n3 = /* @__PURE__ */ u(e3, [["render", t3]]), r3 = {};
function o3(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M20.6239 5.53084C21.1254 6.03225 21.1254 6.84608 20.6239 7.34749L19.0768 8.8945C18.9011 9.07022 18.6161 9.07022 18.4404 8.89449L15.1054 5.55946C14.9297 5.38373 14.9296 5.09882 15.1054 4.92308L16.6522 3.37606C17.1536 2.87465 17.9675 2.87465 18.469 3.37606L20.6239 5.53084Z",
      fill: "url(#paint0_linear_2877_892)"
    }, null, -1),
    o("path", {
      d: "M3 17.5608C3 17.2201 3.135 16.8936 3.37673 16.6532L12.8782 7.15065C13.0539 6.9749 13.3388 6.97489 13.5146 7.15063L16.8493 10.4854C17.0251 10.6611 17.0251 10.946 16.8493 11.1218L7.34716 20.6233C7.10672 20.865 6.78014 21 6.43941 21H3.45C3.20147 21 3 20.7985 3 20.55L3 17.5608Z",
      fill: "url(#paint1_linear_2877_892)"
    }, null, -1),
    o("defs", null, [
      o("linearGradient", {
        id: "paint0_linear_2877_892",
        x1: "21",
        y1: "3.1875",
        x2: "3",
        y2: "21.1875",
        gradientUnits: "userSpaceOnUse"
      }, [
        o("stop", { "stop-color": "#E1A329" }),
        o("stop", {
          offset: "1",
          "stop-color": "#BB8B10"
        })
      ]),
      o("linearGradient", {
        id: "paint1_linear_2877_892",
        x1: "21",
        y1: "3.1875",
        x2: "3",
        y2: "21.1875",
        gradientUnits: "userSpaceOnUse"
      }, [
        o("stop", { "stop-color": "#E1A329" }),
        o("stop", {
          offset: "1",
          "stop-color": "#BB8B10"
        })
      ])
    ], -1)
  ]));
}
const d3 = /* @__PURE__ */ u(r3, [["render", o3]]), l3 = {};
function a3(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M20.6 5.5c.5.5.5 1.3 0 1.8L19.1 9c-.2.2-.5.2-.7 0l-3.3-3.3a.4.4 0 0 1 0-.7l1.6-1.5c.5-.5 1.3-.5 1.8 0l2.1 2.1ZM3 17.6c0-.4.1-.7.4-1l9.5-9.4c.2-.2.4-.2.6 0l3.3 3.3c.2.2.2.4 0 .6l-9.5 9.5c-.2.3-.5.4-.9.4h-3a.5.5 0 0 1-.4-.4v-3Z" }, null, -1)
  ]));
}
const i3 = /* @__PURE__ */ u(l3, [["render", a3]]), s3 = {};
function c3(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M2.01979 8.01025L10.4871 3.30413C11.0897 2.97675 11.8129 2.97675 12.4156 3.30413L21.9777 8.61386C22.2991 8.79801 22.5 9.13563 22.5 9.51416V16.072C22.5 16.6347 22.048 17.0951 21.4956 17.0951C20.9431 17.0951 20.4911 16.6347 20.4911 16.072V10.0257L12.4156 14.517C11.8129 14.8546 11.0897 14.8546 10.4871 14.517L2.01979 9.81085C1.32674 9.42209 1.32674 8.39902 2.01979 8.01025Z" }, null, -1),
    o("path", { d: "M3.59619 12.8679V16.0449C3.59619 16.7917 3.99796 17.4874 4.64079 17.8455L10.4868 21.3266C11.0894 21.6642 11.8126 21.6642 12.4153 21.3266L18.2613 17.8455C18.9041 17.4874 19.3059 16.7917 19.3059 16.0449V12.8679C19.3059 12.5401 18.9472 12.3387 18.6673 12.5093L12.4153 16.1843C11.8126 16.5219 11.0894 16.5219 10.4868 16.1843L4.23479 12.5093C3.95491 12.3387 3.59619 12.5401 3.59619 12.8679Z" }, null, -1)
  ]));
}
const u3 = /* @__PURE__ */ u(s3, [["render", c3]]), f3 = {}, p3 = {
  d: `M16 12C16 14.209 14.209 16 12 16C9.791 16 8 14.209 8 12C8 9.791 9.791
     8 12 8V8C14.209 8 16 9.791 16 12V13.5C16 14.881 17.119 16 18.5 16C19.881 16
     21 14.881 21 13.5V12C21 7.029 16.971 3 12 3C7.029 3 3 7.029 3 12C3 16.971
     7.029 21 12 21C13.149 21 14.317 20.782 15.444 20.315C16.052 20.063 16.614
     19.747 17.133 19.386`,
  stroke: "currentColor",
  "stroke-width": "1.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function $3(e, t) {
  return a(), c("path", p3);
}
const C3 = /* @__PURE__ */ u(f3, [["render", $3]]), _3 = {};
function g3(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, -1),
    o("line", {
      x1: "12",
      y1: "8",
      x2: "12",
      y2: "12"
    }, null, -1),
    o("line", {
      x1: "12",
      y1: "16",
      x2: "12.01",
      y2: "16"
    }, null, -1)
  ]));
}
const y3 = /* @__PURE__ */ u(_3, [["render", g3]]), m3 = {};
function h3(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M14.006 12.003L17 15.001L14 18.003",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: `M9 15H5C3.895 15 3 14.105 3 13V5C3 3.895
        3.895 3 5 3H13C14.105 3 15 3.895 15 5V9`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: `M19 21H11C9.895 21 9 20.105 9 19V11C9 9.895
        9.895 9 11 9H19C20.105 9 21 9.895 21 11V19C21 20.105 20.105 21 19 21Z`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M9 15H17",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const v3 = /* @__PURE__ */ u(m3, [["render", h3]]), b3 = {};
function I3(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.89792 4.75H8.74792C8.96883 4.75 9.14792 4.57091 9.14792 4.35V2.65C9.14792 2.42909 8.96883 2.25 8.74792 2.25H1.79792C1.577 2.25 1.39792 2.42909 1.39792 2.65V21.35C1.39792 21.5709 1.577 21.75 1.79792 21.75H8.74792C8.96883 21.75 9.14792 21.5709 9.14792 21.35V19.65C9.14792 19.4291 8.96883 19.25 8.74792 19.25H3.89792V4.75ZM17.1302 13.25L13.5469 16.8333C13.3907 16.9895 13.3907 17.2427 13.5469 17.399L14.749 18.601C14.9052 18.7573 15.1584 18.7573 15.3146 18.601L21.6328 12.2828C21.7891 12.1266 21.7891 11.8734 21.6328 11.7172L15.3146 5.39896C15.1584 5.24275 14.9052 5.24275 14.749 5.39896L13.5469 6.60104C13.3907 6.75725 13.3907 7.01052 13.5469 7.16673L17.1302 10.75H8.54792C8.327 10.75 8.14792 10.9291 8.14792 11.15V12.85C8.14792 13.0709 8.327 13.25 8.54792 13.25H17.1302Z"
    }, null, -1)
  ]));
}
const M3 = /* @__PURE__ */ u(b3, [["render", I3]]), k3 = {};
function x3(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M9.9 4.24002C10.5883 4.0789 11.2931 3.99836 12 4.00003C19 4.00003 23 12 23 12C22.393 13.1356 21.6691 14.2048 20.84 15.19M14.12 14.12C13.8454 14.4148 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.4811 9.80385 14.1962C9.51897 13.9113 9.29439 13.572 9.14351 13.1984C8.99262 12.8249 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2219 9.18488 10.8539C9.34884 10.4859 9.58525 10.1547 9.88 9.88003M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.68192 3.96914 7.65663 6.06 6.06003L17.94 17.94Z",
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M1 1L23 23",
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const N3 = /* @__PURE__ */ u(k3, [["render", x3]]), S3 = {};
function L3(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z",
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const A3 = /* @__PURE__ */ u(S3, [["render", L3]]), w3 = {};
function O3(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M22 12A10 10 0 0 0 12 2 10 10 0 0 0 2 12c0 5 3.7 9.2 8.4 10v-7H8v-3h2.5V9.9C10.4 7.3 12 6 14.2 6l2.3.2v2.5h-1.3c-1.3 0-1.6.8-1.6 1.6V12h2.7l-.3 3h-2.3v7A10 10 0 0 0 22 12Z" }, null, -1)
  ]));
}
const T3 = /* @__PURE__ */ u(w3, [["render", O3]]), D3 = {};
function E3(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" }, null, -1),
    o("polyline", { points: "13 2 13 9 20 9" }, null, -1)
  ]));
}
const V3 = /* @__PURE__ */ u(D3, [["render", E3]]), j3 = {};
function P3(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }, null, -1),
    o("polyline", { points: "14 2 14 8 20 8" }, null, -1),
    o("line", {
      x1: "16",
      y1: "13",
      x2: "8",
      y2: "13"
    }, null, -1),
    o("line", {
      x1: "16",
      y1: "17",
      x2: "8",
      y2: "17"
    }, null, -1),
    o("polyline", { points: "10 9 9 9 8 9" }, null, -1)
  ]));
}
const H3 = /* @__PURE__ */ u(j3, [["render", P3]]), R3 = {};
function B3(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M20 8H4C3.448 8 3 8.448 3 9V11C3 11.552 3.448 12 4 12H20C20.552 12 21 11.552 21 11V9C21 8.448 20.552 8 20 8Z",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M12 21V8",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M15.696 6.61201C14.618 7.73401 12.921 8.00001 12.099 8.00001",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M12.099 8C12.099 8 11.605 4.884 12.82 3.62",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M15.696 6.612C16.49 5.786 16.49 4.446 15.696 3.62C14.902 2.794 13.615 2.794 12.821 3.62",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M8.304 6.61201C9.382 7.73401 11.079 8.00001 11.901 8.00001",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M11.901 8C11.901 8 12.395 4.884 11.18 3.62",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M8.304 6.612C7.51 5.786 7.51 4.446 8.304 3.62C9.098 2.794 10.385 2.794 11.179 3.62",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M19 12V20C19 20.552 18.552 21 18 21H6C5.448 21 5 20.552 5 20V12",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const z3 = /* @__PURE__ */ u(R3, [["render", B3]]), F3 = {};
function U3(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M4.38469 18.4268C4.38469 19.1093 4.67645 19.7638 5.19578 20.2463C5.71511 20.7289 6.41948 21 7.15392 21H11.1347C11.1806 21 11.2246 20.9831 11.2571 20.9529C11.2895 20.9227 11.3078 20.8818 11.3078 20.8392V13.4412C11.3078 13.3986 11.2895 13.3577 11.2571 13.3275C11.2246 13.2974 11.1806 13.2804 11.1347 13.2804H4.73085C4.63904 13.2804 4.551 13.3143 4.48608 13.3746C4.42116 13.4349 4.38469 13.5168 4.38469 13.6021V18.4268Z" }, null, -1),
    o("path", { d: "M11.3077 11.833L11.3076 7.49073H12.6924L12.6923 11.833C12.6923 11.8756 12.7105 11.9166 12.743 11.9467C12.7755 11.9769 12.8195 11.9938 12.8654 11.9938H18.9231C19.1589 11.9938 19.3931 11.9564 19.6154 11.8833C20.02 11.7498 20.3702 11.5033 20.6181 11.1776C20.866 10.8519 20.9994 10.4629 21 10.0639V9.42063C21 8.90878 20.7812 8.41791 20.3917 8.05598C20.0022 7.69406 19.4739 7.49073 18.9231 7.49073H17.1689C17.1539 7.49051 17.1391 7.48663 17.1262 7.47948C17.1132 7.47233 17.1025 7.46216 17.095 7.44997C17.0876 7.43779 17.0837 7.42401 17.0838 7.41C17.0838 7.39599 17.0878 7.38224 17.0954 7.37011C17.496 6.74164 17.6261 5.99568 17.4596 5.28181C17.2932 4.56794 16.8424 3.93894 16.1978 3.52092C15.5532 3.1029 14.7623 2.92678 13.9838 3.02786C13.2052 3.12895 12.4966 3.49977 12 4.06597C11.5034 3.49977 10.7948 3.12895 10.0162 3.02786C9.23771 2.92678 8.44685 3.1029 7.80221 3.52092C7.15758 3.93894 6.70684 4.56794 6.54037 5.28181C6.3739 5.99568 6.50401 6.74164 6.90462 7.37011C6.91215 7.38224 6.91615 7.39599 6.91621 7.41C6.91628 7.42401 6.9124 7.43779 6.90497 7.44997C6.89754 7.46216 6.88681 7.47233 6.87384 7.47948C6.86088 7.48663 6.84613 7.49051 6.83106 7.49073H5.07692C4.52609 7.49073 3.99782 7.69406 3.60832 8.05598C3.21882 8.41791 3 8.90878 3 9.42063V10.0639C3.00061 10.4629 3.13401 10.8519 3.3819 11.1776C3.62978 11.5033 3.98003 11.7498 4.38462 11.8833C4.60694 11.9564 4.84107 11.9938 5.07692 11.9938H11.1346C11.1805 11.9938 11.2245 11.9769 11.257 11.9467C11.2895 11.9166 11.3077 11.8756 11.3077 11.833ZM12.6924 5.88248C12.6924 5.5644 12.7938 5.25346 12.984 4.98899C13.1742 4.72452 13.4445 4.51838 13.7607 4.39666C14.077 4.27493 14.425 4.24308 14.7607 4.30514C15.0965 4.36719 15.4049 4.52036 15.647 4.74528C15.889 4.9702 16.0538 5.25676 16.1206 5.56873C16.1874 5.8807 16.1531 6.20406 16.0221 6.49793C15.8911 6.7918 15.6693 7.04297 15.3846 7.21969C15.1 7.39641 14.7655 7.49073 14.4231 7.49073H12.6924V5.88248ZM9.45317 4.27826C9.69029 4.26246 9.92836 4.29223 10.1526 4.36569C10.3767 4.43916 10.5822 4.55475 10.7562 4.70527C10.9302 4.85578 11.069 5.03798 11.1639 5.24052C11.2587 5.44306 11.3076 5.66159 11.3076 5.88248V7.49073H9.57684C9.1293 7.48966 8.69969 7.32755 8.37802 7.03842C8.05635 6.74929 7.86771 6.35562 7.8517 5.94003C7.83569 5.52443 7.99355 5.11924 8.29215 4.80947C8.59074 4.49971 9.00686 4.30906 9.45317 4.27826Z" }, null, -1),
    o("path", { d: "M12.8655 21H16.8462C17.5807 21 18.285 20.7289 18.8044 20.2463C19.3237 19.7638 19.6155 19.1093 19.6155 18.4268V13.6021C19.6155 13.5168 19.579 13.4349 19.5141 13.3746C19.4492 13.3143 19.3611 13.2804 19.2693 13.2804H12.8655C12.8195 13.2804 12.7755 13.2974 12.7431 13.3275C12.7106 13.3577 12.6924 13.3986 12.6924 13.4412V20.8392C12.6924 20.8818 12.7106 20.9227 12.7431 20.9529C12.7755 20.9831 12.8195 21 12.8655 21Z" }, null, -1)
  ]));
}
const Z3 = /* @__PURE__ */ u(F3, [["render", U3]]), G3 = {};
function Y3(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("rect", {
      x: "3",
      y: "3",
      width: "7",
      height: "7"
    }, null, -1),
    o("rect", {
      x: "14",
      y: "3",
      width: "7",
      height: "7"
    }, null, -1),
    o("rect", {
      x: "14",
      y: "14",
      width: "7",
      height: "7"
    }, null, -1),
    o("rect", {
      x: "3",
      y: "14",
      width: "7",
      height: "7"
    }, null, -1)
  ]));
}
const W3 = /* @__PURE__ */ u(G3, [["render", Y3]]), Q3 = {};
function K3(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M8.99996 16.4286V20.6C8.99996 20.8209 9.17905 21 9.39996 21H22.6C22.8209 21 23 20.8209 23 20.6V16.4286C23 14.7718 21.6568 13.4286 20 13.4286H16H12C10.3431 13.4286 8.99996 14.7718 8.99996 16.4286Z" }, null, -1),
    o("path", { d: "M16.0715 10.8572C18.2412 10.8572 20.0001 9.0983 20.0001 6.9286C20.0001 4.75889 18.2412 3 16.0715 3C13.9018 3 12.1429 4.75889 12.1429 6.9286C12.1429 9.0983 13.9018 10.8572 16.0715 10.8572Z" }, null, -1),
    o("path", { d: "M10.5 7.9286C10.5 10.0983 8.74111 11.8572 6.5714 11.8572C4.4017 11.8572 2.6428 10.0983 2.6428 7.9286C2.6428 5.75889 4.4017 4 6.5714 4C8.74111 4 10.5 5.75889 10.5 7.9286Z" }, null, -1),
    o("path", { d: "M7.49983 20.6V16.4286C7.49983 15.5896 7.70649 14.7989 8.07168 14.1045C8.22517 13.8127 8.02849 13.4286 7.69874 13.4286H3.99998C2.34312 13.4286 1 14.7718 1 16.4286V20.6C1 20.8209 1.17909 21 1.4 21H7.09983C7.32074 21 7.49983 20.8209 7.49983 20.6Z" }, null, -1)
  ]));
}
const X3 = /* @__PURE__ */ u(Q3, [["render", K3]]), q3 = {};
function J3(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M21.71 8.71C22.96 7.46 22.39 6 21.71 5.29L18.71 2.29C17.45 1.04 16 1.61 15.29 2.29L13.59 4H11C9.1 4 8 5 7.44 6.15L3 10.59V14.59L2.29 15.29C1.04 16.55 1.61 18 2.29 18.71L5.29 21.71C5.83 22.25 6.41 22.45 6.96 22.45C7.67 22.45 8.32 22.1 8.71 21.71L11.41 19H15C16.7 19 17.56 17.94 17.87 16.9C19 16.6 19.62 15.74 19.87 14.9C21.42 14.5 22 13.03 22 12V9H21.41L21.71 8.71M20 12C20 12.45 19.81 13 19 13L18 13L18 14C18 14.45 17.81 15 17 15L16 15L16 16C16 16.45 15.81 17 15 17H10.59L7.31 20.28C7 20.57 6.82 20.4 6.71 20.29L3.72 17.31C3.43 17 3.6 16.82 3.71 16.71L5 15.41V11.41L7 9.41V11C7 12.21 7.8 14 10 14S13 12.21 13 11H20V12M20.29 7.29L18.59 9H11V11C11 11.45 10.81 12 10 12S9 11.45 9 11V8C9 7.54 9.17 6 11 6H14.41L16.69 3.72C17 3.43 17.18 3.6 17.29 3.71L20.28 6.69C20.57 7 20.4 7.18 20.29 7.29Z" }, null, -1)
  ]));
}
const e4 = /* @__PURE__ */ u(q3, [["render", J3]]), t4 = {};
function n4(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, -1),
    o("path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }, null, -1),
    o("line", {
      x1: "12",
      y1: "17",
      x2: "12.01",
      y2: "17"
    }, null, -1)
  ]));
}
const r4 = /* @__PURE__ */ u(t4, [["render", n4]]), o4 = {};
function d4(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" }, null, -1),
    o("polyline", { points: "9 22 9 12 15 12 15 22" }, null, -1)
  ]));
}
const l4 = /* @__PURE__ */ u(o4, [["render", d4]]), a4 = {};
function i4(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M12.319 2.64469C12.1398 2.4518 11.8602 2.45177 11.681 2.64459C10.5345 3.87808 5.66571 8.14249 3.28917 10.6241C3.12474 10.8101 3 11.0811 3 11.4006C3 11.9597 3.36207 12.4116 3.81 12.4116H5.43V19.489C5.43 20.0481 5.79207 20.5 6.24 20.5H9.57C10.0179 20.5 10.38 20.0471 10.38 19.489V16.52C10.38 16.2328 10.5872 16 10.8429 16H13.1571C13.4128 16 13.62 16.2328 13.62 16.52V19.489C13.62 20.0471 13.9821 20.5 14.43 20.5H17.76C18.2079 20.5 18.57 20.0481 18.57 19.489V12.4116H20.19C20.6379 12.4116 21 11.9597 21 11.4006C21 11.0811 20.8753 10.8101 20.6898 10.6241C18.3298 8.14256 13.4648 3.87832 12.319 2.64469Z",
      fill: "url(#paint0_linear_337_6804)"
    }, null, -1),
    o("defs", null, [
      o("linearGradient", {
        id: "paint0_linear_337_6804",
        x1: "21",
        y1: "2.6875",
        x2: "3",
        y2: "20.6875",
        gradientUnits: "userSpaceOnUse"
      }, [
        o("stop", { "stop-color": "#E1A329" }),
        o("stop", {
          offset: "1",
          "stop-color": "#BB8B10"
        })
      ])
    ], -1)
  ]));
}
const s4 = /* @__PURE__ */ u(a4, [["render", i4]]), c4 = {}, u4 = { d: "M12.319 2.64469C12.1398 2.4518 11.8602 2.45177 11.681 2.64459C10.5345 3.87808 5.66571 8.14249 3.28917 10.6241C3.12474 10.8101 3 11.0811 3 11.4006C3 11.9597 3.36207 12.4116 3.81 12.4116H5.43V19.489C5.43 20.0481 5.79207 20.5 6.24 20.5H9.57C10.0179 20.5 10.38 20.0471 10.38 19.489V16.52C10.38 16.2328 10.5872 16 10.8429 16H13.1571C13.4128 16 13.62 16.2328 13.62 16.52V19.489C13.62 20.0471 13.9821 20.5 14.43 20.5H17.76C18.2079 20.5 18.57 20.0481 18.57 19.489V12.4116H20.19C20.6379 12.4116 21 11.9597 21 11.4006C21 11.0811 20.8753 10.8101 20.6898 10.6241C18.3298 8.14256 13.4648 3.87832 12.319 2.64469Z" };
function f4(e, t) {
  return a(), c("path", u4);
}
const p4 = /* @__PURE__ */ u(c4, [["render", f4]]), $4 = {};
function C4(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, -1),
    o("line", {
      x1: "12",
      y1: "16",
      x2: "12",
      y2: "12"
    }, null, -1),
    o("line", {
      x1: "12",
      y1: "8",
      x2: "12.01",
      y2: "8"
    }, null, -1)
  ]));
}
const _4 = /* @__PURE__ */ u($4, [["render", C4]]), g4 = {};
function y4(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM11.8286 8C12.657 8 13.3286 7.32843 13.3286 6.5C13.3286 5.67157 12.657 5 11.8286 5C11.0002 5 10.3286 5.67157 10.3286 6.5C10.3286 7.32843 11.0002 8 11.8286 8ZM9.5 9.9C9.5 9.67909 9.67909 9.5 9.9 9.5H12.6C12.8209 9.5 13 9.67909 13 9.9V15.5H14.1C14.3209 15.5 14.5 15.6791 14.5 15.9V17.1C14.5 17.3209 14.3209 17.5 14.1 17.5H9.9C9.67909 17.5 9.5 17.3209 9.5 17.1V15.9C9.5 15.6791 9.67909 15.5 9.9 15.5H11V11.5H9.9C9.67909 11.5 9.5 11.3209 9.5 11.1V9.9Z"
    }, null, -1)
  ]));
}
const m4 = /* @__PURE__ */ u(g4, [["render", y4]]), h4 = {};
function v4(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M21 8.3c0-.7-.2-1.5-.5-2.2A4.6 4.6 0 0 0 18 3.5c-.7-.3-1.4-.4-2.2-.4a64.4 64.4 0 0 0-9.6.4A4.6 4.6 0 0 0 3.5 6c-.3.7-.4 1.4-.4 2.2a63.7 63.7 0 0 0 .4 9.6A4.6 4.6 0 0 0 6 20.5c.7.3 1.4.4 2.2.4l3.7.1h3.7c.8 0 1.5-.2 2.2-.5a4.6 4.6 0 0 0 2.6-2.6c.3-.7.4-1.4.4-2.2L21 12V8.3Zm-9 8.3a4.6 4.6 0 1 1 0-9.2 4.6 4.6 0 0 1 0 9.2Zm4.8-8.3a1 1 0 1 1 0-2.2 1 1 0 0 1 0 2.2Z" }, null, -1),
    o("path", { d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }, null, -1)
  ]));
}
const b4 = /* @__PURE__ */ u(h4, [["render", v4]]), I4 = {};
function M4(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "stroke-width": "1.5",
      d: "M17.5 21h-11a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h11a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2Z",
      "clip-rule": "evenodd"
    }, null, -1),
    o("path", {
      "stroke-width": "1.5",
      d: `M14 7.5h2m-2 3h2M8 15h8m-8 3h8M9.5 6.8V6m0 5.3v.7m-1.3-1.3c.2.3.5.6 1 .6h.7a1 1 0 0 0
      .3-2.1l-1.4-.4a1 1 0 0 1 .3-2h.8c.4 0 .7.2.9.5`
    }, null, -1)
  ]));
}
const k4 = /* @__PURE__ */ u(I4, [["render", M4]]), x4 = {};
function N4(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M8.75 12C8.75 11.0538 8.78165 10.1336 8.84134 9.25H15.1587C15.2184 10.1336 15.25 11.0538 15.25 12C15.25 12.9462 15.2184 13.8664 15.1587 14.75H8.84134C8.78165 13.8664 8.75 12.9462 8.75 12Z" }, null, -1),
    o("path", { d: "M7.25 12C7.25 11.059 7.28025 10.1391 7.33806 9.25H1.34655C1.12032 10.129 1 11.0504 1 12C1 12.9496 1.12032 13.871 1.34655 14.75H7.33806C7.28025 13.8609 7.25 12.941 7.25 12Z" }, null, -1),
    o("path", { d: "M1.85109 16.25C3.11486 19.2643 5.68234 21.5967 8.84823 22.5418C8.70788 22.1869 8.57671 21.8094 8.45474 21.413C8.00894 19.9641 7.66804 18.2034 7.4645 16.25H1.85109Z" }, null, -1),
    o("path", { d: "M13.3317 22.9202C12.8952 22.9729 12.4507 23 12 23C11.5493 23 11.1048 22.9729 10.6683 22.9202C10.3931 22.4052 10.1286 21.7526 9.88841 20.9718C9.48653 19.6657 9.16936 18.0569 8.97297 16.25H15.027C14.8306 18.0569 14.5135 19.6657 14.1116 20.9718C13.8714 21.7526 13.6069 22.4052 13.3317 22.9202Z" }, null, -1),
    o("path", { d: "M15.1518 22.5418C18.3177 21.5967 20.8851 19.2643 22.1489 16.25H16.5355C16.332 18.2034 15.9911 19.9641 15.5453 21.413C15.4233 21.8094 15.2921 22.1869 15.1518 22.5418Z" }, null, -1),
    o("path", { d: "M22.6535 14.75C22.8797 13.871 23 12.9496 23 12C23 11.0504 22.8797 10.129 22.6535 9.25H16.6619C16.7198 10.1391 16.75 11.059 16.75 12C16.75 12.941 16.7198 13.8609 16.6619 14.75H22.6535Z" }, null, -1),
    o("path", { d: "M22.1489 7.75C20.8851 4.73571 18.3177 2.40333 15.1518 1.45818C15.2921 1.81309 15.4233 2.19065 15.5453 2.58705C15.9911 4.03588 16.332 5.79658 16.5355 7.75H22.1489Z" }, null, -1),
    o("path", { d: "M10.6683 1.07979C11.1048 1.02711 11.5493 1 12 1C12.4507 1 12.8952 1.02711 13.3317 1.07979C13.6069 1.59482 13.8714 2.24744 14.1116 3.02818C14.5135 4.33427 14.8306 5.94311 15.027 7.75H8.97297C9.16936 5.94311 9.48653 4.33427 9.88841 3.02818C10.1286 2.24744 10.3931 1.59482 10.6683 1.07979Z" }, null, -1),
    o("path", { d: "M8.84823 1.45818C5.68234 2.40333 3.11486 4.73571 1.85109 7.75H7.4645C7.66804 5.79658 8.00894 4.03588 8.45474 2.58705C8.57671 2.19065 8.70788 1.81309 8.84823 1.45818Z" }, null, -1)
  ]));
}
const S4 = /* @__PURE__ */ u(x4, [["render", N4]]), L4 = {};
function A4(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.17949 4.75C2.52807 4.75 2 5.26488 2 5.9L2.00004 18.1C2.00004 18.7351 2.52812 19.25 3.17953 19.25H20.8205C21.4719 19.25 22 18.7351 22 18.1V5.9C22 5.26487 21.4719 4.75 20.8205 4.75H3.17949ZM3.60806 7.29151C3.48691 7.48049 3.54497 7.73214 3.73666 7.84895L11.7919 12.7576C11.9197 12.8355 12.0804 12.8355 12.2082 12.7576L20.2634 7.84895C20.4551 7.73214 20.5132 7.48049 20.392 7.29151L20.0085 6.69319C19.8912 6.51019 19.6492 6.45437 19.4636 6.56748L12.0001 11.1156L4.5365 6.56748C4.35088 6.45437 4.1089 6.51019 3.9916 6.69319L3.60806 7.29151Z"
    }, null, -1)
  ]));
}
const w4 = /* @__PURE__ */ u(L4, [["render", A4]]), O4 = {};
function T4(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M11.1954 2C10.9726 2 10.7681 2.11987 10.6635 2.31169L5.07146 12.5634C4.85788 12.9549 5.14875 13.4274 5.60338 13.4274H11.0066L7.26885 20.0366C6.76987 20.919 7.42407 22 8.45699 22C8.86511 22 9.25157 21.8208 9.50926 21.512L18.8636 10.3042C19.1841 9.92011 18.904 9.34516 18.3963 9.34516H13.3152L17.1346 2.88142C17.3662 2.48953 17.0763 2 16.6126 2H11.1954Z" }, null, -1)
  ]));
}
const D4 = /* @__PURE__ */ u(O4, [["render", T4]]), E4 = {};
function V4(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M4 9.28125C4 6.3645 6.3645 4 9.28125 4H11.1938C11.4147 4 11.5938 3.82091 11.5938 3.6V3.4C11.5938 3.17909 11.4147 3 11.1938 3H9.28125C5.81221 3 3 5.81221 3 9.28125V14.7188C3 18.1878 5.81221 21 9.28125 21H14.7188C18.1878 21 21 18.1878 21 14.7188V13.3062C21 13.0853 20.8209 12.9062 20.6 12.9062H20.4C20.1791 12.9062 20 13.0853 20 13.3062V14.7188C20 17.6355 17.6355 20 14.7188 20H9.28125C6.3645 20 4 17.6355 4 14.7188V9.28125Z" }, null, -1),
    o("path", { d: "M14.65 3.91666C14.4291 3.91666 14.25 4.09574 14.25 4.31666V5.01666C14.25 5.23757 14.4291 5.41666 14.65 5.41666H17.6894L12.2671 10.8389C12.1172 10.9888 12.1103 11.2297 12.2514 11.388L12.7181 11.9112C12.8711 12.0828 13.1369 12.0904 13.2995 11.9278L18.75 6.47731V9.84999C18.75 10.0709 18.9291 10.25 19.15 10.25H19.85C20.071 10.25 20.25 10.0709 20.25 9.84999V4.31666C20.25 4.09574 20.071 3.91666 19.85 3.91666H14.65Z" }, null, -1)
  ]));
}
const j4 = /* @__PURE__ */ u(E4, [["render", V4]]), P4 = {};
function H4(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "stroke-width": "1.5",
      d: "M19 9V5h-4m-2 6 6-6m1 8v2a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V9a5 5 0 0 1 5-5h2"
    }, null, -1)
  ]));
}
const R4 = /* @__PURE__ */ u(P4, [["render", H4]]), B4 = {};
function z4(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M20.5 2h-17C2.7 2 2 2.6 2 3.4v17.2c0 .8.7 1.4 1.5 1.4h17c.8 0 1.5-.6 1.5-1.4V3.4c0-.8-.7-1.4-1.5-1.4ZM8 19H5V9.5h3V19ZM6.4 8.2a1.7 1.7 0 1 1 0-3.4 1.7 1.7 0 0 1 0 3.4ZM19 19h-3v-4.6c0-1.1 0-2.5-1.5-2.5s-1.7 1.2-1.7 2.4V19h-3V9.5h2.8v1.3c.5-.7 1.4-1.5 2.9-1.5 3 0 3.5 2 3.5 4.5V19Z" }, null, -1)
  ]));
}
const F4 = /* @__PURE__ */ u(B4, [["render", z4]]), U4 = {};
function Z4(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("line", {
      x1: "8",
      y1: "6",
      x2: "21",
      y2: "6"
    }, null, -1),
    o("line", {
      x1: "8",
      y1: "12",
      x2: "21",
      y2: "12"
    }, null, -1),
    o("line", {
      x1: "8",
      y1: "18",
      x2: "21",
      y2: "18"
    }, null, -1),
    o("line", {
      x1: "3",
      y1: "6",
      x2: "3.01",
      y2: "6"
    }, null, -1),
    o("line", {
      x1: "3",
      y1: "12",
      x2: "3.01",
      y2: "12"
    }, null, -1),
    o("line", {
      x1: "3",
      y1: "18",
      x2: "3.01",
      y2: "18"
    }, null, -1)
  ]));
}
const G4 = /* @__PURE__ */ u(U4, [["render", Z4]]), Y4 = {};
function W4(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13 5.77513V20.2239C13.0002 20.7635 12.7553 21.2741 12.3344 21.6118C11.9134 21.9495 11.3619 22.0778 10.8351 21.9606L6.38924 20.9722C5.57558 20.7915 4.99666 20.0699 4.99666 19.2365V6.76354C4.99666 5.92975 5.57615 5.208 6.39024 5.02782L10.8361 4.03941C11.3626 3.92235 11.9138 4.0506 12.3345 4.38808C12.7552 4.72556 13 5.23577 13 5.77513Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M9.99874 14.0204V12.0196",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M21.0033 8.99834V6.95548C21.0035 6.42479 20.7927 5.91578 20.4175 5.54052C20.0422 5.16526 19.5332 4.95451 19.0025 4.95465H16.0013",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M21.0033 17.0016V19.0025C21.0035 19.5332 20.7927 20.0422 20.4175 20.4174C20.0422 20.7927 19.5332 21.0035 19.0025 21.0033H16.0013",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M16.0013 13H21.0033",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M19.0025 15.0008L21.0033 13L19.0025 10.9992",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const Q4 = /* @__PURE__ */ u(Y4, [["render", W4]]), K4 = {};
function X4(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("circle", {
      cx: "11",
      cy: "11",
      r: "8"
    }, null, -1),
    o("line", {
      x1: "21",
      y1: "21",
      x2: "16.65",
      y2: "16.65"
    }, null, -1)
  ]));
}
const q4 = /* @__PURE__ */ u(K4, [["render", X4]]), J4 = {};
function e5(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: `M15 19H11C9.895 19 9 18.105 9 17V11.5C9 10.395 9.895 9.5 11 9.5H19C20.105
       9.5 21 10.395 21 11.5V17C21 18.105 20.105 19 19 19H18V21L15 19Z`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: `M17.609 9.5V5.435C17.609 4.09 16.519 3 15.174 3H5.435C4.09 3 3 4.09 3
       5.435V12.131C3 13.476 4.09 14.566 5.435 14.566H6.652V17L9 15.435`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const t5 = /* @__PURE__ */ u(J4, [["render", e5]]), n5 = {};
function r5(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, -1),
    o("line", {
      x1: "8",
      y1: "12",
      x2: "16",
      y2: "12"
    }, null, -1)
  ]));
}
const o5 = /* @__PURE__ */ u(n5, [["render", r5]]), d5 = {}, l5 = {
  x1: "5",
  y1: "12",
  x2: "19",
  y2: "12"
};
function a5(e, t) {
  return a(), c("line", l5);
}
const i5 = /* @__PURE__ */ u(d5, [["render", a5]]), s5 = {};
function c5(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M 2.179688 4.511719 C 2.179688 3.453125 3.023438 2.59375 4.0625 2.59375 L 16.9375 2.59375 C 17.976562 2.59375 18.820312 3.453125 18.820312 4.511719 L 18.820312 4.710938 C 18.820312 4.820312 18.734375 4.90625 18.628906 4.90625 L 2.367188 4.90625 C 2.265625 4.90625 2.179688 4.820312 2.179688 4.710938 Z M 2.179688 4.511719 " }, null, -1),
    o("path", { d: "M 17.683594 13.183594 C 17.683594 13.714844 17.261719 14.144531 16.738281 14.144531 C 16.214844 14.144531 15.792969 13.714844 15.792969 13.183594 C 15.792969 12.652344 16.214844 12.21875 16.738281 12.21875 C 17.261719 12.21875 17.683594 12.652344 17.683594 13.183594 Z M 17.683594 13.183594 " }, null, -1),
    o("path", { d: "M 3.335938 5.960938 C 2.699219 5.960938 2.179688 6.492188 2.179688 7.140625 L 2.179688 19.21875 C 2.179688 19.871094 2.699219 20.402344 3.339844 20.402344 L 21.15625 20.402344 C 21.796875 20.402344 22.316406 19.871094 22.316406 19.21875 L 22.3125 15.203125 L 16.78125 15.203125 C 15.660156 15.203125 14.75 14.277344 14.75 13.132812 C 14.75 11.992188 15.660156 11.066406 16.78125 11.066406 L 22.3125 11.066406 L 22.316406 7.144531 C 22.316406 6.492188 21.796875 5.960938 21.15625 5.960938 Z M 3.335938 5.960938 " }, null, -1)
  ]));
}
const u5 = /* @__PURE__ */ u(s5, [["render", c5]]), f5 = {};
function p5(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      d: `M18.0021
        7.99792V6.99751C18.0021
        5.89248 17.1063
        4.99667 16.0012 4.99667H6.49729C5.116
        4.99667 3.99625 6.11643 3.99625
        7.49772V19.5027C3.99625 20.884
        5.116 22.0038 6.49729
        22.0038H19.5027C20.884
        22.0038 22.0037 20.884
        22.0037 19.5027V9.99876C22.0037
        8.89373 21.1079 7.99792 20.0029
        7.99792H3.99625`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M18.0021 15.0008H16.0013",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const $5 = /* @__PURE__ */ u(f5, [["render", p5]]), C5 = {};
function _5(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, -1),
    o("path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }, null, -1),
    o("line", {
      x1: "12",
      y1: "17",
      x2: "12.01",
      y2: "17"
    }, null, -1)
  ]));
}
const g5 = /* @__PURE__ */ u(C5, [["render", _5]]), y5 = {};
function m5(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }, null, -1),
    o("polyline", { points: "15 3 21 3 21 9" }, null, -1),
    o("line", {
      x1: "10",
      y1: "14",
      x2: "21",
      y2: "3"
    }, null, -1)
  ]));
}
const h5 = /* @__PURE__ */ u(y5, [["render", m5]]), v5 = {};
function b5(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "stroke-width": "1.5",
      d: `M7.2 7.8a.3.3 0 1 1-.4.4.3.3 0 0 1 .4-.4m5 0a.3.3 0 1 1-.4.4.3.3 0 0 1 .4-.4m5 0a.3.3 0
      1 1-.4.4.3.3 0 0 1 .4-.4`
    }, null, -1),
    o("path", {
      "stroke-width": "1.5",
      d: "M10 13H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3"
    }, null, -1),
    o("path", {
      "stroke-width": "1.5",
      d: `M13.6 16.7 11.3 19a1 1 0 0 0-.3.8v1.1c0 .6.5 1.1 1 1.1h1.2c.3 0 .6-.1.8-.3l2.3-2.3
      1.3.2a4.3 4.3 0 1 0-4-3v0Z`,
      "clip-rule": "evenodd"
    }, null, -1),
    o("path", {
      "stroke-width": "1.5",
      d: "M17.6 15.2a.1.1 0 1 0 0 .3.1.1 0 0 0 0-.3v0"
    }, null, -1)
  ]));
}
const I5 = /* @__PURE__ */ u(v5, [["render", b5]]), M5 = {};
function k5(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M7.5 18c-1.6 0-2.8-.5-4-1.6-1-1-1.5-2.4-1.5-3.9s.5-2.8 1.6-3.9c1-1 2.3-1.6 3.9-1.6a5 5 0 0 1 3.3 1.1 7 7 0 0 1 1.9 2.7h9.1l.2.2v3s0 .2-.2.2h-2.2v3.6c0 .1 0 .2-.2.2H17s-.2 0-.2-.2v-3.6h-4c-.4 1-1 2-2 2.7A5 5 0 0 1 7.6 18Zm0-4c.4 0 .8 0 1-.4.4-.3.5-.7.5-1.1a1.5 1.5 0 0 0-1.5-1.6c-.5 0-.9.2-1.1.5-.3.3-.5.7-.5 1.1a1.5 1.5 0 0 0 1.6 1.6Z" }, null, -1)
  ]));
}
const x5 = /* @__PURE__ */ u(M5, [["render", k5]]), N5 = {};
function S5(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }, null, -1),
    o("line", {
      x1: "10",
      y1: "15",
      x2: "10",
      y2: "9"
    }, null, -1),
    o("line", {
      x1: "14",
      y1: "15",
      x2: "14",
      y2: "9"
    }, null, -1)
  ]));
}
const L5 = /* @__PURE__ */ u(N5, [["render", S5]]), A5 = {};
function w5(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "stroke-width": "1.5",
      d: "M19 19H8a2 2 0 0 1-2-2v-7c0-1.1.9-2 2-2h11a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2Z",
      "clip-rule": "evenodd"
    }, null, -1),
    o("path", {
      "stroke-width": "1.5",
      d: "M6 12h15M6 16H5a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h11a2 2 0 0 1 2 2v1m-6 8H9"
    }, null, -1)
  ]));
}
const O5 = /* @__PURE__ */ u(A5, [["render", w5]]), T5 = {};
function D5(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("line", {
      x1: "19",
      y1: "5",
      x2: "5",
      y2: "19"
    }, null, -1),
    o("circle", {
      cx: "6.5",
      cy: "6.5",
      r: "2.5"
    }, null, -1),
    o("circle", {
      cx: "17.5",
      cy: "17.5",
      r: "2.5"
    }, null, -1)
  ]));
}
const E5 = /* @__PURE__ */ u(T5, [["render", D5]]), V5 = {}, j5 = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: `M10.856 13.144C9.68599 11.974 8.80399 10.664 8.21799 9.33499C8.09399 9.05399
     8.16699 8.72499 8.38399 8.50799L9.20299 7.68999C9.87399 7.01899 9.87399 6.06999
     9.28799 5.48399L8.11399 4.30999C7.33299 3.52899 6.06699 3.52899 5.28599
     4.30999L4.63399 4.96199C3.89299 5.70299 3.58399 6.77199 3.78399 7.83199C4.27799
     10.445 5.79599 13.306 8.24499 15.755C10.694 18.204 13.555 19.722 16.168 20.216C17.228
     20.416 18.297 20.107 19.038 19.366L19.689 18.715C20.47 17.934 20.47 16.668 19.689
     15.887L18.516 14.714C17.93 14.128 16.98 14.128 16.395 14.714L15.492 15.618C15.275
     15.835 14.946 15.908 14.665 15.784C13.336 15.197 12.026 14.314 10.856 13.144Z`,
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function P5(e, t) {
  return a(), c("path", j5);
}
const H5 = /* @__PURE__ */ u(V5, [["render", P5]]), R5 = {}, B5 = { d: "M9.45094 5.23771C10.0423 5.82904 10.0123 6.81665 9.29277 7.53615C9.12291 7.70601 9.01029 7.97414 8.93641 8.27549C8.63852 9.49057 9.10327 10.747 9.80487 11.7828C10.1318 12.2655 10.5067 12.7621 10.8748 13.1257C11.2364 13.4831 11.7292 13.848 12.2048 14.165C13.1983 14.8274 14.3823 15.2492 15.5579 15.0401C15.961 14.9683 16.3345 14.8404 16.5562 14.6187C17.1835 13.9904 18.1723 13.9604 18.7637 14.5517L20.7322 16.5202C21.0893 16.8772 21.0893 17.4561 20.7322 17.8131L19.5688 18.9765C18.6698 19.8798 17.5599 20.5405 16.354 20.8902C15.9882 20.9963 15.5724 21.0192 15.137 20.9857C12.1073 20.7529 9.38723 18.9104 7.23854 16.7619C5.08986 14.6134 3.2471 11.8935 3.01426 8.86389C2.98081 8.42859 3.0037 8.01291 3.10974 7.64722C3.45957 6.44083 4.12064 5.33053 5.02442 4.43145L6.18809 3.26777C6.54511 2.91074 7.12397 2.91074 7.48099 3.26777L9.45094 5.23771Z" };
function z5(e, t) {
  return a(), c("path", B5);
}
const F5 = /* @__PURE__ */ u(R5, [["render", z5]]), U5 = {};
function Z5(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11ZM10.15 7C9.92909 7 9.75 7.17909 9.75 7.4V9.75H7.4C7.17909 9.75 7 9.92909 7 10.15V11.85C7 12.0709 7.17909 12.25 7.4 12.25H9.75V14.6C9.75 14.8209 9.92909 15 10.15 15H11.85C12.0709 15 12.25 14.8209 12.25 14.6V12.25H14.6C14.8209 12.25 15 12.0709 15 11.85V10.15C15 9.92909 14.8209 9.75 14.6 9.75H12.25V7.4C12.25 7.17909 12.0709 7 11.85 7H10.15Z"
    }, null, -1)
  ]));
}
const G5 = /* @__PURE__ */ u(U5, [["render", Z5]]), Y5 = {};
function W5(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M10.8 10.8V4.3c0-.2.1-.4.3-.4H13c.2 0 .3.2.3.4v6.3h6.4c.2 0 .4.2.4.5v1.7c0 .2-.2.3-.4.3h-6.4v6.4c0 .2-.1.4-.3.4h-2a.4.4 0 0 1-.3-.4v-6.4H4.3A.4.4 0 0 1 4 13v-2c0-.2.2-.3.4-.3h6.3Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Q5 = /* @__PURE__ */ u(Y5, [["render", W5]]), K5 = {};
function X5(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.33333 7.5V4.6875C5.33333 3.75552 6.07952 3 7 3H17C17.9205 3 18.6667 3.75552 18.6667 4.6875V7.5H19.7778C21.0051 7.5 22 8.50736 22 9.75V13.175C22 13.3959 21.8209 13.575 21.6 13.575H2.4C2.17909 13.575 2 13.3959 2 13.175V9.75C2 8.50736 2.99492 7.5 4.22222 7.5H5.33333ZM7.55556 7.5V5.25H16.4444V7.5H7.55556Z"
    }, null, -1),
    o("path", { d: "M21.6 15.2625C21.8209 15.2625 22 15.4416 22 15.6625V19.3125C22 20.5551 21.0051 21 19.7778 21H4.22222C2.99492 21 2 20.5551 2 19.3125V15.6625C2 15.4416 2.17909 15.2625 2.4 15.2625H21.6Z" }, null, -1)
  ]));
}
const q5 = /* @__PURE__ */ u(K5, [["render", X5]]), J5 = {};
function es(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      d: `M5 15.889L10.071 10.818C10.462 10.427 11.095 10.427 11.485
       10.818L13.626 12.959C14.017 13.35 14.65 13.35 15.04 12.959L21 7`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M18.333 7H21V9.667",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M21 20.929H1.925V3.22099",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const ts = /* @__PURE__ */ u(J5, [["render", es]]), ns = {}, rs = { points: "22 12 18 12 15 21 9 3 6 12 2 12" };
function os(e, t) {
  return a(), c("polyline", rs);
}
const ds = /* @__PURE__ */ u(ns, [["render", os]]), ls = {}, as = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM13.4698 7.87609C12.6078 7.41192 11.8252 7.40087 11.32 7.72299C10.7221 8.10427 10.333 8.52294 10.1901 8.97518C10.1235 9.18582 9.94961 9.36887 9.7287 9.36887H8.0287C7.80778 9.36887 7.62643 9.18895 7.64882 8.96917C7.82029 7.28585 9.05221 6.20406 9.97592 5.61506C11.5385 4.61869 13.3579 4.97644 14.6551 5.67491C16.0582 6.43044 16.584 7.87486 16.5 9.1758C16.4169 10.4609 15.7413 11.7941 14.5082 12.5552C14.0033 12.8668 13.623 13.168 13.3821 13.4396C13.3571 13.4678 13.3345 13.4946 13.3141 13.52C13.1759 13.6923 12.9496 13.8689 12.7287 13.8689H11.0287C10.8078 13.8689 10.6256 13.6887 10.6591 13.4704C10.7635 12.7883 11.1232 12.2188 11.5119 11.7806C11.9787 11.2543 12.5849 10.8044 13.1951 10.4278C13.6599 10.1409 13.9681 9.58909 14.0052 9.01465C14.0412 8.4561 13.8235 8.06652 13.4698 7.87609ZM11.8286 18.5C12.6571 18.5 13.3286 17.8284 13.3286 17C13.3286 16.1716 12.6571 15.5 11.8286 15.5C11.0002 15.5 10.3286 16.1716 10.3286 17C10.3286 17.8284 11.0002 18.5 11.8286 18.5Z"
};
function is(e, t) {
  return a(), c("path", as);
}
const ss = /* @__PURE__ */ u(ls, [["render", is]]), cs = {}, us = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function fs(e, t) {
  return a(), c("svg", us, t[0] || (t[0] = [
    o("path", { d: `M5,5H10V10H9V6.5C6.65,7.47 5,9.79 5,12.5C5,16.08 7.91,
      19 11.5,19C15.09,19 18,16.09 18,12.5C18,9.42 15.86,6.84 13,6.17V5.14C16.42,5.84 19,
      8.86 19,12.5C19,16.63 15.64,20 11.5,20C7.36,20 4,16.64 4,12.5C4,9.72 5.5,7.3 7.74,6H5V5Z` }, null, -1)
  ]));
}
const ps = /* @__PURE__ */ u(cs, [["render", fs]]), $s = {}, Cs = {
  viewBox: "0 0 21 20",
  xmlns: "http://www.w3.org/2000/svg"
};
function _s(e, t) {
  return a(), c("svg", Cs, t[0] || (t[0] = [
    o("path", {
      id: "Vector",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.5 2.70833C6.47292 2.70833 3.20833 5.97292 3.20833 10C3.20833 14.0271 6.47292 17.2917 10.5 17.2917C14.4153 17.2917 17.6099 14.2058 17.7842 10.3335C17.7925 10.1496 17.9409 10 18.125 10H19.5417C19.7258 10 19.8756 10.1499 19.8692 10.3339C19.6933 15.3569 15.5659 19.375 10.5 19.375C5.32233 19.375 1.125 15.1777 1.125 10C1.125 4.82233 5.32233 0.625 10.5 0.625C12.8666 0.625 15.0278 1.50217 16.6768 2.94755V2C16.6768 1.8159 16.8261 1.66667 17.0101 1.66667H18.4268C18.6109 1.66667 18.7601 1.81591 18.7601 2V6.54167C18.7601 6.72576 18.6109 6.875 18.4268 6.875H14.1667C13.9826 6.875 13.8333 6.72576 13.8333 6.54167V5.125C13.8333 4.94091 13.9826 4.79167 14.1667 4.79167H15.6033C14.2875 3.50209 12.4861 2.70833 10.5 2.70833Z"
    }, null, -1)
  ]));
}
const gs = /* @__PURE__ */ u($s, [["render", _s]]), ys = {};
function ms(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: `M13 16.5H11C8.791 16.5 7 14.709 7 12.5V4.5C7 3.948 7.448 3.5 8
        3.5H16C16.552 3.5 17 3.948 17 4.5V12.5C17 14.709 15.209 16.5 13 16.5Z`,
      stroke: "currentColor",
      "stroke-width": "1.2"
    }, null, -1),
    o("path", {
      d: "M12 16.5V20.5",
      stroke: "currentColor",
      "stroke-width": "1.2"
    }, null, -1),
    o("path", {
      d: "M9 20.5H15",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M17 6.5H20C20.552 6.5 21 6.948 21 7.5V9.5C21 11.157 19.657 12.5 18 12.5H17",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M7 6.5H4C3.448 6.5 3 6.948 3 7.5V9.5C3 11.157 4.343 12.5 6 12.5H7",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const hs = /* @__PURE__ */ u(ys, [["render", ms]]), vs = {};
function bs(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19.1635 1.63388C19.8955 1.79583 20.5302 2.22349 21.0603 2.75358C21.5904 3.28367 22.018 3.9183 22.18 4.65025C22.2634 5.02745 22.3283 5.44997 22.3187 5.8274C22.4608 9.30921 20.464 11.7509 17.7044 13.7269L15.4331 22.3392C15.2948 22.6987 14.7656 22.8856 14.4797 22.6408C14.4572 22.6216 14.4388 22.5982 14.4225 22.5737L11.7001 17.6529L9.31074 19.3928C9.09461 19.5144 8.82397 19.4772 8.64863 19.3019L4.51198 15.1652C4.33663 14.9899 4.29946 14.7193 4.42103 14.5031L6.16099 12.1138L1.24022 9.39142C1.21563 9.37506 1.19224 9.35663 1.17304 9.33419C0.928313 9.04831 1.27299 8.36123 1.63248 8.22297L6.51878 7.03706L10.0286 6.19143C12.0164 3.38797 14.468 1.35405 17.9865 1.49522C18.3639 1.48561 18.7864 1.55043 19.1635 1.63388ZM17.883 9.68319C16.5462 10.8982 14.7799 11.1935 13.7001 10.1138C12.6204 9.03406 12.9157 7.26775 14.1307 5.93093C15.4304 4.50107 17.434 4.22049 18.5137 5.30023C19.5934 6.37997 19.3129 8.38358 17.883 9.68319Z"
    }, null, -1)
  ]));
}
const Is = /* @__PURE__ */ u(vs, [["render", bs]]), Ms = {};
function ks(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: `M14.25 4C11.0744 4 8.50004 6.57436 8.50004 9.75C8.50004 12.9256 11.0744 15.5 14.25
       15.5C17.4257 15.5 20 12.9256 20 9.75C20 6.57436 17.4257 4 14.25 4ZM6.50004 9.75C6.50004
       5.46979 9.96983 2 14.25 2C18.5302 2 22 5.46979 22 9.75C22 14.0302 18.5302 17.5 14.25
       17.5C12.5966 17.5 11.0641 16.9822 9.80581 16.0999C9.64117 15.9845 9.41618 15.9981
       9.274 16.1403L3.98999 21.4243C3.83378 21.5805 3.58051 21.5805 3.4243 21.4243L2.57578
       20.5757C2.41957 20.4195 2.41957 20.1663 2.57578 20.01L7.85979 14.726C8.00197 14.5839
       8.01555 14.3589 7.90011 14.1942C7.01783 12.936 6.50004 11.4034 6.50004 9.75Z`
    }, null, -1)
  ]));
}
const xs = /* @__PURE__ */ u(Ms, [["render", ks]]), Ns = {};
function Ss(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: `M13 19H3C1.895 19 1 18.105 1 17V9C1 7.895 1.895 7 3 7H13C14.105 7 15
       7.895 15 9V17C15 18.105 14.105 19 13 19Z`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M8 15.09V12.5",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: `M8.5303 11.2197C8.82319 11.5126 8.82319 11.9875 8.5303 12.2804C8.23741
       12.5733 7.76253 12.5733 7.46964 12.2804C7.17675 11.9875 7.17675 11.5126
       7.46964 11.2197C7.76253 10.9268 8.23741 10.9268 8.5303 11.2197`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M4 7V5V5C4 2.791 5.791 1 8 1V1C10.209 1 12 2.791 12 5V5V7",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const Ls = /* @__PURE__ */ u(Ns, [["render", Ss]]), As = {};
function ws(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11 2C10.4477 2 10 2.44772 10 3V3.47683C10 3.93311 9.68856 4.32531 9.25988 4.48159C9.04259 4.5608 8.8297 4.64916 8.62168 4.74621C8.2081 4.93915 7.71045 4.88207 7.38775 4.55937L7.0502 4.22183C6.65968 3.8313 6.02651 3.8313 5.63599 4.22182L4.22177 5.63604C3.83125 6.02656 3.83125 6.65973 4.22177 7.05025L4.55934 7.38782C4.88204 7.71052 4.93912 8.20816 4.74618 8.62174C4.64914 8.82974 4.56079 9.04261 4.48159 9.25987C4.32531 9.68856 3.93311 10 3.47683 10H3C2.44771 10 2 10.4477 2 11V13C2 13.5523 2.44772 14 3 14H3.47682C3.93311 14 4.32531 14.3114 4.48159 14.7401C4.56079 14.9574 4.64915 15.1703 4.7462 15.3783C4.93914 15.7919 4.88206 16.2895 4.55936 16.6122L4.22183 16.9497C3.83131 17.3403 3.83131 17.9734 4.22183 18.364L5.63605 19.7782C6.02657 20.1687 6.65973 20.1687 7.05026 19.7782L7.38779 19.4406C7.71049 19.1179 8.20814 19.0609 8.62171 19.2538C8.82972 19.3508 9.0426 19.4392 9.25988 19.5184C9.68856 19.6747 10 20.0669 10 20.5232V21C10 21.5523 10.4477 22 11 22H13C13.5523 22 14 21.5523 14 21V20.5232C14 20.0669 14.3114 19.6747 14.7401 19.5184C14.9574 19.4392 15.1703 19.3509 15.3783 19.2538C15.7918 19.0609 16.2895 19.118 16.6122 19.4407L16.9497 19.7782C17.3402 20.1687 17.9734 20.1687 18.3639 19.7782L19.7781 18.364C20.1686 17.9734 20.1686 17.3403 19.7781 16.9497L19.4406 16.6122C19.1179 16.2895 19.0608 15.7919 19.2538 15.3783C19.3508 15.1703 19.4392 14.9574 19.5184 14.7401C19.6747 14.3114 20.0669 14 20.5232 14H21C21.5523 14 22 13.5523 22 13V11C22 10.4477 21.5523 10 21 10H20.5232C20.0669 10 19.6747 9.68856 19.5184 9.25988C19.4392 9.0426 19.3508 8.82972 19.2538 8.62171C19.0609 8.20814 19.1179 7.71049 19.4406 7.38779L19.7782 7.05025C20.1687 6.65973 20.1687 6.02656 19.7782 5.63604L18.364 4.22183C17.9734 3.8313 17.3403 3.8313 16.9498 4.22183L16.6122 4.55936C16.2895 4.88206 15.7919 4.93914 15.3783 4.7462C15.1703 4.64915 14.9574 4.56079 14.7401 4.48159C14.3114 4.32531 14 3.93311 14 3.47683V3C14 2.44772 13.5523 2 13 2H11ZM12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z",
      fill: "url(#paint0_linear_2877_1116)"
    }, null, -1),
    o("defs", null, [
      o("linearGradient", {
        id: "paint0_linear_2877_1116",
        x1: "22",
        y1: "2.20833",
        x2: "2",
        y2: "22.2083",
        gradientUnits: "userSpaceOnUse"
      }, [
        o("stop", { "stop-color": "#E1A329" }),
        o("stop", {
          offset: "1",
          "stop-color": "#BB8B10"
        })
      ])
    ], -1)
  ]));
}
const Os = /* @__PURE__ */ u(As, [["render", ws]]), Ts = {};
function Ds(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11 2C10.4477 2 10 2.44772 10 3V3.47683C10 3.93311 9.68856 4.32531 9.25988 4.48159C9.04259 4.5608 8.8297 4.64916 8.62168 4.74621C8.2081 4.93915 7.71045 4.88207 7.38775 4.55937L7.0502 4.22183C6.65968 3.8313 6.02651 3.8313 5.63599 4.22182L4.22177 5.63604C3.83125 6.02656 3.83125 6.65973 4.22177 7.05025L4.55934 7.38782C4.88204 7.71052 4.93912 8.20816 4.74618 8.62174C4.64914 8.82974 4.56079 9.04261 4.48159 9.25987C4.32531 9.68856 3.93311 10 3.47683 10H3C2.44771 10 2 10.4477 2 11V13C2 13.5523 2.44772 14 3 14H3.47682C3.93311 14 4.32531 14.3114 4.48159 14.7401C4.56079 14.9574 4.64915 15.1703 4.7462 15.3783C4.93914 15.7919 4.88206 16.2895 4.55936 16.6122L4.22183 16.9497C3.83131 17.3403 3.83131 17.9734 4.22183 18.364L5.63605 19.7782C6.02657 20.1687 6.65973 20.1687 7.05026 19.7782L7.38779 19.4406C7.71049 19.1179 8.20814 19.0609 8.62171 19.2538C8.82972 19.3508 9.0426 19.4392 9.25988 19.5184C9.68856 19.6747 10 20.0669 10 20.5232V21C10 21.5523 10.4477 22 11 22H13C13.5523 22 14 21.5523 14 21V20.5232C14 20.0669 14.3114 19.6747 14.7401 19.5184C14.9574 19.4392 15.1703 19.3509 15.3783 19.2538C15.7918 19.0609 16.2895 19.118 16.6122 19.4407L16.9497 19.7782C17.3402 20.1687 17.9734 20.1687 18.3639 19.7782L19.7781 18.364C20.1686 17.9734 20.1686 17.3403 19.7781 16.9497L19.4406 16.6122C19.1179 16.2895 19.0608 15.7919 19.2538 15.3783C19.3508 15.1703 19.4392 14.9574 19.5184 14.7401C19.6747 14.3114 20.0669 14 20.5232 14H21C21.5523 14 22 13.5523 22 13V11C22 10.4477 21.5523 10 21 10H20.5232C20.0669 10 19.6747 9.68856 19.5184 9.25988C19.4392 9.0426 19.3508 8.82972 19.2538 8.62171C19.0609 8.20814 19.1179 7.71049 19.4406 7.38779L19.7782 7.05025C20.1687 6.65973 20.1687 6.02656 19.7782 5.63604L18.364 4.22183C17.9734 3.8313 17.3403 3.8313 16.9498 4.22183L16.6122 4.55936C16.2895 4.88206 15.7919 4.93914 15.3783 4.7462C15.1703 4.64915 14.9574 4.56079 14.7401 4.48159C14.3114 4.32531 14 3.93311 14 3.47683V3C14 2.44772 13.5523 2 13 2H11ZM12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z"
    }, null, -1)
  ]));
}
const Es = /* @__PURE__ */ u(Ts, [["render", Ds]]), Vs = {};
function js(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("circle", {
      cx: "12",
      cy: "12",
      r: "3"
    }, null, -1),
    o("path", { d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" }, null, -1)
  ]));
}
const Ps = /* @__PURE__ */ u(Vs, [["render", js]]), Hs = {};
function Rs(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "stroke-width": "1.5",
      d: `M20 11.2c0 4.4-3.2 8.5-7.5 9.7a2 2 0 0 1-1 0A10.3 10.3 0 0 1 4 11.2v-4a2 2 0 0 1
      1.2-1.8l5-2a5 5 0 0 1 3.7 0l4.9 2A2 2 0 0 1 20 7.2v4Z`,
      "clip-rule": "evenodd"
    }, null, -1),
    o("path", {
      "stroke-width": "1.5",
      d: `M13.5 12a2 2 0 1 0-3 0c.2.2.3.5.2.9l-.4 1.3a1 1 0 0 0 1 1.3h1.4a1 1 0 0 0
      1-1.3l-.4-1.3a1 1 0 0 1 .2-1v0Z`,
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Bs = /* @__PURE__ */ u(Hs, [["render", Rs]]), zs = {};
function Fs(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "stroke-width": "1.5",
      d: "M10 10.4h4c.6 0 1 .5 1 1v3.1c0 .6-.4 1-1 1h-4a1 1 0 0 1-1-1v-3c0-.6.4-1 1-1Z",
      "clip-rule": "evenodd"
    }, null, -1),
    o("path", {
      "stroke-width": "1.5",
      d: "M10.3 10.4V9.2a1.7 1.7 0 0 1 3.4 0v1.2"
    }, null, -1),
    o("path", {
      "stroke-width": "1.5",
      d: `m6 5 5.3-1.9a2 2 0 0 1 1.4 0l5.3 2a3 3 0 0 1 2 2.8v4.9c0 3.5-1.8 5-7 8a2 2 0 0 1-2
      0c-5.2-3-7-4.5-7-8v-5a3 3 0 0 1 2-2.7Z`,
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Us = /* @__PURE__ */ u(zs, [["render", Fs]]), Zs = {};
function Gs(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M11.7 2h-.4l-8 3.5c-.2.1-.3.2-.3.4v5.2A11.4 11.4 0 0 0 11.6 22c4.8-1.2 8.4-6 8.4-11V6l-.2-.4-8.1-3.4Zm-.2 10h6.6c-.5 3.7-3 7-6.6 8.1V12H4.9V6.8L11.5 4v8Z" }, null, -1)
  ]));
}
const Ys = /* @__PURE__ */ u(Zs, [["render", Gs]]), Ws = {};
function Qs(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M20 20V19.25C20 16.9028 18.0972 15 15.75 15H8.25C5.90279 15 4 16.9028 4 19.25V20",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("circle", {
      cx: "12",
      cy: "7",
      r: "4",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const Ks = /* @__PURE__ */ u(Ws, [["render", Qs]]), Xs = {};
function qs(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("rect", {
      x: "3",
      y: "3",
      width: "18",
      height: "18",
      rx: "5",
      stroke: "currentColor",
      "stroke-width": "1.2"
    }, null, -1),
    o("path", {
      d: "M15 3V8.5",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M15 12.5V21",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M16.9489 10.9489L21 15",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("circle", {
      cx: "15",
      cy: "10.5",
      r: "2",
      stroke: "currentColor",
      "stroke-width": "1.2"
    }, null, -1),
    o("path", {
      d: "M13.05 10.945L9 15L6 12L3 15",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const Js = /* @__PURE__ */ u(Xs, [["render", qs]]), e8 = {};
function t8(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("polyline", { points: "9 11 12 14 22 4" }, null, -1),
    o("path", { d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" }, null, -1)
  ]));
}
const n8 = /* @__PURE__ */ u(e8, [["render", t8]]), r8 = {}, o8 = {
  x: "3",
  y: "3",
  width: "18",
  height: "18",
  rx: "2",
  ry: "2"
};
function d8(e, t) {
  return a(), c("rect", o8);
}
const l8 = /* @__PURE__ */ u(r8, [["render", d8]]), a8 = {}, i8 = { d: "M11.0521 2.5317C11.5021 1.82277 12.4979 1.82277 12.9479 2.5317L15.7105 6.88439C15.8617 7.12254 16.0898 7.29581 16.3532 7.37249L21.167 8.77406C21.951 9.00233 22.2587 9.99237 21.7528 10.6588L18.6464 14.7505C18.4765 14.9743 18.3894 15.2547 18.401 15.5402L18.6134 20.7591C18.648 21.6091 17.8423 22.221 17.0797 21.924L12.3972 20.1001C12.141 20.0003 11.859 20.0003 11.6028 20.1001L6.92031 21.924C6.15767 22.221 5.35203 21.6091 5.38663 20.7591L5.59903 15.5402C5.61065 15.2547 5.52351 14.9743 5.35355 14.7505L2.24721 10.6588C1.74128 9.99236 2.049 9.00233 2.83303 8.77406L7.6468 7.37249C7.91017 7.2958 8.1383 7.12253 8.28945 6.88439L11.0521 2.5317Z" };
function s8(e, t) {
  return a(), c("path", i8);
}
const c8 = /* @__PURE__ */ u(a8, [["render", s8]]), u8 = {};
function f8(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: `M20.0029 22.0037H5.99708C4.89205 22.0037 3.99625 21.1079 3.99625
       20.0029V10.9992C3.99625 9.89413 4.89205 8.99833 5.99708
       8.99833H20.0029C21.1079 8.99833 22.0037 9.89413 22.0037
       10.9992V20.0029C22.0037 21.1079 21.1079 22.0037 20.0029 22.0037Z`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: `M17.0017 22.0037V6.9975C17.0017 5.89247 16.1059 4.99667 15.0008
       4.99667H10.9992C9.89413 4.99667 8.99832 5.89247 8.99832 6.9975V22.0037`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const p8 = /* @__PURE__ */ u(u8, [["render", f8]]), $8 = {};
function C8(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M13.4577 10.5414L11.0797 12.9194",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: `M13.4197 6.78967V10.5793H17.2094L20.999 6.78967L18.4723 5.52676L17.2094
        3L13.4197 6.78967Z`,
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: `M10.5775 4.87115C6.25579 5.13641 2.9131 8.76425 3.00172 13.0932C3.09035
        17.4222 6.57872 20.9102 10.9077 20.9983C15.2367 21.0864 18.8641 17.7434 19.1289 13.4216`,
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: `M15.5135 13.4216C15.2588 15.7542 13.2461 17.4943 10.9012 17.4092C8.55621
        17.3242 6.67488 15.4428 6.58983 13.0979C6.50477 10.7529 8.24485 8.74026 10.5775 8.48553`,
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const _8 = /* @__PURE__ */ u($8, [["render", C8]]), g8 = {};
function y8(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M17.3 19.8c.3.2.6.3 1 .1.3 0 .5-.3.5-.6L22 4.8c0-.3 0-.5-.2-.6A.7.7 0 0 0 21 4L2.5 10.7c-.3.1-.5.4-.5.7 0 .2.2.5.5.6L7 13.3l1.8 5.3c0 .2.3.4.5.5.2 0 .5 0 .7-.2l2.6-2.3 4.6 3.2Zm-9.2-7 1.4 4.5.4-2.8 8.4-7.3v-.3c0-.1-.1-.2-.2-.1l-10 6Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const m8 = /* @__PURE__ */ u(g8, [["render", y8]]), h8 = {};
function v8(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M19.7 5.5c.2.1.2.4 0 .5L11 18.6c-.1.2-.4.2-.6 0l-5-5.5a.4.4 0 0 1 0-.5l1.3-1.2h.6l3.2 3.6 7.3-10.4c.2-.2.4-.2.6 0l1.4.9Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const b8 = /* @__PURE__ */ u(h8, [["render", v8]]), I8 = {};
function M8(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0ZM16.1011 8.88492C16.2573 8.72871 16.2573 8.47545 16.1011 8.31924L14.899 7.11716C14.7428 6.96095 14.4895 6.96095 14.3333 7.11716L9.50006 11.9504L7.66679 10.1172C7.51058 9.96095 7.25731 9.96095 7.1011 10.1172L5.89902 11.3192C5.74281 11.4754 5.74281 11.7287 5.89902 11.8849L9.21722 15.2031C9.37343 15.3593 9.62669 15.3593 9.7829 15.2031L16.1011 8.88492Z"
    }, null, -1)
  ]));
}
const k8 = /* @__PURE__ */ u(I8, [["render", M8]]), x8 = {};
function N8(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0ZM9.15 6C8.92909 6 8.75 6.17909 8.75 6.4V12.85C8.75 13.0709 8.92909 13.25 9.15 13.25H14.6C14.8209 13.25 15 13.0709 15 12.85V11.15C15 10.9291 14.8209 10.75 14.6 10.75H11.25V6.4C11.25 6.17909 11.0709 6 10.85 6H9.15Z"
    }, null, -1)
  ]));
}
const S8 = /* @__PURE__ */ u(x8, [["render", N8]]), L8 = {};
function A8(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "stroke-width": "1.5",
      d: "M16 12.1h-4.6"
    }, null, -1),
    o("circle", {
      cx: "12",
      cy: "11.5",
      r: "9",
      "stroke-width": "1.5"
    }, null, -1),
    o("path", {
      "stroke-width": "1.5",
      d: "M11.4 12.1V6.5"
    }, null, -1)
  ]));
}
const w8 = /* @__PURE__ */ u(L8, [["render", A8]]), O8 = {};
function T8(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      d: "M3 5.5H6.07",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: `M10.3238 3.73223C11.3001 4.70854 11.3001 6.29145 10.3238 7.26776C9.34748
       8.24407 7.76457 8.24407 6.78826 7.26776C5.81195 6.29145 5.81195 4.70854
       6.78826 3.73223C7.76457 2.75592 9.34748 2.75592 10.3238 3.73223`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M11.06 5.5H21",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: `M10.3238 3.73223C11.3001 4.70854 11.3001 6.29145 10.3238 7.26776C9.34748
       8.24407 7.76457 8.24407 6.78826 7.26776C5.81195 6.29145 5.81195 4.70854
       6.78826 3.73223C7.76457 2.75592 9.34748 2.75592 10.3238 3.73223`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M21 12H17.94",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M12.94 12H3",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: `M17.2118 10.2322C18.1881 11.2085 18.1881 12.7914 17.2118 13.7677C16.2355
       14.744 14.6526 14.744 13.6763 13.7677C12.7 12.7914 12.7 11.2085 13.6763
       10.2322C14.6526 9.25589 16.2355 9.25589 17.2118 10.2322`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M11.06 18.5H21",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: "M3 18.5H6.06",
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    o("path", {
      d: `M10.3238 16.7322C11.3001 17.7085 11.3001 19.2914 10.3238 20.2677C9.34748
       21.244 7.76457 21.244 6.78826 20.2677C5.81195 19.2914 5.81195 17.7085 6.78826
       16.7322C7.76457 15.7559 9.34748 15.7559 10.3238 16.7322`,
      stroke: "currentColor",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const D8 = /* @__PURE__ */ u(O8, [["render", T8]]), E8 = {}, V8 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function j8(e, t) {
  return a(), c("svg", V8, t[0] || (t[0] = [
    k1('<path fill-rule="evenodd" clip-rule="evenodd" d="M4.3999 3.4C4.3999 3.17909 4.57899 3 4.7999 3H5.9999C6.22082 3 6.3999 3.17909 6.3999 3.4V5.45V7.5H4.3999V3.4ZM4.3999 15V19.6C4.3999 19.8209 4.57899 20 4.7999 20H5.9999C6.22082 20 6.3999 19.8209 6.3999 19.6V15H4.3999Z" fill="#56351D"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M11.4 5.4C11.4 5.17909 11.5791 5 11.8 5H13C13.2209 5 13.4 5.17909 13.4 5.4V11H11.4V5.4ZM11.4 19V21.6C11.4 21.8209 11.5791 22 11.8 22H13C13.2209 22 13.4 21.8209 13.4 21.6V19H11.4Z" fill="#56351D"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.2999 2.4C18.2999 2.17909 18.479 2 18.6999 2H19.8999C20.1208 2 20.2999 2.17909 20.2999 2.4V6H18.2999V2.4ZM18.2999 16V19.6C18.2999 19.8209 18.479 20 18.6999 20H19.8999C20.1208 20 20.2999 19.8209 20.2999 19.6V16H18.2999Z" fill="#56351D"></path><path d="M11.4001 11H10.4001C10.1792 11 10.0001 11.1791 10.0001 11.4V18.6C10.0001 18.8209 10.1792 19 10.4001 19H11.4001H13.4001H14.4C14.6209 19 14.8 18.8209 14.8 18.6V11.4C14.8 11.1791 14.6209 11 14.4 11H13.4001H11.4001Z" fill="url(#paint0_linear_1623_437)"></path><path d="M18.3 6H17.3C17.0791 6 16.9 6.17909 16.9 6.4V15.6C16.9 15.8209 17.0791 16 17.3 16H18.3H20.3C21.0732 16 21.6999 15.3733 21.6999 14.6002V6.4C21.6999 6.17909 21.5208 6 21.2999 6H20.3H18.3Z" fill="url(#paint1_linear_1623_437)"></path><path d="M4.40005 7.5C3.62685 7.5 3.00005 8.1268 3.00005 8.9L3 14.6C3 14.8209 3.17909 15 3.4 15H4.40005H6.40005H7.3999C7.62082 15 7.7999 14.8209 7.7999 14.6V7.9C7.7999 7.67909 7.62082 7.5 7.3999 7.5H6.40005H4.40005Z" fill="url(#paint2_linear_1623_437)"></path><defs><linearGradient id="paint0_linear_1623_437" x1="21.6999" y1="6.13542" x2="9.51418" y2="23.664" gradientUnits="userSpaceOnUse"><stop stop-color="#E1A329"></stop><stop offset="1" stop-color="#BB8B10"></stop></linearGradient><linearGradient id="paint1_linear_1623_437" x1="21.6999" y1="6.13542" x2="9.51418" y2="23.664" gradientUnits="userSpaceOnUse"><stop stop-color="#E1A329"></stop><stop offset="1" stop-color="#BB8B10"></stop></linearGradient><linearGradient id="paint2_linear_1623_437" x1="21.6999" y1="6.13542" x2="9.51418" y2="23.664" gradientUnits="userSpaceOnUse"><stop stop-color="#E1A329"></stop><stop offset="1" stop-color="#BB8B10"></stop></linearGradient></defs>', 7)
  ]));
}
const P8 = /* @__PURE__ */ u(E8, [["render", j8]]), H8 = {}, R8 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function B8(e, t) {
  return a(), c("svg", R8, t[0] || (t[0] = [
    k1('<path fill-rule="evenodd" clip-rule="evenodd" d="M4.3999 3.4C4.3999 3.17909 4.57899 3 4.7999 3H5.9999C6.22082 3 6.3999 3.17909 6.3999 3.4V5.45V7.5H4.3999V3.4ZM4.3999 15V19.6C4.3999 19.8209 4.57899 20 4.7999 20H5.9999C6.22082 20 6.3999 19.8209 6.3999 19.6V15H4.3999Z" fill="#A0B0C0"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M11.4 5.4C11.4 5.17909 11.5791 5 11.8 5H13C13.2209 5 13.4 5.17909 13.4 5.4V11H11.4V5.4ZM11.4 19V21.6C11.4 21.8209 11.5791 22 11.8 22H13C13.2209 22 13.4 21.8209 13.4 21.6V19H11.4Z" fill="#A0B0C0"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.2999 2.4C18.2999 2.17909 18.479 2 18.6999 2H19.8999C20.1208 2 20.2999 2.17909 20.2999 2.4V6H18.2999V2.4ZM18.2999 16V19.6C18.2999 19.8209 18.479 20 18.6999 20H19.8999C20.1208 20 20.2999 19.8209 20.2999 19.6V16H18.2999Z" fill="#A0B0C0"></path><path d="M11.4 11H10.4C10.179 11 9.99995 11.1791 9.99995 11.4V18.6C9.99995 18.8209 10.179 19 10.4 19H11.4H13.4H14.3999C14.6208 19 14.7999 18.8209 14.7999 18.6V11.4C14.7999 11.1791 14.6208 11 14.3999 11H13.4H11.4Z" fill="#454D54"></path><path d="M18.2999 6H17.2999C17.079 6 16.8999 6.17909 16.8999 6.4V15.6C16.8999 15.8209 17.079 16 17.2999 16H18.2999H20.2999C21.073 16 21.6998 15.3733 21.6998 14.6002V6.4C21.6998 6.17909 21.5207 6 21.2998 6H20.2999H18.2999Z" fill="#454D54"></path><path d="M4.39993 7.5C3.62673 7.5 2.99993 8.1268 2.99992 8.9L2.99988 14.6C2.99988 14.8209 3.17896 15 3.39988 15H4.39993H6.39993H7.39978C7.62069 15 7.79978 14.8209 7.79978 14.6V7.9C7.79978 7.67909 7.62069 7.5 7.39978 7.5H6.39993H4.39993Z" fill="#454D54"></path>', 6)
  ]));
}
const z8 = /* @__PURE__ */ u(H8, [["render", B8]]), F8 = {};
function U8(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.39841 15.6006C1.2422 15.7568 1.2422 16.0101 1.39841 16.1663L6.7166 21.4845C6.87281 21.6407 7.12608 21.6407 7.28229 21.4845L12.6005 16.1663C12.7567 16.0101 12.7567 15.7568 12.6005 15.6006L11.3984 14.3985C11.2422 14.2423 10.9889 14.2423 10.8327 14.3985L8.24945 16.9818L8.24945 4.39954C8.24945 4.17863 8.07036 3.99954 7.84945 3.99954L6.14945 3.99954C5.92853 3.99954 5.74945 4.17863 5.74945 4.39954L5.74945 16.9818L3.16617 14.3985C3.00996 14.2423 2.7567 14.2423 2.60049 14.3985L1.39841 15.6006Z",
      fill: "url(#paint0_linear_2877_862)"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.3984 8.3985C11.2422 8.24229 11.2422 7.98903 11.3984 7.83282L16.7166 2.51462C16.8728 2.35841 17.1261 2.35841 17.2823 2.51462L22.6005 7.83282C22.7567 7.98903 22.7567 8.24229 22.6005 8.3985L21.3984 9.60058C21.2422 9.75679 20.9889 9.75679 20.8327 9.60058L18.2494 7.01731V19.5995C18.2494 19.8205 18.0704 19.9995 17.8494 19.9995H16.1494C15.9285 19.9995 15.7494 19.8205 15.7494 19.5995V7.01731L13.1662 9.60058C13.01 9.75679 12.7567 9.75679 12.6005 9.60058L11.3984 8.3985Z",
      fill: "url(#paint1_linear_2877_862)"
    }, null, -1),
    o("defs", null, [
      o("linearGradient", {
        id: "paint0_linear_2877_862",
        x1: "22.7176",
        y1: "2.59751",
        x2: "3.62901",
        y2: "23.9049",
        gradientUnits: "userSpaceOnUse"
      }, [
        o("stop", { "stop-color": "#E1A329" }),
        o("stop", {
          offset: "1",
          "stop-color": "#BB8B10"
        })
      ]),
      o("linearGradient", {
        id: "paint1_linear_2877_862",
        x1: "22.7176",
        y1: "2.59751",
        x2: "3.62901",
        y2: "23.9049",
        gradientUnits: "userSpaceOnUse"
      }, [
        o("stop", { "stop-color": "#E1A329" }),
        o("stop", {
          offset: "1",
          "stop-color": "#BB8B10"
        })
      ])
    ], -1)
  ]));
}
const Z8 = /* @__PURE__ */ u(F8, [["render", U8]]), G8 = {};
function Y8(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.39841 15.6006C1.2422 15.7568 1.2422 16.0101 1.39841 16.1663L6.7166 21.4845C6.87281 21.6407 7.12608 21.6407 7.28229 21.4845L12.6005 16.1663C12.7567 16.0101 12.7567 15.7568 12.6005 15.6006L11.3984 14.3985C11.2422 14.2423 10.9889 14.2423 10.8327 14.3985L8.24945 16.9818L8.24945 4.39954C8.24945 4.17863 8.07036 3.99954 7.84945 3.99954L6.14945 3.99954C5.92853 3.99954 5.74945 4.17863 5.74945 4.39954L5.74945 16.9818L3.16617 14.3985C3.00996 14.2423 2.7567 14.2423 2.60049 14.3985L1.39841 15.6006Z"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.3984 8.3985C11.2422 8.24229 11.2422 7.98903 11.3984 7.83282L16.7166 2.51462C16.8728 2.35841 17.1261 2.35841 17.2823 2.51462L22.6005 7.83282C22.7567 7.98903 22.7567 8.24229 22.6005 8.3985L21.3984 9.60058C21.2422 9.75679 20.9889 9.75679 20.8327 9.60058L18.2494 7.01731V19.5995C18.2494 19.8205 18.0704 19.9995 17.8494 19.9995H16.1494C15.9285 19.9995 15.7494 19.8205 15.7494 19.5995V7.01731L13.1662 9.60058C13.01 9.75679 12.7567 9.75679 12.6005 9.60058L11.3984 8.3985Z"
    }, null, -1)
  ]));
}
const W8 = /* @__PURE__ */ u(G8, [["render", Y8]]), Q8 = {}, K8 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function X8(e, t) {
  return a(), c("svg", K8, t[0] || (t[0] = [
    k1('<path fill-rule="evenodd" clip-rule="evenodd" d="M15 21C17.2091 21 19 19.2091 19 17V3.4C19 3.17909 18.8209 3 18.6 3H5.5C6.32843 3 7 3.67157 7 4.5V11V20.6C7 20.8209 7.17909 21 7.4 21H15ZM16.1 9.5H9.9C9.67909 9.5 9.5 9.32091 9.5 9.1V7.9C9.5 7.67909 9.67909 7.5 9.9 7.5H16.1C16.3209 7.5 16.5 7.67909 16.5 7.9V9.1C16.5 9.32091 16.3209 9.5 16.1 9.5ZM9.9 11H16.1C16.3209 11 16.5 11.1791 16.5 11.4V12.6C16.5 12.8209 16.3209 13 16.1 13H9.9C9.67909 13 9.5 12.8209 9.5 12.6V11.4C9.5 11.1791 9.67909 11 9.9 11ZM16.1 16.5H9.9C9.67909 16.5 9.5 16.3209 9.5 16.1V14.9C9.5 14.6791 9.67909 14.5 9.9 14.5H16.1C16.3209 14.5 16.5 14.6791 16.5 14.9V16.1C16.5 16.3209 16.3209 16.5 16.1 16.5Z" fill="url(#paint0_linear_1623_442)"></path><path d="M5.5 3C4.67157 3 4 3.67157 4 4.5L4.00001 8.00002C4.00002 9.65687 5.34316 11 7 11V4.5C7 3.67157 6.32843 3 5.5 3Z" fill="#56351D"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 9.1C16.5 9.32091 16.3209 9.5 16.1 9.5H9.9C9.67909 9.5 9.5 9.32091 9.5 9.1V7.9C9.5 7.67909 9.67909 7.5 9.9 7.5H16.1C16.3209 7.5 16.5 7.67909 16.5 7.9V9.1ZM9.5 11.4C9.5 11.1791 9.67909 11 9.9 11H16.1C16.3209 11 16.5 11.1791 16.5 11.4V12.6C16.5 12.8209 16.3209 13 16.1 13H9.9C9.67909 13 9.5 12.8209 9.5 12.6V11.4ZM16.5 16.1C16.5 16.3209 16.3209 16.5 16.1 16.5H9.9C9.67909 16.5 9.5 16.3209 9.5 16.1V14.9C9.5 14.6791 9.67909 14.5 9.9 14.5H16.1C16.3209 14.5 16.5 14.6791 16.5 14.9V16.1Z" fill="#F6F7F8"></path><defs><linearGradient id="paint0_linear_1623_442" x1="19" y1="3.1875" x2="1.72" y2="16.1475" gradientUnits="userSpaceOnUse"><stop stop-color="#E1A329"></stop><stop offset="1" stop-color="#BB8B10"></stop></linearGradient></defs>', 4)
  ]));
}
const q8 = /* @__PURE__ */ u(Q8, [["render", X8]]), J8 = {}, e6 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function t6(e, t) {
  return a(), c("svg", e6, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15 21C17.2091 21 19 19.2091 19 17V3.4C19 3.17909 18.8209 3 18.6 3H5.5C6.32843 3 7 3.67157 7 4.5V11V20.6C7 20.8209 7.17909 21 7.4 21H15ZM16.1 9.5H9.9C9.67909 9.5 9.5 9.32091 9.5 9.1V7.9C9.5 7.67909 9.67909 7.5 9.9 7.5H16.1C16.3209 7.5 16.5 7.67909 16.5 7.9V9.1C16.5 9.32091 16.3209 9.5 16.1 9.5ZM9.9 11H16.1C16.3209 11 16.5 11.1791 16.5 11.4V12.6C16.5 12.8209 16.3209 13 16.1 13H9.9C9.67909 13 9.5 12.8209 9.5 12.6V11.4C9.5 11.1791 9.67909 11 9.9 11ZM16.1 16.5H9.9C9.67909 16.5 9.5 16.3209 9.5 16.1V14.9C9.5 14.6791 9.67909 14.5 9.9 14.5H16.1C16.3209 14.5 16.5 14.6791 16.5 14.9V16.1C16.5 16.3209 16.3209 16.5 16.1 16.5Z",
      fill: "#454D54"
    }, null, -1),
    o("path", {
      d: "M5.5 3C4.67157 3 4 3.67157 4 4.5L4.00001 8.00002C4.00002 9.65687 5.34316 11 7 11V4.5C7 3.67157 6.32843 3 5.5 3Z",
      fill: "#A0B0C0"
    }, null, -1),
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.5 9.1C16.5 9.32091 16.3209 9.5 16.1 9.5H9.9C9.67909 9.5 9.5 9.32091 9.5 9.1V7.9C9.5 7.67909 9.67909 7.5 9.9 7.5H16.1C16.3209 7.5 16.5 7.67909 16.5 7.9V9.1ZM9.5 11.4C9.5 11.1791 9.67909 11 9.9 11H16.1C16.3209 11 16.5 11.1791 16.5 11.4V12.6C16.5 12.8209 16.3209 13 16.1 13H9.9C9.67909 13 9.5 12.8209 9.5 12.6V11.4ZM16.5 16.1C16.5 16.3209 16.3209 16.5 16.1 16.5H9.9C9.67909 16.5 9.5 16.3209 9.5 16.1V14.9C9.5 14.6791 9.67909 14.5 9.9 14.5H16.1C16.3209 14.5 16.5 14.6791 16.5 14.9V16.1Z",
      fill: "#F6F7F8"
    }, null, -1)
  ]));
}
const n6 = /* @__PURE__ */ u(J8, [["render", t6]]), r6 = {}, o6 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function d6(e, t) {
  return a(), c("svg", o6, t[0] || (t[0] = [
    k1('<path d="M14.5723 11.874H9.42771V9.65497C9.42771 9.19776 8.91899 8.948 8.58391 9.2407L4.28314 12.9974L2.18511 14.8301C1.9383 15.0457 1.9383 15.443 2.18511 15.6586L8.58391 21.248C8.91899 21.5407 9.42771 21.2909 9.42771 20.8337V18.6147H14.5723C17.4136 18.6147 19.7169 16.2003 19.7169 13.2221V10.7505L15.4161 14.5073C15.081 14.8 14.5723 14.5502 14.5723 14.093V11.874Z" fill="#56351D"></path><path d="M9.42778 11.874H14.5724V14.093C14.5724 14.5502 15.0811 14.8 15.4162 14.5073L19.7169 10.7505L21.815 8.9179C22.0618 8.70231 22.0618 8.30495 21.815 8.08936L15.4162 2.5C15.0811 2.2073 14.5724 2.45706 14.5724 2.91426V5.13328H9.42778C6.58651 5.13328 4.2832 7.54761 4.2832 10.5258V12.9974L8.58397 9.24069C8.91905 8.948 9.42778 9.19776 9.42778 9.65496V11.874Z" fill="url(#paint0_linear_1623_428)"></path><defs><linearGradient id="paint0_linear_1623_428" x1="22.0001" y1="2.50168" x2="10.5274" y2="19.0817" gradientUnits="userSpaceOnUse"><stop stop-color="#E1A329"></stop><stop offset="1" stop-color="#BB8B10"></stop></linearGradient></defs>', 3)
  ]));
}
const l6 = /* @__PURE__ */ u(r6, [["render", d6]]), a6 = {}, i6 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function s6(e, t) {
  return a(), c("svg", i6, t[0] || (t[0] = [
    o("path", {
      d: "M14.5723 11.874H9.42771V9.65497C9.42771 9.19776 8.91899 8.948 8.58391 9.2407L4.28314 12.9974L2.18511 14.8301C1.9383 15.0457 1.9383 15.443 2.18511 15.6586L8.58391 21.248C8.91899 21.5407 9.42771 21.2909 9.42771 20.8337V18.6147H14.5723C17.4136 18.6147 19.7169 16.2003 19.7169 13.2221V10.7505L15.4161 14.5073C15.081 14.8 14.5723 14.5502 14.5723 14.093V11.874Z",
      fill: "#A0B0C0"
    }, null, -1),
    o("path", {
      d: "M9.42766 11.874H14.5722V14.093C14.5722 14.5502 15.081 14.8 15.416 14.5073L19.7168 10.7505L21.8148 8.9179C22.0616 8.70231 22.0616 8.30495 21.8148 8.08936L15.416 2.5C15.081 2.2073 14.5722 2.45706 14.5722 2.91426V5.13328H9.42766C6.58638 5.13328 4.28308 7.54761 4.28308 10.5258V12.9974L8.58385 9.24069C8.91893 8.948 9.42766 9.19776 9.42766 9.65496V11.874Z",
      fill: "#454D54"
    }, null, -1)
  ]));
}
const c6 = /* @__PURE__ */ u(a6, [["render", s6]]), u6 = {};
function f6(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M15.8 4.9h4.4c.2 0 .4 0 .6.2l.2.5c0 .2 0 .3-.2.5l-.6.2h-.7l-1 13.6c0 1.2-1 2.1-2.2 2.1H7.7c-1.2 0-2.2-.9-2.3-2.1L4.5 6.3h-.8c-.1 0-.3 0-.5-.2a.7.7 0 0 1-.2-.5c0-.2 0-.4.2-.5.2-.2.4-.2.5-.2h4.5V3.8c0-.5.2-1 .6-1.3a2 2 0 0 1 1.3-.5H14c.5 0 1 .2 1.3.5.4.4.6.8.6 1.3v1ZM7.7 8.4c0-.2.2-.4.4-.4h1.2c.2 0 .4.2.4.4v9.2c0 .2-.2.4-.4.4h-1a.4.4 0 0 1-.3-.4l-.3-9.2Zm8.2 9.6c.2 0 .4-.2.4-.4l.4-9.2c0-.2-.2-.4-.4-.4H15c-.2 0-.4.2-.4.4v9.2c0 .2.2.4.4.4h.8ZM14.2 4.9H9.8V3.8a.3.3 0 0 1 0-.3.4.4 0 0 1 .3 0H14a.4.4 0 0 1 .2 0 .4.4 0 0 1 .2.3v1ZM12.8 18c.2 0 .4-.2.4-.4V8.4c0-.2-.2-.4-.4-.4h-1.2c-.2 0-.4.2-.4.4v9.2c0 .2.2.4.4.4h1.2Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const p6 = /* @__PURE__ */ u(u6, [["render", f6]]), $6 = {};
function C6(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("line", {
      x1: "4",
      y1: "21",
      x2: "4",
      y2: "14"
    }, null, -1),
    o("line", {
      x1: "4",
      y1: "10",
      x2: "4",
      y2: "3"
    }, null, -1),
    o("line", {
      x1: "12",
      y1: "21",
      x2: "12",
      y2: "12"
    }, null, -1),
    o("line", {
      x1: "12",
      y1: "8",
      x2: "12",
      y2: "3"
    }, null, -1),
    o("line", {
      x1: "20",
      y1: "21",
      x2: "20",
      y2: "16"
    }, null, -1),
    o("line", {
      x1: "20",
      y1: "12",
      x2: "20",
      y2: "3"
    }, null, -1),
    o("line", {
      x1: "1",
      y1: "14",
      x2: "7",
      y2: "14"
    }, null, -1),
    o("line", {
      x1: "9",
      y1: "8",
      x2: "15",
      y2: "8"
    }, null, -1),
    o("line", {
      x1: "17",
      y1: "16",
      x2: "23",
      y2: "16"
    }, null, -1)
  ]));
}
const _6 = /* @__PURE__ */ u($6, [["render", C6]]), g6 = {};
function y6(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.2386 2 7.00002 4.23858 7.00002 7C7.00002 9.76142 9.2386 12 12 12Z" }, null, -1),
    o("path", { d: "M20.0148 22C20.5589 22 21 21.5589 21 21.0149C21 20.9098 20.9887 20.7864 20.9681 20.6484C20.4941 17.4803 17.5316 15.3669 14.4217 14.5984C12.8312 14.2054 11.1688 14.2054 9.57827 14.5984C6.46841 15.3669 3.50586 17.4803 3.0319 20.6485C3.01125 20.7864 3 20.9098 3 21.0149C3 21.5589 3.44106 22 3.98514 22H20.0148Z" }, null, -1)
  ]));
}
const m6 = /* @__PURE__ */ u(g6, [["render", y6]]), h6 = {};
function v6(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("line", {
      x1: "12",
      y1: "20",
      x2: "12",
      y2: "10"
    }, null, -1),
    o("line", {
      x1: "18",
      y1: "20",
      x2: "18",
      y2: "4"
    }, null, -1),
    o("line", {
      x1: "6",
      y1: "20",
      x2: "6",
      y2: "16"
    }, null, -1)
  ]));
}
const b6 = /* @__PURE__ */ u(h6, [["render", v6]]), I6 = {};
function M6(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M12 2c-6.4 0-9 2.5-9 8.8 0 5 1.6 6.6 2.5 7.3 1 .6 1.6.9 1.9.9v2c0 1.3 1 1.1 1.3.7l1.8-2.1H12c6.4 0 9-2.5 9-8.8C21 4.5 18.4 2 12 2Zm4.2 8.8c0 .2.2.4.4.4h.7c.3 0 .4-.2.4-.4A7 7 0 0 0 11.4 4c-.2 0-.4.2-.4.4v.8c0 .2.2.4.4.4 2.6.2 4.6 2.4 4.8 5Zm-3.7 3c.3-.5.7-.6 1.1-.3l1.7 1.4c.3.3.2.8-.3 1.4-.5.5-1 .8-1.3.7a10 10 0 0 1-4.8-3A10.4 10.4 0 0 1 6 8.8c0-.6.4-1.2 1.2-1.7.4-.3.7-.2 1 .3L9.4 9c.2.4 0 .8-.3 1.1-1.9.8 2.4 5.6 3.4 3.5Zm1.1-2.6a.4.4 0 0 1-.4-.4c-.2-1-.9-1.8-1.8-2a.5.5 0 0 1-.4-.4v-.7c0-.3.2-.5.4-.4 1.7.2 3.1 1.6 3.3 3.5 0 .2-.1.4-.4.4h-.7Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const k6 = /* @__PURE__ */ u(I6, [["render", M6]]), x6 = {};
function N6(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M12 7.6c2.5 0 4.5 2 4.5 4.4l-.1 1 .1.5 2.3 2.3h.6c1-1 2-2.2 2.5-3.6v-.3A10.8 10.8 0 0 0 9.3 5.7c-.3 0-.3.4-.1.6l1.3 1.3c.1.1.2.2.4.1l1.1-.1ZM4.5 4.3a.4.4 0 0 0-.6 0l-.7.7c-.2.1-.1.4 0 .5l2.2 2.1A10.5 10.5 0 0 0 2 12v.3A10.8 10.8 0 0 0 15.9 18l2.9 2.7c.1.2.4.2.5 0l.7-.7c.2-.1.2-.4 0-.5L4.5 4.3ZM12 16.5c-2.5 0-4.5-2-4.5-4.5 0-.5 0-1 .2-1.4 0-.2.4-.3.6 0l.9.8v.6a2.7 2.7 0 0 0 3.1 2.7h.4l.8 1c.2.1.2.4 0 .5l-1.5.3Zm1.9-5.5c.3.2.6 0 .4-.3-.2-.4-.5-.7-1-1-.2-.1-.4.2-.2.5l.8.8Z" }, null, -1)
  ]));
}
const S6 = /* @__PURE__ */ u(x6, [["render", N6]]), L6 = {};
function A6(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M12 6a11 11 0 0 0-10 6.3v.4a11 11 0 0 0 20 0v-.4A10.8 10.8 0 0 0 12 6Zm0 10.8c-2.5 0-4.5-2-4.5-4.3 0-2.4 2-4.3 4.5-4.3s4.5 2 4.5 4.3c0 2.4-2 4.3-4.5 4.3Zm0-6.9a2.7 2.7 0 0 0-2.7 2.6c0 1.4 1.2 2.6 2.7 2.6 1.5 0 2.7-1.2 2.7-2.6 0-1.4-1.2-2.6-2.7-2.6Z" }, null, -1)
  ]));
}
const w6 = /* @__PURE__ */ u(L6, [["render", A6]]), O6 = {};
function T6(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0ZM10.15 13C9.92909 13 9.75 12.8209 9.75 12.6V4.4C9.75 4.17909 9.92909 4 10.15 4H11.85C12.0709 4 12.25 4.17909 12.25 4.4V12.6C12.25 12.8209 12.0709 13 11.85 13H10.15ZM11 17.4C11.8284 17.4 12.5 16.7284 12.5 15.9C12.5 15.0716 11.8284 14.4 11 14.4C10.1716 14.4 9.5 15.0716 9.5 15.9C9.5 16.7284 10.1716 17.4 11 17.4Z"
    }, null, -1)
  ]));
}
const D6 = /* @__PURE__ */ u(O6, [["render", T6]]), E6 = {};
function V6(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }, null, -1),
    o("line", {
      x1: "12",
      y1: "9",
      x2: "12",
      y2: "13"
    }, null, -1),
    o("line", {
      x1: "12",
      y1: "17",
      x2: "12.01",
      y2: "17"
    }, null, -1)
  ]));
}
const j6 = /* @__PURE__ */ u(E6, [["render", V6]]), P6 = {}, H6 = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.4359 3.41835C13.3569 1.52722 10.6431 1.52722 9.56411 3.41835L1.37408 17.7724C0.315948 19.6269 1.62024 22 3.80997 22H20.19C22.3798 22 23.6841 19.6269 22.6259 17.7724L14.4359 3.41835ZM10.8541 13.9091C10.8541 14.1099 11.0182 14.2727 11.2208 14.2727H12.7792C12.9818 14.2727 13.1459 14.1099 13.1459 13.9091V7.36364C13.1459 7.16281 12.9818 7 12.7792 7H11.2208C11.0182 7 10.8541 7.16281 10.8541 7.36364V13.9091ZM13.3751 17.4545C13.3751 18.2077 12.7595 18.8182 12 18.8182C11.2405 18.8182 10.6249 18.2077 10.6249 17.4545C10.6249 16.7014 11.2405 16.0909 12 16.0909C12.7595 16.0909 13.3751 16.7014 13.3751 17.4545Z"
};
function R6(e, t) {
  return a(), c("path", H6);
}
const B6 = /* @__PURE__ */ u(P6, [["render", R6]]), z6 = {};
function F6(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      d: "M12 20.8a9 9 0 0 0 6.4-15.2A9 9 0 0 0 4.3 16.4L3 20.7c0 .1 0 .3.2.2l4.5-1.1a9 9 0 0 0 4.2 1Zm3-4.6c.3 0 1.2-.6 1.4-1l.2-1.2-.4-.2a36 36 0 0 0-1.6-.7H14l-.7 1h-.7a5.8 5.8 0 0 1-2.9-2.6l.1-.5.3-.3.3-.4v-.5l-.3-.5-.4-1.1c-.2-.4-.3-.4-.5-.4h-.4c-.2 0-.4 0-.6.3-.3.3-.8.8-.8 1.8 0 1.1.8 2.2.9 2.3v.1c.3.4 1.7 2.5 3.8 3.3 1.7.7 2.2.6 2.6.6h.1Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const U6 = /* @__PURE__ */ u(z6, [["render", F6]]), Z6 = {}, G6 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Y6(e, t) {
  return a(), c("svg", G6, t[0] || (t[0] = [
    k1('<path d="M3 1.4C3 1.17909 3.17909 1 3.4 1H20.6C20.8209 1 21 1.17909 21 1.4V2.6C21 2.82091 20.8209 3 20.6 3H3.4C3.17909 3 3 2.82091 3 2.6V1.4Z" fill="#56351D"></path><path d="M10.7915 20.9091C9.4203 20.2288 8.5511 18.8171 8.5511 17.2706V11.4352H5.617C5.09488 11.4352 4.80966 10.9953 5.14391 10.7056L11.5269 4.16005C11.65 4.05335 11.825 4 12 4C12.175 4 12.35 4.05335 12.4731 4.16005L18.8561 10.7056C19.1903 10.9953 18.9051 11.4352 18.383 11.4352H15.4489L15.4972 22.5925C15.4985 22.8931 15.1877 23.0904 14.9212 22.9582L10.7915 20.9091Z" fill="url(#paint0_linear_1623_492)"></path><defs><linearGradient id="paint0_linear_1623_492" x1="19" y1="4.19792" x2="0.852783" y2="17.5696" gradientUnits="userSpaceOnUse"><stop stop-color="#E1A329"></stop><stop offset="1" stop-color="#BB8B10"></stop></linearGradient></defs>', 3)
  ]));
}
const W6 = /* @__PURE__ */ u(Z6, [["render", Y6]]), Q6 = {}, K6 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function X6(e, t) {
  return a(), c("svg", K6, t[0] || (t[0] = [
    o("path", {
      d: "M3 1.4C3 1.17909 3.17909 1 3.4 1H20.6C20.8209 1 21 1.17909 21 1.4V2.6C21 2.82091 20.8209 3 20.6 3H3.4C3.17909 3 3 2.82091 3 2.6V1.4Z",
      fill: "#A0B0C0"
    }, null, -1),
    o("path", {
      d: "M10.7915 20.9091C9.4203 20.2288 8.5511 18.8171 8.5511 17.2706V11.4352H5.617C5.09488 11.4352 4.80966 10.9953 5.14391 10.7056L11.5269 4.16005C11.65 4.05335 11.825 4 12 4C12.175 4 12.35 4.05335 12.4731 4.16005L18.8561 10.7056C19.1903 10.9953 18.9051 11.4352 18.383 11.4352H15.4489L15.4972 22.5925C15.4985 22.8931 15.1877 23.0904 14.9212 22.9582L10.7915 20.9091Z",
      fill: "#454D54"
    }, null, -1)
  ]));
}
const q6 = /* @__PURE__ */ u(Q6, [["render", X6]]), J6 = {};
function e7(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("rect", {
      x: "2",
      y: "7",
      width: "20",
      height: "14",
      rx: "2",
      ry: "2"
    }, null, -1),
    o("path", { d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" }, null, -1)
  ]));
}
const t7 = /* @__PURE__ */ u(J6, [["render", e7]]), n7 = {};
function r7(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", { d: "M23.5 5.8c-.3-1.1-1-2-2-2.3C19.4 3 12 3 12 3s-7.5 0-9.4.5a3 3 0 0 0-2 2.3 35.9 35.9 0 0 0 0 12.4 3 3 0 0 0 2 2.3c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5c1-.3 1.8-1.2 2.1-2.3a36.2 36.2 0 0 0 0-12.4Zm-13.9 10V8.2l6.3 4L9.6 16Z" }, null, -1)
  ]));
}
const o7 = /* @__PURE__ */ u(n7, [["render", r7]]), d7 = {}, l7 = {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 21.4434C17.5228 21.4434 22 17.0908 22 11.7217C22 11.5973 21.9976 11.4736 21.9928 11.3504C21.7921 6.1533 17.395 2 12 2C6.47715 2 2 6.35254 2 11.7217C2 13.6123 2.55516 15.3769 3.51565 16.8698L2.52352 20.4695C2.28301 21.342 3.07116 22.1556 3.98152 21.9745L8.95629 20.9848C9.67207 21.2069 10.4229 21.3528 11.1986 21.4126C11.463 21.433 11.7302 21.4434 12 21.4434ZM10.7113 13.8017V13.9372H12.6488V13.8017C12.6527 13.4333 12.7012 13.124 12.7943 12.8737C12.8913 12.62 13.0387 12.3994 13.2365 12.2117C13.4382 12.024 13.6961 11.8433 14.0103 11.6695C14.3672 11.4784 14.6756 11.2612 14.9355 11.0179C15.1954 10.7746 15.3951 10.4966 15.5348 10.1838C15.6783 9.87106 15.7501 9.51657 15.7501 9.12039C15.7501 8.53305 15.591 8.02565 15.2729 7.59819C14.9587 7.16725 14.5185 6.83535 13.9522 6.6025C13.3897 6.36966 12.738 6.25323 11.9972 6.25323C11.3183 6.25323 10.6977 6.36444 10.1352 6.58686C9.57667 6.80929 9.12671 7.14292 8.78536 7.58776C8.44789 8.03261 8.26946 8.58518 8.25006 9.2455H10.3214C10.3408 8.91882 10.43 8.64948 10.5891 8.43748C10.752 8.22201 10.9556 8.06215 11.2 7.95789C11.4483 7.85015 11.7101 7.79628 11.9855 7.79628C12.2842 7.79628 12.5538 7.85189 12.7943 7.9631C13.0387 8.07431 13.2326 8.2307 13.3761 8.43227C13.5196 8.63384 13.5914 8.8719 13.5914 9.14645C13.5914 9.38972 13.5371 9.61041 13.4285 9.8085C13.3199 10.0031 13.1705 10.1804 12.9805 10.3402C12.7943 10.4966 12.5829 10.6408 12.3463 10.7729C12.001 10.9641 11.7082 11.1743 11.4677 11.4037C11.2272 11.6296 11.041 11.9285 10.9091 12.3003C10.7811 12.6722 10.7151 13.1726 10.7113 13.8017ZM10.8218 16.8565C11.074 17.0789 11.3746 17.1901 11.7237 17.1901C11.9564 17.1901 12.1678 17.1397 12.3579 17.0389C12.5518 16.9347 12.707 16.7957 12.8234 16.6219C12.9436 16.4481 13.0037 16.2553 13.0037 16.0433C13.0037 15.7305 12.8757 15.4629 12.6197 15.2405C12.3676 15.018 12.0689 14.9068 11.7237 14.9068C11.3746 14.9068 11.074 15.018 10.8218 15.2405C10.5697 15.4629 10.4436 15.7305 10.4436 16.0433C10.4436 16.363 10.5697 16.6341 10.8218 16.8565Z"
};
function a7(e, t) {
  return a(), c("path", l7);
}
const i7 = /* @__PURE__ */ u(d7, [["render", a7]]), s7 = {};
function c7(e, t) {
  return a(), c("g", null, t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.17102 2C6.02489 2 4.28516 3.73973 4.28516 5.8856C4.28516 8.03147 6.02489 9.77147 8.17076 9.77147C10.3166 9.77147 12.0564 8.03173 12.0564 5.8856C12.0564 3.73947 10.3169 2 8.17102 2ZM10.4645 11.5002C8.94533 11.2578 7.39733 11.2578 5.8784 11.5002L5.71547 11.526C3.57493 11.8676 2 13.714 2 15.8815C2 17.0514 2.94853 17.9999 4.1184 17.9999H12.2245C13.3944 17.9999 14.3429 17.0514 14.3429 15.8815C14.3429 13.714 12.768 11.8676 10.6275 11.526L10.4645 11.5002ZM16.1717 8.17193C16.1717 7.79326 15.8645 7.48633 15.4858 7.48633C15.1071 7.48633 14.8002 7.79326 14.8002 8.17193V9.31486H13.6573C13.2786 9.31486 12.9717 9.62179 12.9717 10.0005C12.9717 10.3791 13.2786 10.6861 13.6573 10.6861H14.8002V11.829C14.8002 12.2079 15.1069 12.5149 15.4858 12.5149C15.8647 12.5149 16.1717 12.2077 16.1717 11.829V10.6861H17.3146C17.6933 10.6861 18.0002 10.3791 18.0002 10.0005C18.0002 9.62179 17.6933 9.31486 17.3146 9.31486H16.1717V8.17193Z"
    }, null, -1)
  ]));
}
const u7 = /* @__PURE__ */ u(s7, [["render", c7]]), f7 = {}, p7 = { viewBox: "0 0 42 42" };
function $7(e, t) {
  return a(), c("svg", p7, t[0] || (t[0] = [
    k1('<path d="M21 41C32.0457 41 41 32.0457 41 21C41 9.95431 32.0457 1 21 1C9.95431 1 1 9.95431 1 21C1 32.0457 9.95431 41 21 41Z" fill="url(#paint0_linear_1_17)" stroke="url(#paint1_linear_1_17)" stroke-width="0.2"></path><g filter="url(#filter0_i_1_17)"><path d="M21 6C12.7149 6 6 12.7149 6 21C6 29.2851 12.7149 36 21 36C29.2851 36 36 29.2851 36 21C36 17.0218 34.4196 13.2064 31.6066 10.3934C28.7936 7.58035 24.9782 6 21 6ZM21 32.2596C18.0138 32.2596 15.1499 31.0733 13.0383 28.9617C10.9267 26.8501 9.74043 23.9862 9.74043 21C9.74043 18.0138 10.9267 15.1499 13.0383 13.0383C15.1499 10.9267 18.0138 9.74043 21 9.74043C23.9862 9.74043 26.8501 10.9267 28.9617 13.0383C31.0733 15.1499 32.2596 18.0138 32.2596 21C32.2596 23.9862 31.0733 26.8501 28.9617 28.9617C26.8501 31.0733 23.9862 32.2596 21 32.2596ZM16.7526 20.199C16.3417 20.6635 16.3421 21.3616 16.7535 21.8257L20.0924 25.5917C20.5814 26.1433 21.4429 26.1422 21.9304 25.5894L25.2522 21.8234C25.6609 21.36 25.6613 20.6651 25.2532 20.2014L21.9313 16.4268C21.4437 15.8726 20.5806 15.8715 20.0915 16.4244L16.7526 20.199Z" fill="url(#paint2_linear_1_17)"></path></g><defs><filter id="filter0_i_1_17" x="6" y="6" width="30" height="34" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="4"></feOffset><feGaussianBlur stdDeviation="2"></feGaussianBlur><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend mode="normal" in2="shape" result="effect1_innerShadow_1_17"></feBlend></filter><linearGradient id="paint0_linear_1_17" x1="1" y1="1" x2="13.6039" y2="53.283" gradientUnits="userSpaceOnUse"><stop stop-color="#F2EACD"></stop><stop offset="1" stop-color="#B8A76F"></stop></linearGradient><linearGradient id="paint1_linear_1_17" x1="1" y1="1" x2="41" y2="41" gradientUnits="userSpaceOnUse"><stop stop-color="white"></stop><stop offset="1" stop-color="white" stop-opacity="0.3"></stop></linearGradient><linearGradient id="paint2_linear_1_17" x1="6" y1="6" x2="36" y2="34.5" gradientUnits="userSpaceOnUse"><stop stop-color="#D09C73"></stop><stop offset="1" stop-color="#AA8C5F"></stop></linearGradient></defs>', 3)
  ]));
}
const C7 = /* @__PURE__ */ u(f7, [["render", $7]]), Wt = {
  IconAccountMultipleOutline: Ia,
  IconArrowBigDown: Na,
  IconArrowBigLeft: wa,
  IconArrowBigRight: Ea,
  IconArrowBigUp: Ha,
  IconArrowDown: za,
  IconArrowLeft: Za,
  IconArrowRight: Wa,
  IconArrowSmallDown: Xa,
  IconArrowSmallUp: ei,
  IconArrowTopRight: ri,
  IconArrowUp: li,
  IconBank: si,
  IconBlock: fi,
  IconBusinessChart: Ci,
  IconCall: yi,
  IconCardIn: vi,
  IconChartBoxOutline: Mi,
  IconCheckCircleFill: Si,
  IconCheckCircle: wi,
  IconCheck: Ei,
  IconCheckboxChecked: Hi,
  IconCheckboxIndeterminate: Fi,
  IconChevronDown: Yi,
  IconChevronLeft: Xi,
  IconChevronRight: t9,
  IconChevronUp: d9,
  IconCloseCircleOutline: i9,
  IconClose: u9,
  IconContentCopy: $9,
  IconCopy: g9,
  IconCoupon: h9,
  IconCreditCardPerigon: I9,
  IconCreditCardWithdraw: x9,
  IconDelimiterSlider: A9,
  IconDepositGold: D9,
  IconDeposit: P9,
  IconDiscount: B9,
  IconDocument: U9,
  IconDollarGold: Y9,
  IconDollarPaymentsConversion: K9,
  IconDollar: J9,
  IconDownload: n3,
  IconEditGold: d3,
  IconEdit: i3,
  IconEducation: u3,
  IconEmail: C3,
  IconErrorOutline: y3,
  IconEssentialCopy: v3,
  IconExit: M3,
  IconEyeOff: N3,
  IconEye: A3,
  IconFacebook: T3,
  IconFileOutline: V3,
  IconFile: H3,
  IconGiftBox: z3,
  IconGiftSolid: Z3,
  IconGrid: W3,
  IconGroup: X3,
  IconHandshakeOutline: e4,
  IconHelpCircle: r4,
  IconHome: l4,
  IconHouseGold: s4,
  IconHouse: p4,
  IconInfoOutline: _4,
  IconInfoSolid: m4,
  IconInstagram: b4,
  IconInvoiceDollar: k4,
  IconLanguage: S4,
  IconLetter: w4,
  IconLightning: D4,
  IconLinkOut: j4,
  IconLinkShare: R4,
  IconLinkedin: F4,
  IconListBulleted: G4,
  IconLogout: Q4,
  IconMagnify: q4,
  IconMessagesChat: t5,
  IconMinusCircle: o5,
  IconMinus: i5,
  IconMoneyWalletSolid: u5,
  IconMoneyWallet: $5,
  IconMove: g5,
  IconOpenInNew: h5,
  IconPasswordKey: I5,
  IconPassword: x5,
  IconPauseCircle: L5,
  IconPaymentMethod: O5,
  IconPercent: E5,
  IconPhoneCall: H5,
  IconPhone: F5,
  IconPlusCircle: G5,
  IconPlus: Q5,
  IconPortfolio: q5,
  IconProductsChart: ts,
  IconPulse: ds,
  IconQuestion: ss,
  IconRefresh: ps,
  IconRetry: gs,
  IconRewardCup: hs,
  IconRocket: Is,
  IconSearch: xs,
  IconSecurityLock: Ls,
  IconSettingsAltGold: Os,
  IconSettingsAlt: Es,
  IconSettings: Ps,
  IconShieldKeyhole: Bs,
  IconShieldLock: Us,
  IconShield: Ys,
  IconSingleUser: Ks,
  IconSquareChart: Js,
  IconSquareCheck: n8,
  IconSquare: l8,
  IconStar: c8,
  IconSuitcasePortfolio: p8,
  IconTargetGoal: _8,
  IconTelegram: m8,
  IconTickBig: b8,
  IconTickCircle: k8,
  IconTimeCircle: S8,
  IconTimeClock: w8,
  IconToolsSettings: D8,
  IconTradeGold: P8,
  IconTrade: z8,
  IconTradingGold: Z8,
  IconTrading: W8,
  IconTransactionGold: q8,
  IconTransaction: n6,
  IconTransferGold: l6,
  IconTransfer: c6,
  IconTrashcan: p6,
  IconTune: _6,
  IconUser: m6,
  IconVariant: b6,
  IconViber: k6,
  IconVisibilityOff: S6,
  IconVisibilityOn: w6,
  IconWarningCircle: D6,
  IconWarningOutline: j6,
  IconWarningTriangle: B6,
  IconWhatsapp: U6,
  IconWithdrawalGold: W6,
  IconWithdrawal: q6,
  IconWorkOutline: t7,
  IconYoutube: o7,
  IconChat2Desk: i7,
  IconUnion: u7,
  iconGoldMedal: C7
}, _7 = [
  "arrow-big-down",
  "arrow-big-left",
  "arrow-big-right",
  "arrow-big-up",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-small-down",
  "arrow-small-up",
  "arrow-up",
  "block",
  "call",
  "check-circle-fill",
  "close",
  "copy",
  "edit",
  "facebook",
  "instagram",
  "letter",
  "linkedin",
  "password",
  "plus",
  "plus-circle",
  "question",
  "shield",
  "telegram",
  "tick-big",
  "tick-circle",
  "time-circle",
  "trashcan",
  "viber",
  "visibility-off",
  "visibility-on",
  "warning-circle",
  "whatsapp",
  "youtube",
  "link-out",
  "phone",
  "warning-triangle",
  "exit",
  "language",
  "star",
  "user",
  "gift-solid",
  "house",
  "dollar",
  "settings-alt",
  "trading",
  "coupon",
  "retry",
  "download",
  "info-solid",
  "refresh",
  "lightning",
  "portfolio",
  "rocket",
  "education",
  "group",
  "handshake-icon-outline",
  "account-multiple-outline",
  "money-wallet-solid",
  "bank",
  "chat-2-desk",
  "union",
  "gold-medals"
], g7 = {
  name: "icon-base",
  components: Wt,
  props: {
    name: {
      type: String,
      required: !0
    }
  },
  computed: {
    iconCmpName() {
      return `icon-${this.name}`;
    },
    isNewIcon() {
      return _7.includes(this.name);
    },
    fillValue() {
      return this.isNewIcon ? "currentColor" : "none";
    },
    strokeValue() {
      return this.isNewIcon ? "none" : "currentColor";
    },
    strokeWidthValue() {
      return this.isNewIcon ? "0" : "2";
    }
  }
}, y7 = ["fill", "stroke", "stroke-width"];
function m7(e, t, n, r, l, d) {
  return a(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: d.fillValue,
    stroke: d.strokeValue,
    "stroke-width": d.strokeWidthValue,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    (a(), k(on(d.iconCmpName)))
  ], 8, y7);
}
const h7 = /* @__PURE__ */ u(g7, [["render", m7]]), oc = n1.reduce((e, t) => {
  const n = t.charAt(0).toUpperCase(), r = t.slice(1).replace(/-(.)/g, (l, d) => d.toUpperCase());
  return e[t] = Wt[`Icon${n + r}`], e;
}, {}), dc = {
  component: ({ tag: e, icon: t, ...n }) => xe(
    h7,
    { tag: "svg", name: t, ...n }
  )
}, v7 = {
  MAIN: "main"
}, y1 = {
  [C.PRIMARY]: {
    "primary-100": "#a6410e",
    "primary-90": "#c85014",
    "primary-80": "#df5916",
    primary: "#f06e2d",
    "primary-70": "#f06e2d",
    "primary-60": "#eb7e47",
    "primary-50": "#f68851",
    "primary-40": "#fae8db",
    "primary-30": "#fcf1e9"
  },
  [C.GRAY]: {
    "gray-100": "#454d54",
    "gray-90": "#698096",
    gray: "#8599ad",
    "gray-80": "#8599ad",
    "gray-70": "#a0b0c0",
    "gray-60": "#b2bfcc",
    "gray-50": "#c2ccd6",
    "gray-40": "#d4dbe2",
    "gray-30": "#e3e8ed",
    "gray-20": "#e7ebef",
    "gray-10": "#f6f7f8"
  },
  [C.BLACK]: {
    black: "#030d17"
  },
  [C.LINK]: {
    "link-100": "#264d73",
    "link-90": "#0b6bcb",
    link: "#3379db",
    "link-80": "#3379db",
    "link-70": "#5598f6",
    "link-60": "#68a4f7",
    "link-50": "#ddeafd",
    "link-40": "#e7f0fe",
    "link-30": "#f0f6ff"
  },
  [C.WARNING]: {
    "warning-100": "#894b0e",
    "warning-90": "#ce8c09",
    "warning-80": "#daa710",
    warning: "#f2a60d",
    "warning-70": "#f2a60d",
    "warning-60": "#e3c467",
    "warning-50": "#fbe8b2",
    "warning-40": "#fcf3d8",
    "warning-30": "#fffaeb"
  },
  [C.WHITE]: {
    white: "#fff"
  },
  [C.SUCCESS]: {
    "success-100": "#1f4730",
    "success-90": "#318f58",
    "success-80": "#309c5d",
    success: "#3dbe73",
    "success-70": "#3dbe73",
    "success-60": "#6fc593",
    "success-50": "#d7f9e5",
    "success-40": "#e9fcf1",
    "success-30": "#f0fff6"
  },
  [C.ERROR]: {
    "error-100": "#7a1f2e",
    "error-90": "#bd0f2c",
    "error-80": "#c02e46",
    error: "#d74860",
    "error-70": "#d74860",
    "error-60": "#e37d8e",
    "error-50": "#f5d6db",
    "error-40": "#f9e7ea",
    "error-30": "#fff7f8"
  }
}, lc = {
  [v7.MAIN]: {
    dark: !1,
    colors: {
      ...y1[C.GRAY],
      ...y1[C.PRIMARY],
      ...y1[C.BLACK],
      ...y1[C.WARNING],
      ...y1[C.LINK],
      ...y1[C.SUCCESS],
      ...y1[C.ERROR],
      ...y1[C.WHITE]
    }
  }
};
export {
  D7 as AppAlert,
  P7 as AppAutocomplete,
  ec as AppBadge,
  nc as AppBottomBar,
  S7 as AppButton,
  L7 as AppButtonClipboard,
  Se as AppButtonIcon,
  Dt as AppButtonText,
  x7 as AppCard,
  H7 as AppCheckbox,
  A7 as AppChip,
  w7 as AppChipAssist,
  c0 as AppChipTab,
  O7 as AppChipTabs,
  j0 as AppCol,
  j7 as AppContainer,
  N7 as AppCountdownTimer,
  m0 as AppDialog,
  T7 as AppDialogConfirm,
  mn as AppDivider,
  G as AppIcon,
  E7 as AppLinearStepper,
  J2 as AppLink,
  Cr as AppList,
  Ae as AppListItem,
  Q7 as AppLogo,
  X7 as AppMenuDropdown,
  V7 as AppNotificationTemplate,
  R7 as AppOtpInput,
  J7 as AppPhoneInput,
  F7 as AppPreloader,
  U7 as AppPreloading,
  xr as AppProgressLinear,
  z0 as AppRow,
  Z7 as AppSelect,
  tc as AppSimpleCard,
  q7 as AppSlider,
  Et as AppSpinner,
  le as AppSpinnerDot,
  B7 as AppSwitch,
  G7 as AppTableDisplay,
  Y7 as AppTableTabs,
  R as AppText,
  ir as AppTextField,
  z7 as AppTextarea,
  K7 as AppTipsList,
  Le as AppTitle,
  Tt as AppTooltip,
  W7 as AppTooltipIcon,
  oc as aliases,
  rc as getCssClassForLocale,
  dc as iconSvg,
  k7 as setHtmlAttributes,
  M7 as setTitle,
  lc as themes
};
//# sourceMappingURL=ui-kit-next.es.js.map
